{
  "copy.f10000000001": "Bu dosya kabul edilmiyor.",
  "copy.f10000000002": "HTML, SVG, XML ve diğer etkin dosyalar kabul edilmiyor.",
  "copy.f10000000003": "Dosya türü adıyla veya bildirilen biçimle eşleşmiyor.",
  "copy.f10000000004": "Bu arşiv güvenli olmayan veya aşırı genişleyen girdiler içeriyor.",
  "copy.f10000000005": "Dosya kötü amaçlı yazılım koruması tarafından reddedildi.",
  "copy.f10000000006": "Dosya taraması geçici olarak kullanılamıyor. Hiçbir şey kaydedilmedi.",
  "copy.f10000000007": "Dosya izin verilen yükleme boyutundan büyük.",
  "copy.f10000000008": "Bu yükleme için yeterli dosya alanı yok.",
  "copy.f10000000009": "Yüklenen bu dosya zaten başka bir kayda eklendi.",
  "copy.f1000000000a": "Temel dosya artık kullanılamıyor.",
  "copy.f1000000000b": "Yüklemenin süresi doldu. Yeniden başlatın.",
  "copy.f1000000000c": "Bu yükleme zaten devam ediyor.",
  "copy.f1000000000d": "Bu yükleme tamamlanmaya hazır değil.",
  "copy.f1000000000e": "İndirme bağlantısının süresi doldu veya bağlantı iptal edildi. Yenisini isteyin.",
  "copy.f1000000000f": "Dosya dayanıklı depolamaya kaydedilemedi.",
  "copy.f10000000010": "Dosya bütünlüğü doğrulanamadı.",
  "copy.f10000000011": "Gerekli dosya depolama arka ucu kullanılamıyor.",
  "copy.f10000000012": "Bu işlemden önce dosya referanslarının uzlaştırılması gerekiyor.",
  "copy.f10000000013": "Yedek bütünlüğü doğrulanamadı. Hiçbir veri değiştirilmedi.",
  "copy.f10000000014": "Yedek imzası geçersiz.",
  "copy.f10000000015": "Güvenli yedek imzalama yapılandırılmamış.",
  "copy.99ccda9ac024": "Kayıt",
  "copy.6e967a3e89bc": "Parola sıfırlama",
  "copy.790357450f9c": "Giriş",
  "copy.cb27cced5cc5": "Kişisel bilişsel çalışma alanı",
  "copy.ab0887752ff0": "Zihninde daha az yük, önünde daha net bir gün.",
  "copy.12b9d11566e3": "Exognitos düşüncelerini yakalar, işlerini bağlama yerleştirir ve doğru anda yeniden bulmana yardım eder. Karar yine senindir.",
  "copy.122913f4b005": "Bağlamı Koru",
  "copy.8a999cccc0af": "Projeler, notlar ve değerler birbirinden kopmadan birlikte yaşar.",
  "copy.8ce297e26be6": "Gününü Gör",
  "copy.c5fc01e89f91": "Kapasiteni, planını ve sıradaki anlamlı adımı tek yerde izle.",
  "copy.7534a646bfd1": "Yeniden Bul",
  "copy.1a357d80f548": "Geçmiş kararlarına ve öğrendiklerine aramayla hızla geri dön.",
  "copy.d874d8980561": "Puan, seri veya suçluluk yok. Yalnızca anlamlı ilerleme.",
  "copy.cac362bfa89e": "Verilerin hesabına özeldir ve dışa aktarılabilir.",
  "copy.96de1bf904a7": "Giriş yapılamadı.",
  "copy.1ded787a47a6": "Girişi Doğrula",
  "copy.d1ab13bcc5ff": "Tekrar Hoş Geldin",
  "copy.9124574ad28f": "Kimlik doğrulama uygulamandaki altı haneli kodu gir.",
  "copy.7cc5b030a950": "Kaldığın bağlama güvenli biçimde geri dön.",
  "copy.20ae94edf9f0": "Doğrulama kodu",
  "copy.cc75b9cda14d": "Kod {{value1}} saatine kadar geçerli.",
  "copy.e1081b69d80a": "E-posta",
  "copy.e3962ceb93e1": "Parola",
  "copy.3f3f476f7c53": "Parolamı Unuttum",
  "copy.a1125173b696": "Doğrula ve Gir",
  "copy.93f4dcc5424f": "Giriş Yap",
  "copy.bcab3b593715": "Farklı Hesapla Giriş Yap",
  "copy.957387f11f7c": "Hesabın yok mu?",
  "copy.f2c0c4779e9d": "Kayıt Ol",
  "copy.0ad7ff3fb585": "Hesap oluşturulamadı.",
  "copy.9776c3fa42f1": "Exognitos'a Başla",
  "copy.dda75ea742ce": "Verilerin yalnızca bu sunucuda kalır. Reklam, izleme veya üçüncü taraf analiz yok.",
  "copy.c5176ef33f7c": "Adın",
  "copy.fd278f35f29f": "İsteğe bağlı",
  "copy.ebba7f77a8d6": "En az 10 karakter.",
  "copy.b2d8a657f766": "Davet kodu",
  "copy.28799f27050c": "Sunucu davet kodu istiyorsa doldur.",
  "copy.58593661c0db": "Hesap Oluştur",
  "copy.8e90e87fd2e9": "Zaten hesabın var mı?",
  "copy.96028bee8845": "Parolanı Sıfırla",
  "copy.d98bd06d8787": "Bu adres kayıtlıysa bir sıfırlama bağlantısı gönderildi. Bağlantı iki saat geçerli.",
  "copy.bc8256446160": "E-posta gelmediyse adresi kontrol et ya da sunucunun e-posta ayarlarının yapılmış olduğundan emin ol.",
  "copy.3210a9a0a33b": "Girişe Dön",
  "copy.7e717af902c3": "Kayıtlı e-posta adresine bir bağlantı gönderelim.",
  "copy.b061b1a14741": "Bağlantı Gönder",
  "copy.600d46c29699": "Parola değiştirilemedi.",
  "copy.55013f334652": "Parolan Değişti",
  "copy.9ced4778c962": "Güvenlik için önceki API anahtarların iptal edildi. Yeni parolanla giriş yapabilirsin.",
  "copy.5498e19834c5": "Yeni Parola Belirle",
  "copy.7f51a9b76aae": "Yeni parola",
  "copy.b0e095a26762": "Parolayı Değiştir",
  "copy.3fac8e82ff3f": "Ayar bölümleri",
  "copy.3c39b8330eb6": "Hesap ve Güvenlik",
  "copy.31c258bfd0b8": "Gün ve Planlama",
  "copy.e1b0af0c144d": "Görünüm",
  "copy.9bbb369bcada": "Veri ve Yedek",
  "copy.dedf357e48bd": "Kontrol Odası",
  "copy.bbb1132f30f1": "Açık",
  "copy.0579c9d9e5ac": "Aydınlık ve düşük gölgeli çalışma yüzeyi.",
  "copy.4e52adc41240": "Lacivert",
  "copy.f9cc2f54b768": "Varsayılan mavi-siyah Exognitos görünümü.",
  "copy.b24a36089466": "Koyu",
  "copy.09e7ebefa6c7": "Nötr grafit ve düşük parlaklıklı yüzeyler.",
  "copy.17f8a4286226": "IANA biçiminde geçerli bir saat dilimi yaz. Örnek: Europe/Istanbul.",
  "copy.989b7310c07a": "Saat dilimi kaydedildi",
  "copy.575ace75f026": "Saat dilimi kaydedilemedi",
  "copy.35784c3627d6": "Gün",
  "copy.a8ca9f7e5126": "Boş zaman ve kapasite hesapları buradan çıkar.",
  "copy.a30bdb59f27f": "Uyku aralığını göster",
  "copy.31283aa6b6b8": "Planlama tercihi; tıbbi bir kayıt değil. Saat üzerinde gölgeli görünür.",
  "copy.8288a7742db5": "Yatma",
  "copy.9343e72ea78d": "Kalkma",
  "copy.9723d134bafa": "Günlük Kapasite",
  "copy.7630c0813cfd": "Günlük kapasite",
  "copy.36bd3aba5116": "Günün “hafif / dengeli / dolu” olarak nitelendiği eşik. Bir hedef değil, bir ölçek.",
  "copy.ff9d48576ade": "Hafta Başlangıcı",
  "copy.980bd89a0b6d": "Hafta başlangıcı",
  "copy.4e4f470ade3a": "Pazartesi",
  "copy.2bd6371ea1e4": "Pazar",
  "copy.59de31cc9f7f": "Saat dilimi",
  "copy.12bd4e2996d0": "“Bugün”ün ne olduğunu bu belirler. Örnek: Europe/Istanbul.",
  "copy.3e952ba1bc9c": "Açılış Çalışma Alanı",
  "copy.e12d3f164b76": "Açılış çalışma alanı",
  "copy.73da4635f33b": "Doğrudan bir kayda gitmediğinde Exognitos bu alanı açar. Varsayılan Planlayıcıdır.",
  "copy.d5df3708bc68": "Tema",
  "copy.8d9849ab4452": "Tema kaydediliyor…",
  "copy.8f73c6093926": "Tema kaydedildi.",
  "copy.676746c60973": "Tema kaydedilemedi; önceki seçim geri yüklendi.",
  "copy.2839a67ba293": "Seçim anında önizlenir ve hesabına kaydedilir.",
  "copy.6fcb1bcd9a09": "Tamamlanan görevleri listelerde göster",
  "copy.31d672524630": "Bildirim izni verilmedi",
  "copy.e81e9c7e11dd": "Uygulama içi bildirimler açık",
  "copy.62cbfe31871d": "Tarayıcı kapalıyken bildirim için sunucuda VAPID anahtarı gerekiyor.",
  "copy.4370c330aaab": "Push bildirimleri açıldı",
  "copy.fd900fd31815": "Push kurulamadı",
  "copy.854e2dcd5116": "Tarayıcı aboneliği oluşturulamadı. Bildirim iznini ve güvenli bağlantıyı kontrol et.",
  "copy.b6cd2a14a1fc": "Push bildirimleri kapatıldı",
  "copy.bd28db9d8f41": "Push aboneliği kaldırılamadı",
  "copy.07c8698663ba": "Tarayıcı aboneliği kaldırılamadı. Sayfayı yenileyip tekrar dene.",
  "copy.2b37aa840fe6": "Hatırlatıcılar",
  "copy.491e77e5ffe2": "Hatırlatıcı, plan bloğuna bağlı bir zamandır; nasıl ulaştığı ayrı bir konu. Uygulama açıkken her hatırlatıcı burada görünür. Tarayıcı kapalıyken de ulaşması için Web Push gerekir.",
  "copy.0b47d0881340": "Bildirimleri Yenile",
  "copy.a6fe95a912f2": "Bildirimlere İzin Ver",
  "copy.1ffc39c22b1c": "Push Bildirimlerini Kapat",
  "copy.49e62454340a": "İzin verildi",
  "copy.0cad353f2bae": "Tarayıcı engelledi",
  "copy.658d742a69ea": "Sunucuda push yapılandırılmamış",
  "copy.ee28de8dbf01": "Günlük planlama hatırlatıcısı",
  "copy.21004173ed75": "Sabah günü planlamak için bir dokunuş.",
  "copy.6bc5a901db48": "Saat",
  "copy.285af6543a87": "Gözden geçirme hatırlatıcısı",
  "copy.27c734778cff": "Dosya okunamadı.",
  "copy.d2a59dc02427": "Dosya incelenemedi.",
  "copy.0d4c8aa82886": "Yedek okunamadı",
  "copy.4d3a52d755ea": "Geri yükleme tamamlandı",
  "copy.5d0141c44ddd": "{{value1}} kayıt yüklendi.",
  "copy.7ef22d4f9e39": "Geri yüklenemedi",
  "copy.6135a42bf53e": "Veri",
  "copy.4bd012f22dc6": "Yedek indir",
  "copy.ed806cf70c05": "Markdown indir",
  "copy.f2a88edf41a6": "Yedekten Geri Yükle",
  "copy.6fcc00eeee69": "Yedek, her satırı içeren düz bir JSON belgesidir; başka bir programla da okunabilir. Geri yükleme hem bu biçimi hem de Flutter uygulamasının kendi yedeğini kabul eder — telefondaki veriyi sunucuya taşımanın yolu budur. Flutter veritabanına hiçbir zaman dokunulmaz.",
  "copy.9ab231d7ae79": "Markdown dosyası ise okunmak içindir: projeler, görevler, rutinler, notlar ve günlük tek bir belgede, herhangi bir editörde açılabilir hâlde. Geri yüklenemez — eksiksiz kopya isteyen JSON yedeğini alsın.",
  "copy.97e09437b22b": "Bu işlem mevcut tüm verini değiştirir.",
  "copy.55ed39df01e7": "Her Şeyi Değiştir",
  "copy.071c30132baf": "Biçim:",
  "copy.9fbd25a3a325": "Geri yükleme tek bir işlem içinde çalışır: dosya bozuksa mevcut verine hiç dokunulmaz. Ama başarılı olursa şu anki her şey bu yedekle değişir.",
  "copy.e594a7374ebf": "Yedek dosyası incelenemedi",
  "copy.1c56ac8f2dc6": "Hesap",
  "copy.26d51c460f0b": "Parola değişti",
  "copy.5e5ed7325e20": "Parola değiştirilemedi",
  "copy.32b3b79aaf12": "Mevcut parola",
  "copy.1de4bd6bfd9c": "Değiştir",
  "copy.9112c2a2ec5f": "API Anahtarları",
  "copy.7938ed2c3830": "Tarayıcı dışındaki istemciler için. Gelecekteki Flutter uygulaması da aynı API'yi bu şekilde kullanır. Anahtar yalnızca bir kez gösterilir; sunucuda sadece özeti saklanır.",
  "copy.63a37bba0c7e": "Anahtar adı",
  "copy.4a3d53ad97e5": "Flutter · telefon",
  "copy.a6b7090cf3f7": "API anahtarı oluşturuldu",
  "copy.d2724171a732": "API anahtarı oluşturulamadı",
  "copy.89c75b03b93f": "Oluştur",
  "copy.2e8944436e76": "Bu anahtar bir daha gösterilmeyecek. Şimdi kopyala.",
  "copy.2a05663cf99e": "API anahtarı kopyalandı",
  "copy.4830b08fd70a": "API anahtarı kopyalanamadı",
  "copy.06f4c085606c": "Anahtarı Kopyala",
  "copy.089ede514fc5": "API anahtarları yüklenemedi",
  "copy.3ecf0643fb4a": "Henüz API anahtarı yok",
  "copy.43b1ea49527b": "Harici bir istemci bağladığında anahtarları burada yönetebilirsin.",
  "copy.a1a8b6d5f45b": "son kullanım {{value1}}",
  "copy.647df8479ced": "hiç kullanılmadı",
  "copy.027d04b51d4d": "İptal ediliyor",
  "copy.0e6a4a39ff65": "Anahtarı iptal et",
  "copy.a656eb128532": "“{{value1}}” API anahtarı iptal edilsin mi?",
  "copy.8241550568a6": "Bu anahtarı kullanan istemciler hemen erişimini kaybedecek.",
  "copy.e5a1d1fc47d3": "API anahtarı iptal edildi",
  "copy.360423f4a9de": "API anahtarı iptal edilemedi",
  "copy.283092d12a56": "Çıkış Yap",
  "copy.9c0288e28f48": "Hesabı Sil",
  "copy.2221b1be9c7d": "Hesabı Kalıcı Olarak Sil",
  "copy.45167c3129fe": "Tüm kişisel kayıtların geri alınamayacak biçimde silinir. İstersen önce Veri bölümünden yedek indir.",
  "copy.93c576376df4": "Hesap silinemedi",
  "copy.f065ec043d16": "Hesabı ve tüm verileri sil",
  "copy.9752a34ccec5": "Onay için e-posta adresini yaz",
  "copy.bb82cdb533c2": "İki adımlı doğrulama başlatılamadı",
  "copy.cb7ee627497c": "İki adımlı doğrulama açıldı",
  "copy.d069a78d03a3": "Kod doğrulanamadı",
  "copy.1091b67d6db2": "İki adımlı doğrulama kapatılsın mı?",
  "copy.a43d800a9f19": "Hesabın bundan sonra yalnızca parolayla korunacak.",
  "copy.b0057747f18c": "Doğrulamayı kapat",
  "copy.15fa9c08634a": "İki adımlı doğrulama kapatıldı",
  "copy.dee98045c5da": "İki adımlı doğrulama kapatılamadı",
  "copy.4527d07bc1ab": "İki Adımlı Doğrulama",
  "copy.de9131310413": "Etkin",
  "copy.5f7034fb8282": "Parolandan sonra kimlik doğrulama uygulamandaki tek kullanımlık kodu ister.",
  "copy.494aa90793a6": "Kurulumu Başlat",
  "copy.4abd83238a1f": "Aşağıdaki anahtarı kimlik doğrulama uygulamana ekle, ardından üretilen kodu doğrula.",
  "copy.24e79a23345f": "Kurulum anahtarı kopyalandı",
  "copy.be09dd731d0b": "Kurulum anahtarı kopyalanamadı",
  "copy.dce8edc1f8c5": "Anahtarı kopyala",
  "copy.5c00187a2ff0": "Kurulum bağlantısı kopyalandı",
  "copy.1023809cf73d": "Kurulum bağlantısı kopyalanamadı",
  "copy.b144eb0e1e87": "Kurulum Bağlantısını Kopyala",
  "copy.f0e09f445c16": "Altı haneli kod",
  "copy.a95c3631c07c": "Doğrula ve Aç",
  "copy.3bfc38419944": "İki Adımlı Doğrulamayı Kapat",
  "copy.c16ff70cadf7": "Kavram Haritası Oluştur",
  "copy.02f429580797": "Harita bilgileri kopyalamaz; ortak Bilgi Ağı için görsel bir düzen saklar.",
  "copy.c5bf2bbb3e0a": "Harita Oluştur",
  "copy.a3b8c0cb41b2": "Başlık",
  "copy.e7ae0d9a164c": "Açıklama",
  "copy.48e488f58d9c": "Kavram haritası oluşturuldu",
  "copy.6cfa113b2ffc": "Kavram haritası oluşturulamadı",
  "copy.ab8c0d276d7b": "Kavram Haritaları",
  "copy.cd3725f0201c": "Bu bağlamdaki bilgileri ortak Bilgi Ağı üzerinde görselleştir.",
  "copy.1122edeaf6b2": "Bilgi Ağına Git",
  "copy.faf7c7deea49": "Yeni Harita",
  "copy.c65e1d312d7d": "Kavram haritaları yüklenemedi",
  "copy.b8e59fb1d563": "Bilgi Ağına şu anda ulaşılamıyor.",
  "copy.9371d0677126": "Henüz kavram haritası yok",
  "copy.0f351e4625b1": "Bu bağlam için bir harita oluştur; bilgileri Bilgi Ağından ekle.",
  "copy.9f2fb4fd0fab": "bilgi",
  "copy.dcc084f9a2e1": "Aç",
  "copy.ba26074f4bcf": "Kavram",
  "copy.57998053d77d": "Olgu",
  "copy.4d2dbc852280": "İddia",
  "copy.37c9299cc784": "Tanım",
  "copy.916fcb840691": "Yöntem",
  "copy.9670899fdcff": "Örnek",
  "copy.2f0db590c3dc": "Kaynak",
  "copy.0e7e238b1da4": "Bilgi kütüphanesi yükleniyor.",
  "copy.0aa78f4cc099": "Bilgi kütüphanesi yüklenemedi.",
  "copy.d8fbb865cf2b": "Kütüphanede {{value1}} bilgi kaydı var. Semantik bağlar ortak Bağlantılar panelinde yönetilir.",
  "copy.6341f61f1f16": "Bilgiler arasındaki bağları gör.",
  "copy.17d7999c9c9f": "Bir kez kaydet; notlarda, projelerde ve haritalarda aynı bilgiyi kullan.",
  "copy.ad9c6f95dff2": "Bilgi Ekle",
  "copy.3e4e2ad7969b": "Bilgilerde ara",
  "copy.0c0dbeb8d256": "Başlık, açıklama veya diğer ad ara",
  "copy.e98e7ed16c63": "Bilgiler alınamadı",
  "copy.304ae84d606f": "Bilgi kütüphanesi şu anda yüklenemiyor.",
  "copy.39caa44a8a8d": "Aramayla eşleşen bilgi yok",
  "copy.8ad154203512": "Henüz bilgi yok",
  "copy.bf5f1440ae7b": "Arama ifadesini değiştir veya yeni bir bilgi ekle.",
  "copy.46ad22af4fc5": "İlk kavramı, tanımı veya yöntemi tek cümleyle kaydet.",
  "copy.de2b7b02d529": "İlk Bilgiyi Ekle",
  "copy.487bb6f48874": "Bilgi ayrıntısı",
  "copy.f5afa9429103": "Ayrıntısını görmek için bir bilgi seç",
  "copy.91cd451ca120": "Bilginin kısa açıklaması, diğer adları ve ilişkileri burada görünür.",
  "copy.ea33b58c1d8e": "Düzenle",
  "copy.82d5f40bb2f6": "Henüz kısa açıklama eklenmemiş.",
  "copy.f6f0d73998a3": "Diğer adlar",
  "copy.89a0ccceb3bc": "Kavram haritaları alınamadı",
  "copy.c7c52545852b": "Kaydedilmiş haritalar şu anda yüklenemiyor.",
  "copy.75d124168685": "Aynı bilgi ağından farklı bakışlar oluşturmak için ilk haritayı aç.",
  "copy.98a57fdcb335": "Kavram haritaları",
  "copy.4c71e939d90a": "Haritalar",
  "copy.c49bb3dc164e": "Kavram Haritası Ekle",
  "copy.e946061f575d": "Bilgilerin kendisini çoğaltmadan görsel düzenler oluştur.",
  "copy.eae894d6068a": "Seçili kavram haritası",
  "copy.8dd21c376daa": "Görüntülemek için bir harita seç",
  "copy.8a4fbc7be035": "Haritada yalnızca bilgi konumları tutulur; bilgiler ve ilişkiler ortak ağdan gelir.",
  "copy.2bd11e318b03": "Harita alınamadı",
  "copy.37c7bfb928a2": "düğüm",
  "copy.e699f39f8014": "Haritaya eklenecek bilgi",
  "copy.e235b92514e6": "Bilgi seç…",
  "copy.7bc3fd2fdd78": "Haritaya Ekle",
  "copy.485f6079a58b": "{{value1}} kavram haritası",
  "copy.fab00418a21f": "Harita boş",
  "copy.0862cb8ca0d8": "Yukarıdan bir bilgi seçip haritaya ekle. Düğümleri sürükleyerek görsel düzeni kur; semantik ilişkileri seçili bilginin ortak Bağlantılar panelinden yönet.",
  "copy.57aec0d3cde9": "· Haritadaki konumu seçildi",
  "copy.a6aa714085a7": "Haritadan Kaldır",
  "copy.aa61eddb228d": "Bilgiyi Düzenle",
  "copy.886e262917d1": "Tek, kısa bir açıklama kullan; ayrıntılı içerik için bilgiyi notlara bağla.",
  "copy.5d33fa789962": "Bilgi Türü",
  "copy.d0903530c3cc": "Kısa Açıklama",
  "copy.1aec633b7fa7": "Bilginin ne olduğunu tek bakışta anlatan kısa ifade.",
  "copy.e5d90c03cd12": "Diğer Adlar",
  "copy.e4f5709d854a": "Virgülle ayır.",
  "copy.014555b0cd45": "Tüm Notlar",
  "copy.e472df084ad0": "Koleksiyon",
  "copy.c0977fd7e739": "Koleksiyonlar",
  "copy.94d8ad6ca5b5": "Koleksiyonlar yüklenemedi.",
  "copy.1e3f5b71382d": "Seçili koleksiyonda ara",
  "copy.d79b8374ac49": "Bu koleksiyonda ara…",
  "copy.c85b32b81834": "Notlar yüklenemedi.",
  "copy.7f9e8516d8cd": "Aramayla eşleşen not yok",
  "copy.5d6a926f5038": "Bu koleksiyon boş",
  "copy.85fbac45abaa": "Yeni bir not ekleyebilir veya başka bir notu buraya sürükleyebilirsin.",
  "copy.be81df2e2f74": "{{value1}} notunu taşı; önceki veya sonraki koleksiyon için sol ve sağ okları kullan",
  "copy.0c2319c34c4d": "İsimsiz not",
  "copy.0720141575bd": "İçerik henüz boş.",
  "copy.af5314c74764": "Daha Fazla Not Getir",
  "copy.c47288f712d7": "Okumak için bir not seç",
  "copy.ed70439d3159": "Koleksiyon arşivlendi",
  "copy.e767f6520b1e": "Alt notlar silinmedi; koleksiyonun yeri, sırası ve not yerleşimleri korunuyor.",
  "copy.a1a42bee962d": "Koleksiyon arşivlenemedi",
  "copy.c34e60dc6967": "Biraz sonra yeniden dene.",
  "copy.8161c2e2f138": "{{value1}} koleksiyonunu sırala",
  "copy.cda75a7a40ba": "{{value1}} koleksiyonunu arşivle",
  "copy.ff33abf236d8": "Hafıza koleksiyonları",
  "copy.37200f9aa455": "Köke bırak",
  "copy.719b89b6b404": "Düzenlemek için aç",
  "copy.28697ae7dc33": "Bu not henüz boş.",
  "copy.d4c443070010": "Koleksiyon oluştur",
  "copy.2c5802e49e24": "{{value1}} içinde yeni bir alt koleksiyon.",
  "copy.b38cca770e15": "Yeni bir bilgi alanı.",
  "copy.4cd247ff5c07": "Koleksiyon adı",
  "copy.a5ad04672105": "Kısa açıklama",
  "copy.e282bf08a937": "Yaşam kayıtları",
  "copy.28b679f4fca7": "Anı",
  "copy.31adddf058fd": "Anılar",
  "copy.abab70053722": "Taslak",
  "copy.779c7177e97a": "Karar",
  "copy.4419e0aef47c": "Odak kayıtları",
  "copy.3d7c54eef3f9": "Geçmiş görünümü",
  "copy.186197b176e7": "Geçmiş Görünümü",
  "copy.4e850716074e": "Son",
  "copy.c9a878720fa5": "Zaman",
  "copy.a3830980d61b": "Geçmiş yüklenemedi",
  "copy.6b4275f1f7cb": "Notlarına ve yaşam kayıtlarına şu anda ulaşılamıyor.",
  "copy.49f44b3ac144": "Geçmişte henüz içerik yok",
  "copy.4558404455a3": "Notlar, günlük girişleri ve yaşam kayıtları burada birlikte görünür.",
  "copy.f9751f975bb4": "En Son Güncellenenler",
  "copy.ebf4fcd4d1a2": "Yaşam Akışı",
  "copy.4fa0633a66bc": "Daha Eski Kayıtları Getir",
  "copy.3c9f2a84065f": "Kayıt detayı",
  "copy.5a9c55b92a06": "Ayrıntısını görmek için bir kayıt seç",
  "copy.0c4b5330b16e": "Geçmiş yükleniyor",
  "copy.5729428c8301": "{{value1}} · {{value2}} ayrıntısını aç",
  "copy.e27c5b4c5a57": "Taslak nota dönüştürüldü",
  "copy.46713d910a91": "Bu kaydın metni boş.",
  "copy.e1d51eb61dd8": "Oluşturuldu",
  "copy.40fdb26f3cfe": "Güncellendi",
  "copy.27184cb9b470": "Gerçekleşti",
  "copy.8bd057388e28": "Durum",
  "copy.a8d897547560": "Kaynak ve Bağlam",
  "copy.3dd2db670c40": "Bağlı Projeyi Aç",
  "copy.dc378bd68203": "Nota Çevir",
  "copy.e75b5dc1a5f3": "Notu Aç",
  "copy.a37edb689683": "Yaşam Takibinde Aç",
  "copy.eb9fd3d385e9": "Taslaklarda Aç",
  "copy.a599140a43c6": "Proje Kararlarında Aç",
  "copy.b81ebeb6909d": "Projelerde Aç",
  "copy.720e1e63e424": "Yaşam Kaydını Aç",
  "copy.18711bade2f4": "Odak Geçmişini Aç",
  "copy.a40fa2f422d2": "Yaşam Kayıtlarında Aç",
  "copy.193410982b9f": "Günlük notu",
  "copy.734cfd05c468": "İsimsiz taslak",
  "copy.41f1200287ab": "İşlenmeyi bekliyor",
  "copy.6d676228d805": "İşlendi",
  "copy.a7248eeb45eb": "Normal",
  "copy.301ef766a15b": "Günlük",
  "copy.4cbfeef81fdf": "Günlüğe eklendi",
  "copy.8b98d2808d38": "Günlük kaydı eklenemedi",
  "copy.37865452302c": "Bugünün Günlüğü",
  "copy.76834c1dc5f0": "Zihnimi boşalt",
  "copy.31387c5f43a1": "Zihnini boşalt",
  "copy.8840ef4929f4": "Günlüğe yaz",
  "copy.1561033ecd0e": "Sıralamak veya düzenlemek zorunda değilsin.",
  "copy.648efb007a51": "Kısa bir an da uzun bir anlatı da tek kayıt olabilir.",
  "copy.f155b3d83319": "Aklında kalan ne varsa sıraya koymadan yaz…",
  "copy.bdca02bf6354": "Bugün neler oldu, ne düşündün, nasıl hissediyorsun?",
  "copy.c35ce2067f4e": "Ruh hâli",
  "copy.2cfd3126aac2": "Enerji",
  "copy.78827e6c01ea": "Günlüğe Ekle",
  "copy.a43cd9c432ea": "İlgili Kaydı Doğrudan Aç",
  "copy.08acae7bc533": "Günlükten ayrılmadan yaşam bağlamını seç",
  "copy.21468bc8c572": "Zaman Akışı",
  "copy.7c6de22a8c72": "Bağımsız, zaman damgalı kayıtlar",
  "copy.814154914f15": "Günlük yüklenemedi",
  "copy.278d97e211c9": "İlk kayıt için alan hazır",
  "copy.6f6922d85815": "Kısa bir cümle de uzun bir zihinsel boşaltım da tek bir kayıt olabilir.",
  "copy.15fbb69da018": "Zihinsel boşaltım",
  "copy.df115500233f": "Sohbet",
  "copy.77b99959017d": "AI’den",
  "copy.34515e4055e2": "enerji",
  "copy.edeeb9e1679d": "Günlük penceresi",
  "copy.dd97b4df33fd": "Anlık penceresini küçült",
  "copy.3bc0515406c7": "Anlık · Günlük",
  "copy.f2d73da75ca2": "Anlık penceresini taşı; ok tuşlarıyla konumlandır, Home ile ortala",
  "copy.8e38c0d838ee": "Sürükle veya ok tuşlarıyla taşı",
  "copy.04c48f347564": "Anlık penceresini genişlet",
  "copy.979540421e75": "Anlık penceresini daralt",
  "copy.8a4c53f5395c": "Anlık penceresini kapat",
  "copy.3f8fb95771d7": "Not yüklenemedi",
  "copy.d2ffe86b10c4": "İçeriğe şu anda ulaşılamıyor. Bağlantını kontrol edip tekrar deneyebilirsin.",
  "copy.fbdde700237f": "Bağlantılar",
  "copy.6f08277817be": "Harita",
  "copy.35993c4e1a07": "Başlıksız not",
  "copy.809a89aa5afa": "Not Alanı",
  "copy.e2f4a0fec18f": "Kaydedilemedi · tekrar dene",
  "copy.dd292f855cd8": "Kaydediliyor…",
  "copy.d6d27b472489": "Değişiklikler bekliyor…",
  "copy.569e6436ea71": "Kaydedildi · {{value1}}",
  "copy.2fe83d132e3d": "Mod",
  "copy.4a2884827a36": "Yaz",
  "copy.3ca30db82b66": "Oku",
  "copy.82c552e2d402": "Arşivle",
  "copy.88e176f2a0e6": "Not arşivlendi",
  "copy.03b226cec5d0": "Çöp Kutusu’na Taşı",
  "copy.b1555d57c2a7": "“{{value1}}” Çöp Kutusu’na taşınsın mı?",
  "copy.c7d4503603a3": "Not ve içeriği Çöp Kutusu’na taşınır ve oradan geri alınabilir. Arşivlemek istersen yanındaki düğmeyi kullanabilirsin.",
  "copy.16a587ad2c09": "Bağlam",
  "copy.9d577d1d2ed9": "Not Üst Bilgisi",
  "copy.430d32b5de5c": "Proje ve değerleri içerikten ayrı düzenle. Değişiklikler anında kaydedilir.",
  "copy.e7dc4ae35876": "Üst Bilgide Ara",
  "copy.5fccaf98381f": "Proje ara",
  "copy.cfcbce97d6e0": "Proje Bağlamı",
  "copy.60deebf3df56": "Projesiz",
  "copy.020c2a36778d": "Üst bilgi kaydedilemedi · Tekrar Dene",
  "copy.9e5be53b8f2d": "Not içeriği",
  "copy.da660887e4e2": "Yazmaya başla…\n\n# Başlık\n- Madde\n- [ ] Yapılacak\n> Alıntı",
  "copy.246a1f0e91b2": "Not geçmişi yükleniyor",
  "copy.6e031db7f962": "Not geçmişi yüklenemedi",
  "copy.18a36c15eac9": "Kaydedilmiş anlık görüntülere şu anda ulaşılamıyor.",
  "copy.83702fdefb08": "Not Geçmişi",
  "copy.cd0a5f25a736": "Tam anlık görüntüler. Aynı içerik art arda yeniden kaydedilmez.",
  "copy.5a5a29abba15": "Notun anlık görüntüsü kaydedildi",
  "copy.4595298d737d": "Şimdi Kaydet",
  "copy.a1e192c5d443": "Henüz geçmiş yok",
  "copy.29f6bf64e917": "İlk anlık görüntüyü kaydettiğinde burada görünecek.",
  "copy.3c1698c0e8ef": "Bu görüntüde not metni boş.",
  "copy.8ca610c50004": "· Kaynak sürüm",
  "copy.ef77f8e2bda4": "Bu sürüme dönülsün mü?",
  "copy.f113cb6d765c": "Şu anki içerik önce geçmişe kaydedilir; ardından seçilen görüntü yeni sürüm olur.",
  "copy.2d0cf3a0aff6": "Geri yükle",
  "copy.0089ce0949fb": "Not sürümü geri yüklendi",
  "copy.71cb54e14d68": "Geri yüklenen sürüm",
  "copy.6fd8a45f58d5": "Geri yükleme öncesi",
  "copy.961611152385": "Anlık görüntü",
  "copy.6af64a401241": "<p class=\"cx-empty\">Bu not boş.</p>",
  "copy.f3d3bb4e2fb3": "Not görünümü ve filtreleri",
  "copy.4447849a4d05": "Notlarda ara",
  "copy.84610aff8195": "Filtreler",
  "copy.c1d67bf78759": "Not Görünümü",
  "copy.7343841e724e": "Liste",
  "copy.b1b05e3eb50d": "Kartlar",
  "copy.747e078b6022": "Not filtreleri",
  "copy.1191aff270da": "Tüm projeler",
  "copy.468d9f680caa": "Filtreleri temizle",
  "copy.a7587d828765": "Notlar yüklenemedi",
  "copy.91441af0ba4a": "“{{value1}}” için not yok",
  "copy.885cf62e1b0c": "Henüz not yok",
  "copy.8498f479155c": "Notlar, tutmaya değer bulduğun şeyler için. Henüz işlenmemiş düşünceler Taslaklar'da kalır.",
  "copy.2b2a398126da": "İlk Notu Yaz",
  "copy.443e7f4a2b74": "Boş not",
  "copy.cf6499ad96a2": "not gösteriliyor",
  "copy.d0e39a8e5c8f": "Daha Fazla Not Yükle",
  "copy.fe0e34366b5a": "Diğer notlar yüklenemedi. Yeniden deneyebilirsin.",
  "copy.e5dc5437dcb4": "Sekme sınırına ulaşıldı",
  "copy.04d93bf407bb": "Bir not penceresinde en çok {{value1}} not açık kalabilir. Önce bir sekmeyi kapat.",
  "copy.55c7c1986f4b": "Not çalışma penceresi",
  "copy.ae2a40b4d164": "Not penceresini küçült",
  "copy.8fb911dcd76e": "Not penceresini taşı; ok tuşlarıyla konumlandır, Home ile ortala",
  "copy.ff13cd3370f8": "Açık notlar",
  "copy.f39674b236c2": "Yeni not oluştur ve sekme olarak aç",
  "copy.ff89fe1be595": "İki notu yan yana göster",
  "copy.e8874f776a69": "Var olan bir notu sekme olarak ekle",
  "copy.7931d04b3a97": "Not penceresini genişlet",
  "copy.70b7fb0dd36f": "Not penceresini daralt",
  "copy.cb6e87fb5944": "Not penceresini kapat",
  "copy.d8116ac68d43": "Not seç",
  "copy.8576940aa0fe": "Yeni Not",
  "copy.73041134791c": "Bu pencerede en çok",
  "copy.00858ad236c8": "not açık kalabilir. Yeni bir not eklemek için önce bir sekmeyi kapat.",
  "copy.81b2a24d53c0": "Notlar yükleniyor",
  "copy.70040ce7974d": "Çalışma notlarına şu anda ulaşılamıyor.",
  "copy.50fc81010461": "İlk çalışma notunu oluşturup doğrudan bu pencerede yazmaya başlayabilirsin.",
  "copy.9dc191af034f": "Daha Fazla Not",
  "copy.126e4fae4dd4": "Henüz içerik yok",
  "copy.6b90e23a89ee": "Açık sekme",
  "copy.2b88a710cfd0": "tamamlandı",
  "copy.b7992378caee": "atlandı",
  "copy.49730237c2a7": "Duraklatıldı",
  "copy.bd5d2911824c": "Arşivli",
  "copy.37e2cf2fa7cf": "Rutin yüklenemedi",
  "copy.604c1a53e347": "Rutinin planına ve geçmişine şu anda ulaşılamıyor.",
  "copy.56bf34ff3770": "bu tarihte oluşum yok",
  "copy.24c7be1b09ec": "Devam Ettir",
  "copy.8b821f1a0c83": "Rutin grubu:",
  "copy.127aef763ca8": ". Rutin durumu:",
  "copy.92b43618cb97": "Bugün tamamlandı",
  "copy.a7ce264a8338": "Bugün atlandı",
  "copy.09564815dd9c": "Bugünkü kayıt açık",
  "copy.b78cb2c56557": "Bugün için oluşum yok",
  "copy.2eccf6038ace": "Yeniden aç",
  "copy.d723799ffbf6": "Atlamayı geri al",
  "copy.70ad067c3757": "Bugün atla",
  "copy.8917b01bb398": "Rutin Özeti",
  "copy.0212854030fa": "30 Günlük Ritim",
  "copy.c6f743dde499": "28 günü üret",
  "copy.d694d5719eaa": "30 gün önce",
  "copy.1279dae674df": "Bugün",
  "copy.5383a260a281": "Rutinin son 30 günlük kaydı",
  "copy.d6924100da57": "Son 30 gün",
  "copy.0bcb5ff74923": "Son 7 gün",
  "copy.73fc1e6b33e4": "Seri",
  "copy.0ecea5c1b188": "gün · en iyi",
  "copy.5b3df0cf7cc8": "Atlanan",
  "copy.f95267f29623": "Efor",
  "copy.b4b558237ae3": "Efor özeti şu anda hesaplanamadı.",
  "copy.f4ad0b67bd35": "Gerçek odak",
  "copy.40201a4eb444": "son 365 gün",
  "copy.d784e2e6d474": "Tamamlananların tahmini",
  "copy.9d14a5ce5e27": "{{value1}} görev",
  "copy.1348a1207b09": "Önündeki bir yıl",
  "copy.3a78efdd2a93": "tamamlanan görevde tahmini süre bilinmiyor; tahmini toplam yalnız bilinen süreleri içerir.",
  "copy.5f12d026fc97": "Gelecek birikimi görmek için rutine varsayılan bir süre ekle.",
  "copy.917e2b5439bf": "Yaklaşan Günler",
  "copy.6b8771d56886": "Bağlı Proje",
  "copy.053664dcbb41": "Projeye bağlı değil",
  "copy.5da57b457b37": "Tekrar",
  "copy.e14ad577955f": "Süre belirtilmedi",
  "copy.074c7bd805e8": "Saat belirtilmedi",
  "copy.e9498e148b1f": "Hatırlatıcı",
  "copy.a11d42f98c24": "Renk bağlamdan",
  "copy.bfaca8828655": "Özel renk",
  "copy.d55dd778c931": "Renk otomatik",
  "copy.39ce8f387818": "Kapalı",
  "copy.60f97fc2fff5": "Sınırlandırılmadı",
  "copy.21f81ca74299": "Seçili günler",
  "copy.ace7f0833a9d": "X günde bir",
  "copy.461f8fe7a08a": "Haftada N kez",
  "copy.d2bc3efeb1c0": "Bitiş, başlangıçtan önce olamaz.",
  "copy.02f933b8581d": "Rutini düzenle",
  "copy.9030480b9ade": "Yeni rutin",
  "copy.e6289605b1c8": "Kuralı değiştirmek geçmişi değiştirmez.",
  "copy.c96f14c92d16": "Ne tekrar edecek?",
  "copy.b0e4706c6dcd": "Sıklık",
  "copy.e5e7f5719c8e": "Kaç günde bir",
  "copy.d66cae7606de": "günde bir",
  "copy.6dccd1a20031": "Haftada",
  "copy.10dbe20d4ad5": "Haftada kaç kez",
  "copy.24196fe8174c": "kez",
  "copy.c60438bbed33": "Belirli günlere bağlı değil. Haftalık kota dolunca Bugün'den düşer.",
  "copy.e69f304adc92": "Planlarken bu saat önerilir.",
  "copy.5c053d01946d": "Başlangıç Tarihi",
  "copy.d5dc5b6e533c": "Boşsa hemen etkinleşir.",
  "copy.6d4b32f1eedb": "Bitiş Tarihi",
  "copy.f92cdf77a8c7": "Boşsa süresiz devam eder.",
  "copy.aa2d27eacb80": "Boş bırakılırsa proje veya değer rengi kullanılır.",
  "copy.cba36654e0f5": "Planlandığında hatırlatıcı da kurulur. Hiçbir şey kendiliğinden bildirim göndermez.",
  "copy.bf7a73dbee81": "Rutin Çöp Kutusu’na taşınır ve oradan geri alınabilir. Yalnızca yeni görev üretimine ara vermek istiyorsan rutini duraklatabilirsin.",
  "copy.53e796c2d4be": "Rutin listesi filtreleri",
  "copy.191d885ea878": "Rutinler yüklenemedi",
  "copy.45535fb5b28d": "Henüz rutin yok",
  "copy.9c2ca1f60091": "Tekrarlanan bir davranışın günlerini, saatini ve süresini tanımlayarak ilk rutini kur.",
  "copy.d1f9d8919e11": "İlk rutini oluştur",
  "copy.f546116422a8": "Etkin Rutinler",
  "copy.afd1e6207559": "Şu anda çalışan rutin yok",
  "copy.facf43ea229a": "Duraklatılmış bir rutini devam ettirebilir veya yeni bir tekrar kuralı oluşturabilirsin.",
  "copy.b9377fce6e10": "Rutin oluştur",
  "copy.f80edd33efd3": "Bağımsız rutinler",
  "copy.99b57227b30e": "Arşivlendi",
  "copy.4eb3b9f0a041": "Duraklatılmış",
  "copy.f8224ce322c4": "Rutin ve bağlam",
  "copy.70ba1bbe6850": "Ritim",
  "copy.02600cabf6d4": "Sıradaki oluşum",
  "copy.b93c839f51f3": "İşlem",
  "copy.56dc29143dcd": "{{value1}} rutinini sırala",
  "copy.8498fb76aee8": "Bağımsız rutin",
  "copy.4222cd4cba97": "Süre belirtilmemiş",
  "copy.c3c906d77742": "Hatırlatıcı açık",
  "copy.07bd01d53c3a": "Yeni görev üretmiyor",
  "copy.5421e3bbecf9": "Sıradaki açık tekrar",
  "copy.37e4b6a7987d": "Tarih yok",
  "copy.5aa457084b05": "Rutin sona erdi",
  "copy.6968ef1b930a": "Sıradaki oluşum hesaplanmadı",
  "copy.19b6acde3303": "Duraklat",
  "copy.b7428c0608da": "Daha Fazla",
  "copy.b1b94c42b1ee": "Görev yüklenemedi",
  "copy.2696ceee5b85": "Görev ayrıntılarına şu anda ulaşılamıyor.",
  "copy.160a0c04f40f": "Arşivde",
  "copy.a395d3f03cd5": "Odağa Başla",
  "copy.7c6f3f5f37bc": "Tamamlandı",
  "copy.c56ee44480c4": "Yeniden Aç",
  "copy.e99c0f5f39c4": "Zamanlama",
  "copy.28f367c06d06": "Tek görev zamanı; istersen boş bırakabilirsin.",
  "copy.eda0ec4e68fc": "Zamanlamayı Düzenle",
  "copy.6e53533c7eee": "Odak Geçmişi",
  "copy.e39d882bed59": "Toplam {{value1}}",
  "copy.20a1bc039cb5": "Kaydedilen gerçek çalışma oturumları.",
  "copy.af458a65e955": "Odak geçmişi yükleniyor",
  "copy.191ef851f132": "Odak geçmişi yüklenemedi",
  "copy.7ef1bec67806": "Görevin çalışma kayıtlarına şu anda ulaşılamıyor.",
  "copy.41e52748392f": "Henüz odak kaydı yok",
  "copy.66edcbed3b55": "Tamamlanan odak oturumları burada görünecek.",
  "copy.68301d6363c0": "Süre kaydedilmedi",
  "copy.0fbfb68f1fea": "Bağlam ve Köken",
  "copy.b37eb675bf47": "Çalışma bağları, öncelik ve kayıt geçmişi",
  "copy.5f6c274c0968": "Projeyi Aç",
  "copy.feaf3bca563c": "Planı Aç",
  "copy.a6204fb9ae1e": "Bağlı değil",
  "copy.c8a5aafada26": "Köken",
  "copy.89d3bff7cac1": "Kaynak Rutini Aç",
  "copy.6ed956b0b6dc": "Bir taslaktan dönüştürüldü",
  "copy.da3952395dbe": "Doğrudan görev",
  "copy.874608e6ef44": "Oluşturulma Yolu",
  "copy.10cc43323876": "Öncelik",
  "copy.aa5be1febbcb": "Görev İşlemleri",
  "copy.721698ff82bb": "Bölme, durum, arşiv ve Çöp Kutusu’na taşıma",
  "copy.0f2f871ae988": "Görevi Böl",
  "copy.964e5c87e8d2": "Bu Oluşumu Atla",
  "copy.dee2f8e430fe": "İptal Et",
  "copy.5bc872cacfa7": "Arşivden çıkarıldı",
  "copy.2bd6fa586ed3": "Arşivden Çıkar",
  "copy.a566e98a17ee": "Görev Çöp Kutusu’na taşınır ve oradan geri alınabilir. Etkin listelerden kaldırıp saklamak istiyorsan arşivleyebilirsin.",
  "copy.0ce25055a534": "Görev Özeti",
  "copy.9acca15934e5": "Görev Tarihi",
  "copy.a4fe24966302": "Tahmin {{value1}}",
  "copy.2e07de89affa": "Tahmin yok",
  "copy.c169dad911d5": "Takvimde",
  "copy.a135e05bc1ff": "Liste Görünürlüğü",
  "copy.c77135fdca59": "Çalışma Bağlamı",
  "copy.59a9c862f500": "Görev Tarihi Eklenmedi",
  "copy.95d7dcfd55e9": "Görevi tarihsiz bırakabilir veya doğrudan bugün ya da yarına yerleştirebilirsin.",
  "copy.c704a0289b62": "Yarın",
  "copy.e052ca7e0a11": "Hatırlatıcı yok",
  "copy.8e612a881191": "{{value1}} önce hatırlat",
  "copy.e5685b250866": "Takvimde Aç",
  "copy.3c9be645ee70": "İptal Edildi",
  "copy.594b1254c47d": "Atlandı",
  "copy.f46439f36834": "Düşük",
  "copy.06213d812746": "Yüksek",
  "copy.bbcaca2db421": "Her Yerde Göster",
  "copy.80d7c6117abc": "Genel Listelerde Gizle",
  "copy.02e302c78c1e": "Doğrudan",
  "copy.20facd515829": "İçe Aktarma",
  "copy.63dd812ab288": "Veri Taşıması",
  "copy.954f0858d921": "Düşük enerji",
  "copy.432b14918534": "Orta enerji",
  "copy.7e1e6873b1f7": "Yüksek enerji",
  "copy.4369b336d7d9": "Yok",
  "copy.9bd00c306092": "Saatinde",
  "copy.3cd4735a3fe4": "5 dk önce",
  "copy.6f9f73d717ce": "15 dk önce",
  "copy.5d57342b7a4f": "30 dk önce",
  "copy.b59a46e8b948": "Görevi düzenle",
  "copy.a4d247b8df96": "Yeni görev",
  "copy.f55aac09fd54": "Ne yapılacak?",
  "copy.5c0ac1d583b3": "Görevin kapsamını veya beklenen sonucu yazabilirsin.",
  "copy.9f21e646042b": "Proje ve Plan bağlamı",
  "copy.d67ced741420": "Plansız",
  "copy.ffcb471eae18": "Mevcut plan",
  "copy.40131626f1a0": "Boş bırakılabilir.",
  "copy.e306951c12fe": "Temizle",
  "copy.b31ad9244182": "İsteğe bağlı. Boşsa görev o gün içinde saatsiz kalır.",
  "copy.825a623342bf": "Tahmini Süre",
  "copy.70aab7b9b7e3": "Ayrıntılar",
  "copy.b4b9890a72f6": "Belirtme",
  "copy.f0c77623fdfc": "Liste görünürlüğü",
  "copy.2dbe78aee227": "görünür",
  "copy.0894d27e4b5d": "Her yerde göster",
  "copy.6511a6d3b677": "Genel listelerde gizle",
  "copy.c80aefc61331": "Tarihsiz",
  "copy.dbd417da03e1": "İptal edildi",
  "copy.7eb27764c944": "Süre yok",
  "copy.3ade1f388d35": "Tarihli",
  "copy.2ae48de34178": "Yüksek öncelik",
  "copy.341c89df4699": "Bugün Takvime Ekle",
  "copy.9af9083e23c5": "Yarın Takvime Ekle",
  "copy.3f6920a9ead3": "İptal et",
  "copy.b5fb430e1781": "Bu oluşumu atla",
  "copy.4cbe371f24e1": "Gecikmiş",
  "copy.ebf017bde39a": "Tamamlanan",
  "copy.3bad15cd9763": "Durdurulan",
  "copy.6d3fa3fdb177": "Hepsi",
  "copy.5a98326ea72d": "Açık görev yok",
  "copy.7585d98e6ee4": "Aklındaki işi yakala; ne zaman yapacağına sonra karar verebilirsin.",
  "copy.29eef5007472": "Bugüne yerleştirilmiş görev yok",
  "copy.f78bdbaec539": "Günün takvimini görmek için Takvim ekranına dönebilirsin.",
  "copy.4077f68b85ab": "Gecikmiş görev yok",
  "copy.afcb8109ff8b": "Açık görevlerinin tarihi veya planlanan bitiş zamanı geride kalmamış.",
  "copy.9103ae8c1f63": "Tamamlanan görev yok",
  "copy.65cc8905e935": "Bitirdiğin işler burada, en son tamamlanandan başlayarak görünür.",
  "copy.36c978566a06": "İptal edilen veya atlanan görev yok",
  "copy.503c6b93a6ff": "İptal edilen işler ve rutinlerden atlanan oluşumlar burada görünür.",
  "copy.eb61dfad320e": "Eşleşen görev yok",
  "copy.4ea8111f84dc": "“{{value1}}” için bu görünümde sonuç bulunamadı.",
  "copy.4bff24c71cd5": "Bu görünümde {{value1}} görev yok",
  "copy.11a5f5913441": "Tarih filtresini değiştirerek diğer görevleri görebilirsin.",
  "copy.c70acf93fd29": "Yeni Sıra",
  "copy.0be3998bcc26": "Manuel Sırala",
  "copy.d5c9b3e3bef8": "Görev filtreleri",
  "copy.b918e4d5261e": "Görev Görünümü",
  "copy.49645c228b78": "Görev Tarihi Filtresi",
  "copy.7df146b5ba8d": "Görevlerde ara",
  "copy.043cbcd4e8b5": "Proje, öncelik, enerji ve kaynakla görünümü daralt.",
  "copy.cc7fcf8ee6d0": "Projeye göre filtrele",
  "copy.dea358c3157d": "Önceliğe göre filtrele",
  "copy.10bcad87d149": "Tüm öncelikler",
  "copy.0363cc1a7759": "Enerjiye göre filtrele",
  "copy.d1e3bd0cb4d4": "Tüm enerjiler",
  "copy.4120388e3ca6": "Kaynağa göre filtrele",
  "copy.158b2f775c1f": "Tüm kaynaklar",
  "copy.81f6f7f0c433": "Rutin kaynaklı",
  "copy.53306a82f141": "Gelen kutusundan",
  "copy.9e12b68131c5": "İçe aktarılan",
  "copy.4782424b8a21": "Görevleri sırala",
  "copy.55fa21269c40": "Akıllı Sıra",
  "copy.3e109d157254": "Görev Tarihine Göre",
  "copy.f434360cfd50": "Son değişene göre",
  "copy.ed6367311d42": "Oluşturulana göre",
  "copy.184aee9eca0d": "Başlığa göre",
  "copy.82906b7b4bcc": "Manuel sıra",
  "copy.e980e73462a7": "Görevler yükleniyor",
  "copy.d60cb36f492d": "{{value1}} görev gösteriliyor",
  "copy.d1eb7fe130e7": "Görevler yüklenemedi",
  "copy.11d0da610718": "Bağlantını kontrol edip listeyi yeniden yükleyebilirsin.",
  "copy.8975bb30e876": "Aramayı Temizle",
  "copy.7c7c5b2ec391": "Görev ekle",
  "copy.3005a154a599": "Görev ve bağlam",
  "copy.af3e04fd73aa": "Görev Tarihi ve Durum",
  "copy.1c8289d66557": "{{value1}} görevini sürükleyerek sırala",
  "copy.132290e5e9e9": "Bu görünüm ilk",
  "copy.e9f68d5f2cb8": "görev üzerinden hesaplandı; aramayı veya filtreleri daraltarak kalan görevlere ulaşabilirsin.",
  "copy.46e8e6e245e1": "Her parça için bir başlık gir.",
  "copy.5121fc9b367e": "Tahminler 1 ile 1440 dakika arasında tam sayı olmalı.",
  "copy.42240b459bc6": "Görev {{value1}} parçaya bölündü",
  "copy.60e2a7a0d592": "Asıl görev açık bırakıldı.",
  "copy.0ea48fef5bb4": "Asıl görev iptal edildi.",
  "copy.63438088511c": "“{{value1}}” görevini bağımsız ve uygulanabilir parçalara ayır.",
  "copy.dbfb40cac736": "{{value1}} Parçaya Böl",
  "copy.5ccb12e24e3c": "Parça sayısı",
  "copy.f06f072de208": "parça",
  "copy.f5aaa7faf374": ". parça",
  "copy.96dd9382cb27": "Dakika · isteğe bağlı",
  "copy.7aa935ebb7ad": "Asıl görevi açık tut",
  "copy.60960e2fc54b": "Kapalıyken asıl görev iptal edilir; yeni parçalar aynı proje, plan ve değer bağlamını korur.",
  "copy.c3e13b03dc99": "İşlem tamamlanamadı",
  "copy.a5ec4079a398": "Değişiklik kaydedilemedi. Bağlantını kontrol edip tekrar dene.",
  "copy.d4d0b9f5e404": "Bu alan prototipte henüz kullanıma açılmadı.",
  "copy.18ec784cabf5": "Geliştirme aşamasında",
  "copy.2d573297256f": "Bu alanın akışı tamamlandığında erişime açılacak.",
  "copy.e99bd3a990b9": "Menüyü genişlet",
  "copy.16eb3489b945": "Menüyü daralt",
  "copy.64467805a844": "Ana gezinmeyi aç",
  "copy.f49efddc6485": "Ara, komut çalıştır veya bir yere git",
  "copy.d9f0d8d1e13c": "Anlık günlük penceresini aç",
  "copy.304ae1558cde": "Anlık",
  "copy.92fbe8a2cca5": "Odak sayfası açık",
  "copy.3360084dc9e3": "Odak aracını aç",
  "copy.41620582d621": "Odak",
  "copy.e24b757f73ec": "Dağıldım yardım aracını aç",
  "copy.36008d4c423c": "Dağıldım",
  "copy.e9f7351d6ce8": "Hızlı Yakala",
  "copy.1968f5976659": "Profil ve hesap ayarlarını aç",
  "copy.a3254376acd7": "{{value1}} alt sayfaları",
  "copy.338a27d7a65a": "Ana gezinme",
  "copy.7a7a80bfab44": "İstek işlenemedi. Girdiğin bilgileri kontrol et.",
  "copy.39f6162d8263": "Oturumun sona erdi. Yeniden giriş yap.",
  "copy.a25c909874f9": "Bu işlem için yetkin yok.",
  "copy.31377a9a1089": "Güvenlik doğrulaması yenilenemedi. Sayfayı yenileyip tekrar dene.",
  "copy.4c8f6d456015": "Bu işlem için gerekli erişim izni bulunmuyor.",
  "copy.c7c2d58c091b": "Aradığın kayıt bulunamadı veya artık mevcut değil.",
  "copy.e53e2fae9cfc": "Kayıt bu sırada değişti. Sayfayı yenileyip tekrar dene.",
  "copy.560418b7fa5d": "Bazı bilgiler geçerli değil. İşaretlenen alanları kontrol et.",
  "copy.7f98f92e9117": "Bazı alan değerleri şema kurallarına uymuyor. Alanları kontrol et.",
  "copy.232da33bbc54": "Yayımlanmış bir alanın anahtarı değiştirilemez.",
  "copy.70495730f4bf": "Bu alan türü mevcut kayıtlarla uyumlu değil.",
  "copy.f2db1cf1a3a3": "Çok fazla deneme yapıldı. Biraz bekleyip yeniden dene.",
  "copy.a240b9844254": "Sunucuda bir sorun oluştu. Birazdan tekrar dene.",
  "copy.3ae448d5fd3f": "E-posta veya parola hatalı.",
  "copy.63aa560bc872": "Yeni hesap oluşturma şu anda kapalı.",
  "copy.f531becf149c": "Davet kodu geçerli değil.",
  "copy.ad844c2eddce": "Bu e-posta ile daha önce hesap oluşturulmuş.",
  "copy.fed49c4fa912": "Parola güvenlik koşullarını karşılamıyor.",
  "copy.e9052867369c": "Geçerli parolan doğru değil.",
  "copy.6c963742257c": "Yazdığın onay bilgisi eşleşmiyor.",
  "copy.bf647903640b": "Parola sıfırlama bağlantısı geçersiz, kullanılmış veya süresi dolmuş.",
  "copy.29264ede9afa": "İki adımlı doğrulama bu hesapta zaten etkin.",
  "copy.69b436bca334": "Doğrulama kodu eşleşmedi. Yeni kodu dene.",
  "copy.fa96a514cee4": "Doğrulama oturumu geçersiz. Parola ile yeniden giriş yap.",
  "copy.bf96bcfec84f": "Doğrulama süresi doldu. Parola ile yeniden giriş yap.",
  "copy.849189b4fc23": "Çok fazla hatalı kod girildi. Giriş işlemini yeniden başlat.",
  "copy.b6b5914072ea": "Kalıcı silme için yeniden giriş yapman gerekiyor.",
  "copy.889b2f0761db": "Kalıcı silme için yeniden giriş yapıp iki adımlı doğrulamayı tamamla.",
  "copy.006357b61a98": "Bu kayıt başka bir yerde değiştirildi. Güncel halini yükleyip tekrar dene.",
  "copy.4d9c0ce92710": "İstek güvenli biçimde yinelenemedi. İşlemi yeniden başlat.",
  "copy.3a3c12e12293": "Aynı işlem hâlâ sürüyor. Kısa süre sonra yeniden dene.",
  "copy.a99421654cb2": "Listedeki bazı kayıtlar artık mevcut değil. Listeyi yenile.",
  "copy.31bc0356a1f2": "Seçilen proje bulunamadı.",
  "copy.6dbd7caa28b9": "Projenin hedef tarihi başlangıç tarihinden önce olamaz.",
  "copy.55101a434922": "Rutinin bitiş tarihi başlangıç tarihinden önce olamaz.",
  "copy.eb3c89088cba": "Bitiş tarihi başlangıç tarihinden önce olamaz.",
  "copy.c9f48253f21e": "Seçilen tarih aralığı çok geniş.",
  "copy.d3da6ac68787": "Zaten devam eden bir odak oturumu var.",
  "copy.b2451eb290f2": "Bu odak oturumu daha önce tamamlanmış.",
  "copy.9f28c77266f0": "Bu kayıt daha önce başka bir öğeye dönüştürülmüş.",
  "copy.24b3417c7991": "Yerel veri güncelliğini yitirdi. Yeniden eşitleme gerekiyor.",
  "copy.1bbfacaf52ac": "Tablo şeması başka bir yerde güncellendi. Güncel sürümü yükleyip yeniden dene.",
  "copy.dfd828ce9648": "Şema değişikliği mevcut alan sözleşmesiyle çakışıyor.",
  "copy.d7c79850987c": "Düzenlemek istediğin şema taslağı artık mevcut değil.",
  "copy.d392ee8d6c5c": "Bu bağlantı seçilen kayıt türleri arasında kurulamaz.",
  "copy.9e38325184e6": "Bu kayıt için izin verilen bağlantı sayısına ulaşıldı.",
  "copy.2024ae73a2bc": "Bu iki kayıt arasında aynı bağlantı zaten var.",
  "copy.0f9c0f87258d": "Tek işlemde izin verilenden fazla kayıt gönderildi.",
  "copy.206c75ac5e79": "Bu uygulama sürümü artık desteklenmiyor. Uygulamayı güncelle.",
  "copy.a66f1848dfd8": "Dosya desteklenen bir Exognitos yedeği değil.",
  "copy.30fe16bc36fb": "Yedek dosyası hasarlı veya eksik.",
  "copy.6ddace0f7eca": "Yedek dosyası izin verilen boyutu aşıyor.",
  "copy.72a99d31ccfc": "Geri yükleme için açık onay gerekiyor.",
  "copy.a17c324d6700": "Bu sunucuda tarayıcı bildirimleri yapılandırılmamış.",
  "copy.29d574450a54": "Dönemin bitiş tarihi başlangıç tarihinden önce olamaz.",
  "copy.e5fe4bc69ee9": "Gerekçenin bağlandığı kayıt bulunamadı veya artık mevcut değil.",
  "copy.40fdeba4f745": "Bu yeniden planlama oturumu kapanmış. Yeni bir oturum başlat.",
  "copy.4b0fee1a08c2": "Bu sapma daha önce sonuçlandırılmış. Güncel halini yükle.",
  "copy.8ec85d81583e": "Seçilen gün korumalı bir aralığa denk geliyor. Başka bir gün seç ya da korumayı bilerek geçersiz kıl.",
  "copy.83e3c078ed2a": "Sunucuya ulaşılamadı. Bağlantınızı kontrol edin.",
  "copy.b4c203ba1d0a": "Sunucuda bir sorun oluştu. Birazdan tekrar deneyin.",
  "copy.7fad5c1a42c1": "Aradığın kayıt bulunamadı.",
  "copy.f30ce6821950": "İşlem mevcut kayıtlarla çakıştı. Sayfayı yenileyip tekrar dene.",
  "copy.74f1eed84c64": "Bazı bilgiler geçerli değil. Alanları kontrol et.",
  "copy.dc76c143a8bb": "İşlem tamamlanamadı. Bilgileri kontrol edip yeniden dene.",
  "copy.5ad34b7b9e46": "Bu alan zorunludur.",
  "copy.5331105d3b00": "Geçerli bir e-posta adresi gir.",
  "copy.1f29b340def0": "Bu parola çok yaygın kullanılıyor.",
  "copy.ddf3cd86eb73": "Parola yalnızca rakamlardan oluşamaz.",
  "copy.03ec540fd4cc": "Bu değer geçerli değil.",
  "copy.45a69c97967f": "Parola en az {{value1}} karakter olmalı.",
  "copy.5800d22ccc2b": "Parola kişisel bilgilerine çok benziyor.",
  "copy.c60bd32ff1ec": "Bu alan için girilen değer geçerli değil.",
  "copy.7db8bd713a33": "Sunucuya ulaşılamadı.",
  "copy.643f2c5b4ff3": "İşlem tamamlanamadı.",
  "copy.87cbe59e5f41": "Görev",
  "copy.7b321d627cb1": "Proje",
  "copy.a3cb7fba638e": "Not",
  "copy.e3d25a0d55e8": "Rutin",
  "copy.a3973f7cd7c0": "Hedef",
  "copy.8310d07b9e6c": "Dönem",
  "copy.5ec70189e795": "Bilgi Öğesi",
  "copy.98396a60bb07": "Kavram Haritası",
  "copy.fa8ed0bdabdd": "Plan",
  "copy.4bacae8886aa": "Yaşam Alanı",
  "copy.2eeda58d5020": "Yaşam Tablosu",
  "copy.c335f493996c": "Yaşam Kaydı",
  "copy.5785a01da6e0": "Takvim",
  "copy.baae303c2a0f": "Gün, hafta, ay ve yıl planı",
  "copy.7d03cf59fb3b": "Görevler",
  "copy.58e16151b552": "Tüm görevler",
  "copy.dd14cd6ede95": "Rutinler",
  "copy.aa6a83bfcde1": "Planlar",
  "copy.2f4bf8602006": "Görevleri, rutinleri ve hedefleri bir zaman aralığında birleştir",
  "copy.9cba11f2a318": "Çalışma Masası",
  "copy.4068257604e3": "Çalışma alanına genel bakış",
  "copy.30bcb5bccd3e": "Projeler",
  "copy.cf33e2c6e655": "Planları, görevleri, rutinleri ve bilgiyi bir arada tut",
  "copy.959f1d1df29f": "Notlar",
  "copy.e047cbc6ad0b": "Bilgi Alanı",
  "copy.0603d7e36963": "Koleksiyonlarını ve notlarını tek çalışma yüzeyinde gör",
  "copy.ee541d33413a": "Taslaklar",
  "copy.b634acc71119": "Arşiv",
  "copy.009e9385f1fb": "Çöp Kutusu",
  "copy.b377e5f91efa": "Yaşam Takibi",
  "copy.dda0b6d08a1c": "Anlıkları ve zamana bağlı yaşam kayıtlarını birlikte gör",
  "copy.549645665df6": "Bilgiler",
  "copy.7796f329d977": "Bilgileri ve aralarındaki bağları gör",
  "copy.11e580db2092": "Yaşam Alanları",
  "copy.d1fed43771b2": "Kendi tablo, sütun ve kayıt düzenini kur",
  "copy.67ed883ba47d": "Yaşam Rehberi",
  "copy.4a6c03490a93": "Değer, ilke, düşünce ve sınırlarını kendi yapınla kaydet",
  "copy.6074721d9400": "Dönemler",
  "copy.961304f44e7c": "Analiz",
  "copy.2b0919f10d2e": "Verilerden örüntüler ve sonuçlar çıkar",
  "copy.2d8c97defc9e": "Yeniden Keşfet",
  "copy.d320a13654f8": "Geçmiş",
  "copy.80ad54ad05fa": "Ayarlar",
  "copy.e1a10bdd81df": "Planlayıcı",
  "copy.f86dcfafd6d1": "Planla, uygula ve odaklan",
  "copy.b061c83841e3": "Çalışma",
  "copy.29a87f2ba4f6": "Üretim bağlamları ve odaklı çalışma",
  "copy.26dade3a1507": "Hafıza",
  "copy.0684f4eb38a7": "Bilgiyi yakala, bağla ve yeniden kullan",
  "copy.71317e48f579": "Yaşam",
  "copy.6ba50b24e4ae": "Kendi yaşam verini izle, yapılandır ve anlamlandır",
  "copy.c46cfde0f057": "Verilerden sonuç ve örüntü çıkar",
  "copy.3fc29bcc049b": "Plan Ayrıntısı",
  "copy.a5980e637f70": "Proje Ayrıntısı",
  "copy.4c4df10d00cb": "Görev Ayrıntısı",
  "copy.f03037978607": "Rutin Ayrıntısı",
  "copy.5b2983bb53d0": "Not Düzenleyici",
  "copy.c9a1e072cd88": "Dönem Ayrıntısı",
  "copy.9299e36c6bec": "Çalışma Alanı",
  "copy.1c466db79243": "Sistem",
  "copy.4c5c101be403": "Pzt",
  "copy.59cc0fc7e93e": "Sal",
  "copy.6d46ddd615db": "Çar",
  "copy.89ac4dc9eddf": "Per",
  "copy.5f9967713ae0": "Cum",
  "copy.36986d15c759": "Cmt",
  "copy.3b4ca471d9af": "Paz",
  "copy.c7679d3a2c18": "Her gün",
  "copy.425685711478": "{{value1}} günde bir",
  "copy.a841b044d7ae": "Haftada bir",
  "copy.cd082065cfe1": "Haftada {{value1}} kez",
  "copy.a561ec4066fd": "Bağımsız",
  "copy.20d18d9e162a": "Her yerde gösteriliyor",
  "copy.23752e864336": "Genel listelerde gizli",
  "copy.f015ffefb5c5": "Bağımsız görev",
  "copy.387c05650d00": "Rutinin sıradaki oluşumu",
  "copy.29d2601c1cc3": "Rutinin sonraki oluşumu",
  "copy.374f93c061f6": "Tarihli olduğu için görünür",
  "copy.46bc92eca915": "Planın sıradaki tarihsiz görevi",
  "copy.edca6b60ebec": "Önündeki açık görevler tamamlanınca görünür",
  "copy.7ffb404f5335": "Projenin sıradaki tarihsiz görevi",
  "copy.752080617cc8": "Tamamlanan geçmişinde",
  "copy.dc009da85cbc": "Arşiv geçmişinde",
  "copy.24093ff710a4": "Önünde {{value1}} açık görev var.",
  "copy.f50ee96c17a4": "Genel listelerde görünür",
  "copy.9c7970eec763": "Her yerde göster · {{value1}}",
  "copy.b4403213c392": "Gizle · {{value1}}",
  "copy.fc10d5f347e6": "Otomatik · {{value1}}",
  "copy.532275a1cb66": "Henüz veri yok",
  "copy.03678eb372d7": "Çok kötü",
  "copy.80b78d1e3818": "Kötü",
  "copy.e8d77d452a3b": "Orta",
  "copy.eff9d592c1c0": "İyi",
  "copy.573a921d8664": "Çok iyi",
  "copy.1d71dba89fb1": "Henüz kayıt yok.",
  "copy.86cb1249fd5d": "Bir düğümü seçmek için Enter veya Boşluk tuşuna bas. Seçimi kapatmak için Escape tuşunu kullan.",
  "copy.83891e141c9c": "Bir düğümü seçmek için Enter veya Boşluk tuşuna bas. Ok tuşlarıyla düğümü taşıyabilir, Escape ile seçimi kapatabilirsin.",
  "copy.b87f6b1a3bf7": "Seçili düğüm {{value1}} yönünde taşındı. Yeni konum: {{value2}}, {{value3}}.",
  "copy.26da7e2e0e64": "İlişkiyi seçmek için Enter veya Boşluk tuşuna bas. Seçimi kapatmak için Escape tuşunu kullan.",
  "copy.447cc1d4ba62": "Harita görünüm denetimleri",
  "copy.c2655422772b": "Yakınlaştır",
  "copy.2e4fb0e2949e": "Uzaklaştır",
  "copy.0a8ac1e09e3c": "Haritayı görünür alana sığdır",
  "copy.a1b8c5c2b054": "Harita etkileşimini değiştir",
  "copy.479249dedf9f": "Harita özeti",
  "copy.04e319632d00": "Bağlantı noktası",
  "copy.ec3d96ac7b9e": "Veri görünümü kontrolleri",
  "copy.17233932ffda": "Ara",
  "copy.71dd445d67c3": "{{value1}} kayıt seçildi",
  "copy.132d75b59dc0": "kayıt seçildi",
  "copy.ec8bffdf896f": "Seçimi Kaldır",
  "copy.751b16b2e216": "Sıralamak için taşı",
  "copy.1f1ec06befc3": "Sayfa Dizini",
  "copy.58673ce3348d": "Çalışma alanları ve uygulama bağlantıları",
  "copy.d1369c913096": "Tüm sayfalar",
  "copy.ce62513278b0": "Çalışma alanları",
  "copy.55f65dccaf0e": "Yaşam & düşünce",
  "copy.bc92d677c3c6": "İçeriğe atla",
  "copy.b2b27ec9d43c": "Bir sorun oluştu · Exognitos",
  "copy.fd2dd2868fa0": "Sunucuya ulaşılamadı",
  "copy.7425beb94bea": "Sunucuda bir sorun var",
  "copy.984e2985dfba": "Bir şeyler ters gitti",
  "copy.84a6a839fa04": "Bağlantını kontrol edip tekrar dene. Kaydedilmiş hiçbir şey kaybolmadı.",
  "copy.e2a5508d620d": "Sorun bizde, sende değil. Birazdan tekrar dene.",
  "copy.a07db22fd3a9": "Bu ekran beklenmedik bir durumla karşılaştı. Verilerin yerinde duruyor.",
  "copy.0ce9380b07f8": "Tekrar dene",
  "copy.261b635999f7": "Planlayıcıya dön",
  "copy.239465761503": "Sayfa bulunamadı · Exognitos",
  "copy.bbed3440afef": "Bu sayfa yok",
  "copy.995ef3984833": "Bağlantı eskimiş olabilir ya da içerik silinmiş olabilir.",
  "copy.e2400cb26b87": "Sayfa yükleniyor",
  "copy.443f816b565c": "Küçültülmüş pencereler",
  "copy.d07d06d4e2a6": "{{value1}} penceresini geri aç",
  "copy.3ed7ccf473c8": "Başlıksız",
  "copy.c5a55750f2ce": "Çalışma Masasına dön",
  "copy.203a1579c591": "Proje planına dön",
  "copy.9bb92dc4d3ae": "{{value1}} projesine dön",
  "copy.a88fc2d1c7ea": "Projeye dön",
  "copy.c5ab5d0dc391": "Plana dön",
  "copy.5dc3474f0711": "Göreve dön",
  "copy.f81caa6f480d": "Rutine dön",
  "copy.9c81b243c51c": "Nota dön",
  "copy.76741a32b1d4": "Döneme dön",
  "copy.8355265d008c": "Yaşam kaydına dön",
  "copy.34e1c0595af6": "Geçmişe dön",
  "copy.5aefae4377d6": "Analize dön",
  "copy.49f596f88479": "Bilgi öğesine dön",
  "copy.ca78b719f170": "Kavram haritasına dön",
  "copy.6cbfb2590062": "Projelere dön",
  "copy.1dc4ec2e1967": "Planlara dön",
  "copy.bb285b384f1c": "Görevlere dön",
  "copy.03fabdadb999": "Rutinlere dön",
  "copy.4f1c00ad874e": "Bilgi Ağına dön",
  "copy.b24f012c1869": "Yaşam Rehberi'ne dön",
  "copy.64be65f73da2": "Notlara dön",
  "copy.855e18b676c9": "Günün dairesel planı",
  "copy.4e9016e6ce4a": "Buraya yerleştir",
  "copy.7524e44d4191": "Planlanmış görev",
  "copy.04a13eafafa1": "Taşınıyor",
  "copy.acda530e0d25": "Takvim Öğesi",
  "copy.2b7c2ee34693": "Öğleden sonra",
  "copy.39a8d28c1c6b": "Vazgeç",
  "copy.b910012e68ff": "Bu işlem geri alınamaz.",
  "copy.fbfceccd03c0": "Süre",
  "copy.6b16ec3bfae3": "Süresiz",
  "copy.7bd8b8264c4e": "Özel",
  "copy.81dfbc43b5dd": "Özel süre (dakika)",
  "copy.d0ae62b4ee81": "Nötr",
  "copy.3902002d5818": "Ayrıntı",
  "copy.5ac8da480f5d": "Üst bilgi yok",
  "copy.1279defd4dff": "{{value1}} üst bilgi daha",
  "copy.e7162b9c2884": "üst bilgi daha",
  "copy.7b31a9fc4816": "Kapat",
  "copy.c1fe2ecdff02": "Kaydet",
  "copy.5914f47999f8": "Kaydedilmemiş değişiklikler var.",
  "copy.7b294c635e76": "Düzenlemeye Dön",
  "copy.7696d78c4ec1": "Değişiklikleri At",
  "copy.8738e52615b2": "Kayıt ayrıntısı",
  "copy.e462ec557398": "Ayrıntıyı küçült",
  "copy.40a89eeb71ab": "Ayrıntıyı Kapat",
  "copy.a44a14bc618a": "Bağlı kayıtları gizle",
  "copy.8d7a3495dbfe": "Bağlam filtresi açıkken yalnızca bu bağlama ait kayıtlar gösterilir.",
  "copy.11a9cad73496": "Görsel tema",
  "copy.694af45beeaa": "Seçim bu tarayıcıda saklanır ve tüm arayüze anında uygulanır.",
  "copy.4c6b4fc770bb": "{{value1}} temasını seç",
  "copy.45957ab68170": "Etkin tema:",
  "copy.6b65f1920bb2": "Geri al",
  "copy.fc2cbca9acbe": "Bildirimler",
  "theme.light": "Açık",
  "theme.mint_breeze.label": "Nane Esintisi",
  "theme.mint_breeze.description": "Ferah, sakin bir görünüm için soğuk nane ve yumuşak tonlar.",
  "theme.paper_glow.label": "Kağıt Işıltı",
  "theme.paper_glow.description": "Sıcak, kağıt gibi bir doku ve yumuşak şeftali vurgu renkleri.",
  "theme.sandstone_rose.label": "Kumtaşı Gülü",
  "theme.sandstone_rose.description": "Nazik gül ve sıcak kil tonlarıyla ferah bir zemin.",
  "theme.sunset_amber.label": "Alacakaranlık Amber",
  "theme.sunset_amber.description": "Sakin, amber ağırlıklı gece öncesi hava ve net kontrast.",
  "theme.lavender_veil.label": "Menekşe Sis",
  "theme.lavender_veil.description": "Berrak kontrastla yumuşak menekşe katmanları.",
  "theme.ocean_mist.label": "Okyanus Buğu",
  "theme.ocean_mist.description": "Derin mavi-yeşil sis ve keskin deniz aksanları.",
  "theme.forest_night.label": "Orman Gecesi",
  "theme.forest_night.description": "Topraklı ve dingin bir hissiyat için koyu orman yeşili palet.",
  "theme.midnight_cobalt.label": "Gece Kobaltı",
  "theme.midnight_cobalt.description": "Yoğun kobalt arka plan, canlı vurgu renkleriyle.",
  "theme.copper_rust.label": "Bakır Pas",
  "theme.copper_rust.description": "Sıcak bakır-kahverengi tonlarıyla güçlü bir görünüm.",
  "theme.choice": "{{label}} tema",
  "language.label": "Dil",
  "language.description": "Dil tercihin bu cihazda saklanır. Tema, saat dilimi ve verilerin değişmez.",
  "time.minutes_short": "{{count}} dk",
  "time.hours_short": "{{count}} sa",
  "time.minutes_one": "{{count}} dakika",
  "time.minutes_other": "{{count}} dakika",
  "time.hours_one": "{{count}} saat",
  "time.hours_other": "{{count}} saat",
  "time.just_now": "az önce",
  "time.today": "Bugün",
  "time.tomorrow": "Yarın",
  "time.yesterday": "Dün",
  "time.day_after_tomorrow": "Öbür gün",
  "time.last_weekday": "{{weekday}} (geçen)",
  "time.days_overdue_one": "{{count}} gün gecikti",
  "time.days_overdue_other": "{{count}} gün gecikti",
  "time.due_today": "Bugün son",
  "time.due_tomorrow": "Yarın son",
  "time.due_on": "{{date}} son",
  "time.good_night": "İyi geceler",
  "time.good_morning": "Günaydın",
  "time.good_day": "İyi günler",
  "time.good_evening": "İyi akşamlar",
  "native.sign_in": "Exognitos'a giriş yap",
  "native.sign_in_description": "Exognitos sunucuna bağlan. Giriş tarayıcıda yapılır ve erişim onayın istenir.",
  "native.server": "Exognitos sunucusu",
  "native.server_hint": "API v4 çalıştıran sunucunun HTTPS adresini kullan.",
  "native.local_server_hint": "Bu test sürümü, yalıtılmış yerel sunucu için localhost adresini de kabul eder.",
  "native.connection_error": "Bağlantı veya yetkilendirme başarısız. Sunucu adresini ve yerel uygulama OAuth yapılandırmasını kontrol edip yeniden dene.",
  "native.waiting": "Tarayıcıda girişi tamamlayıp buraya dön.",
  "native.continue_browser": "Tarayıcıda devam et",
  "native.retry": "Yeniden dene",
  "native.authority_notice": "Bazı hesap, arama, koleksiyon, arşiv ve gözden geçirme işlemleri web uygulamasını gerektirir. Bu uygulama sunucunuzun erişim izinlerine uyar.",
  "copy.699b4a551d76": "Genel Bakış",
  "copy.1d5b5f2fb570": "Eğilimler",
  "copy.75cf28d95789": "Sapmalar",
  "copy.9b93ee902529": "Aynı bağlamda birden fazla sapma kaydedildi.",
  "copy.c0d83b327132": "Planlanan ve gerçekleşen süre birlikte ölçüldü.",
  "copy.56106f8c3c04": "Rutin devamlılığı gerçek oluşumlardan hesaplandı.",
  "copy.1d39fe4c3871": "Sayısal yaşam kayıtları bu aralık için özetlendi.",
  "copy.42f02731387b": "Yazılmış ruh hâli ve enerji kaydı ölçüme katıldı.",
  "copy.ca07eb82fb55": "Tarihli yaşam kayıtları ölçüme katıldı.",
  "copy.2db63f1d98f1": "Bu aralıkta kaydedilmiş sapma yok.",
  "copy.2ade08ae6b1a": "Aynı sapma koşulu birden fazla kez kaydedildi.",
  "copy.64769a49a981": "Sonucu henüz kaydedilmemiş sapmalar bulunuyor.",
  "copy.0364504faab3": "Bazı sapmaların koşulu belirtilmemiş.",
  "copy.7f51bf511c20": "Bu tarih için etkin bir dönem bulunmuyor.",
  "copy.8381409980cd": "Bu tarih için etkin bir proje bağlantısı bulunmuyor.",
  "copy.0b28eaaa77e8": "Bu tarih için planlanmış görev bulunmuyor.",
  "copy.1009134016cb": "Planlanan süre kullanılabilir süreyi aşıyor.",
  "copy.72de145888c6": "Bir görev birden fazla kez yeniden zamanlandı.",
  "copy.2d1e1205df1c": "Çok Düşük",
  "copy.4e6fff651df2": "Çok İyi",
  "copy.fd3d95cea97b": "Güven",
  "copy.6d1683d52eef": "Mesafe",
  "copy.4601f9a1d3c4": "Diz ağrısı",
  "copy.6b2c64c33c7d": "Sayfa",
  "copy.4151250b6689": "Uyku süresi (saat)",
  "copy.98a3d97c81d6": "Adım",
  "copy.696bcfffe839": "Su tüketimi (litre)",
  "copy.f10033600f55": "Kilo (kg)",
  "copy.d17e14562cbb": "Sayısal alan",
  "copy.484e8fa0f70a": "kaydedilmemiş",
  "copy.3acbd1590a90": "Aynı bağlam",
  "copy.8141adb3a99e": "{{value1}} bağlamında birden fazla sapma kaydedildi.",
  "copy.f3d3bf8d2c18": "{{value1}} bağlamında {{value2}} sapma kaydedildi.",
  "copy.519982f3d8bb": "Takvimde {{value1}} planlandı; odakta {{value2}} kaydedildi.",
  "copy.84a19fe29091": "Rutin devamlılığı gerçek görev oluşumlarından ölçüldü.",
  "copy.96f9d2806fba": "{{value1}} oluşumun {{value2}} tanesi tamamlandı; {{value3}} atlandı, {{value4}} bekliyor.",
  "copy.b449abf000ef": "kayıtlar",
  "copy.14af565f2265": "{{value1}} kayıt",
  "copy.ed2e844e2fae": "{{value1}} alanındaki {{value2}} ölçüme katıldı.",
  "copy.3675817f5631": "{{value1}} alanındaki {{value2}} ölçüme katıldı; ortalama {{value3}}.",
  "copy.14159b3c3448": "Seçilen günde",
  "copy.ee6de1dbafb9": "yazılı kayıtlar",
  "copy.97fcd63cf9f0": "{{value1}} yazılı kayıt",
  "copy.8e415df86bf9": "{{value1}} tarihinde {{value2}} ölçüme katıldı; enerji kaydı yok.",
  "copy.e6b4ee44bac5": "{{value1}} tarihinde {{value2}} ölçüme katıldı; yazılmış enerji ortalaması {{value3}} / 5.",
  "copy.344b7835a532": "Yaşam kaydı",
  "copy.f5b64ff49d36": "{{value1}} kayıtları ölçüme katıldı.",
  "copy.982c6f38d5d6": "{{value1}} {{value2}} kaydı ölçüme katıldı.",
  "copy.5e4a238aadec": "{{value1}} kayıtlı zaman penceresini aştı.",
  "copy.70a9d46755bf": "{{value1}}, kayıtlı zaman penceresini {{value2}} gün aştı.",
  "copy.ff03194dc047": "{{value1}} kayıtlı başlangıç penceresi geçtiği hâlde başlamadı.",
  "copy.eea14284812e": "{{value1}}, kayıtlı başlangıç penceresi {{value2}} gün önce geçtiği hâlde başlamadı.",
  "copy.20577048b0e8": "{{value1}} projesinde yakın zamanda kayıtlı hareket yok.",
  "copy.10951f1553bf": "{{value1}} projesinde {{value2}} gündür kayıtlı hareket yok.",
  "copy.2b44d498d4f1": "{{value1}} bağlamında ölçülebilir bir ayrışma var.",
  "copy.5c5336d36545": "Kaynak kayıtlarda ölçülebilir bir ayrışma bulundu.",
  "copy.c949e5056385": "Takvim Yerleşimi",
  "copy.9afc2661b32a": "Odak Oturumu",
  "copy.7e66fc1eda75": "Günlük Kaydı",
  "copy.5fd08a10a4ff": "Plan Sapması",
  "copy.344c6690297b": "Tanımlanamayan Kaynak",
  "copy.3d843d6e3095": "{{value1}} kaynağını aç",
  "copy.8967bf5f1528": "Bu kayıt türünün henüz ayrı bir ayrıntı sayfası yok.",
  "copy.5f9a33e8602e": "— ayrı bir ayrıntı sayfası yok",
  "copy.f7ac9438c7ac": "Bu bulgu için açılabilir tekil kaynak kaydı bulunmuyor.",
  "copy.92c0ad8f65cb": "Dayanaklar (",
  "copy.194083615c73": "kayıt)",
  "copy.fe9500ac9e85": "Bulgunun dayanakları",
  "copy.0c296d035246": "Dayanaklar",
  "copy.e118d133ba8b": "Henüz bulgu yok",
  "copy.3a5cf1bd20f0": "Yeterli gerçek kayıt oluştuğunda ölçülebilir bulgular burada görünür.",
  "copy.063a8f65a3f6": "Analiz görünümü ve tarih aralığı",
  "copy.296ccc7ac21e": "Başlangıç",
  "copy.b649bea15b42": "Bitiş",
  "copy.b7b6b66d6c2e": "Analiz Görünümü",
  "copy.eb85025f57e9": "Şimdiki Durum",
  "copy.a747cea0c329": "{{value1}} tarihindeki kanonik bağlam",
  "copy.5e1e575acb6b": "Bu tarihle kesişen dönem veya etkin proje yok",
  "copy.e230256f8ba5": "Bu bir eksiklik puanı değildir; yalnızca kayıtlı bağlamın şu an boş olduğunu gösterir.",
  "copy.e3abcbedc634": "Veri Kapsamı",
  "copy.27d35a2e26a5": "Eksik değerler sıfıra çevrilmez",
  "copy.af961eb8d285": "Gözlenen Satır",
  "copy.10e6f00b7502": "Kayıtlı Dayanak",
  "copy.cd24803b7cff": "Kayıt bulunmayan kaynaklar: {{value1}}.",
  "copy.b1f72c2a7760": "Seçilen aralıkta ölçülen kaynaklarda açık bir veri boşluğu yok.",
  "copy.dbc593009c51": "Yakın Gelecek",
  "copy.b9474df99b17": "Önümüzdeki 30 günde başlayan dönemler ve tarihli görevler",
  "copy.3eefd413ee4a": "İlerisi",
  "copy.20fa3d48d99a": "Sonraki 12 ay içinde başlayan kayıtlı dönemler",
  "copy.259075025473": "Dikkat Alanı",
  "copy.41f396a42da5": "Yorum değil; tarih veya yerleşim durumundan türetilen gözlemler",
  "copy.09fe9088c99f": "Tarihe bağlı açık gözlem yok",
  "copy.228217a1e3b8": "Rehber Bağlantıları",
  "copy.cd91cdc72b84": "Yalnız açıkça kurulmuş ilişkiler; neden-sonuç çıkarımı yapılmaz",
  "copy.57a8267df748": "Açık ilişki kaydı yok",
  "copy.ea8a2740a284": "Bağlantılar oluşturulduğunda kaynak ve hedefleri burada birlikte görünür.",
  "copy.cef049823785": "Büyüyebilen kayıt kümeleri sayfalar hâlinde yüklenir.",
  "copy.fd7d07094dc1": "Daha Fazla Kayıt Getir",
  "copy.573e90743b12": "Bu ufukta kayıt yok",
  "copy.0caf9a767222": "{{value1}} ayrıntısını aç",
  "copy.4784133a2fe1": "Kayıtlı görev tarihi geçti",
  "copy.23dc5f94a13a": "Kayıtlı görev tarihi yaklaşıyor",
  "copy.f6437feca11e": "Zaman çizgisine yerleştirilmemiş dönem",
  "copy.ca04b86cecd5": "Kayıtlı gözlem",
  "copy.95a1a1eb1c15": "Planlanan Süre",
  "copy.88f63ff8f47f": "Odak Süresi",
  "copy.6a43e17f4f05": "Tamamlanan Görev",
  "copy.d72fe8884788": "Kayıtlı Sapma",
  "copy.2b15be480619": "Tamamlanan Rutin",
  "copy.aec60a8ea768": "Ortalama Enerji",
  "copy.5aef8bcda265": "Zaman Eğilimi",
  "copy.194b188bc9a3": "Planlanan süre ve gerçek odak süresi",
  "copy.72a4b79c5bf7": "Yetersiz veri",
  "copy.593d3fe06c7e": "Eğilim göstermek için bu tarih aralığında daha fazla plan ve odak kaydı gerekiyor.",
  "copy.66b695b479e7": "Üst çizgi planlanan süreyi, alt çizgi gerçek odak süresini gösterir.",
  "copy.f1b7a9e2b978": "Bulgular",
  "copy.3687c5cb487d": "Rutin Devamlılığı",
  "copy.61f0c68a3576": "Beklenen ve gerçekleşen rutin görevleri",
  "copy.ef196020d311": "{{value1}} atlandı · ",
  "copy.c12aa0229d2a": "bekliyor",
  "copy.9d506c74dd6c": "Sayısal Yaşam Alanları",
  "copy.c87862b6bf93": "Tarihli yaşam kayıtlarındaki ölçümler",
  "copy.f217f705fd62": "kayıt ·",
  "copy.0dd43d35b19a": "Ortalama",
  "copy.fd54ce5b9748": "Ruh Hâli ve Enerji",
  "copy.8fdeeb6f88ef": "Yalnız kullanıcının yazdığı günlük kayıtları",
  "copy.9c750b75af2e": "Enerji kaydı yok",
  "copy.c7719dae5c2b": "Yaşam Kayıtları",
  "copy.ac31649e2ee1": "Bu aralıktaki tarihlenmiş kayıt adetleri",
  "copy.d324292349b1": "Planlanan ve Gerçekleşen",
  "copy.51223baa29e4": "Eksik süreler sıfır sayılmaz",
  "copy.f3f9b0259529": "Karşılaştırılabilir süre yok",
  "copy.3eb8bbc406d0": "Takvim süresi veya tamamlanmış odak kaydı oluştuğunda burada görünür.",
  "copy.a82544bb3657": "Kaynaklı Bulgular",
  "copy.87458bca1155": "Sapmalar kaydedilmiş gerçeklerden türetilir",
  "copy.e4d81304ba80": "Tekrar Eden Durumlar",
  "copy.c3855400049f": "Sıralama bir öneri veya puan değildir",
  "copy.1194b8be7571": "Kayıtlı sapma yok",
  "copy.3c3d5749f0fe": "Planlayıcıda sapma kaydedildiğinde neden dağılımı burada görünür.",
  "copy.6317eac1d512": "Belirtilmemiş",
  "copy.316286aea87b": "Bu döneme haftalık bir süre ayrılmamış, bu yüzden içindeki iş bir uzunluğa çevrilemiyor.",
  "copy.9468d201fb20": "Tekrar eden işler haftada {{value1}} tutuyor; ",
  "copy.a3bb29ba1318": "haftalık bütçe {{value1}}. Tek seferlik işe yer kalmıyor.",
  "copy.2910bab29902": "Tahmini tek seferlik iş, açıklanan haftalık hızda yaklaşık {{value1}} hafta ",
  "copy.ca8a928aa918": "sürüyor ({{value1}} tahminli görev).",
  "copy.d9c87f0b0151": "Zaman çizgisinde çizilen pencere {{value1}} haftalık kesin zaman.",
  "copy.48670957fdb8": "Bu, işin topladığı süreden {{value1}} hafta daha az.",
  "copy.dff2ee89e800": "{{value1}} görevin tahmini yok; toplamlara dahil edilmedi.",
  "copy.f8df5456119a": "{{value1}} rutinin süresi yok; haftalık yüke dahil edilmedi.",
  "copy.354bfd95e5d0": "Aktif bir Yaşam Rehberi kaydı yok; çalışmaların bağlanacağı üst ölçek henüz tanımlanmamış.",
  "copy.c74bd57b27ca": "{{value1}} gününü kapsayan bir dönem yok; bu gün daha büyük hiçbir şeye ait değil.",
  "copy.afaf741ff611": "Bu güne {{value1}} iş planlanmış ama hiçbir dönem bu günü sahiplenmiyor; ",
  "copy.a2a4c1380a39": "günün işi daha uzun vadeli hiçbir şeye bağlanamıyor.",
  "copy.6323ec5ae9a0": "Bu güne takvimde bir şey yerleştirilmemiş.",
  "copy.7851760053ab": "Bu günü kapsayan bir dönem korumalı dinlenme olarak işaretli.",
  "copy.655acd482ec9": "Bugünkü işlerin hiçbiri bir Yaşam Rehberi kaydına bağlı değil; ",
  "copy.16a5a0e0e929": "bu yüzden bu gün ne için olduğunu söyleyemiyor.",
  "copy.7b97c112fd51": "Bugün takvime yerleştirilen işler şunlara dokunuyor: {{value1}}.",
  "copy.1e808629eebc": "Gün {{value1}} fazla yüklü.",
  "copy.11018460e9df": "Plan sığıyor ama neredeyse hiç boşluk bırakmıyor.",
  "copy.92d79fac35b4": "{{value1}} takvim işi, günün kalanına artık sığmıyor.",
  "copy.3e667ff7256f": "Bugün takvime yerleştirilen her şey yapılmış.",
  "copy.4eba3c1dbd69": "Korumalı dinlenme olarak işaretli bir dönemin içine iş planlanmış: {{value1}}.",
  "copy.e5db616b8247": "Bu gün katı bir korumalı pencerenin içinde: {{value1}}.",
  "copy.86b0c38656a8": "Bu gün zaten fazla yüklü.",
  "copy.28c3342258ae": "Yalnızca {{value1}} boş; bu iş {{value2}} istiyor.",
  "copy.10a04d3b82e9": "Burada duran işlerden {{value1}} tanesi kaydırılabilir; ",
  "copy.985fd90fbf9f": "taşınırsa {{value1}} açılır.",
  "copy.b7cff901f682": "Bu gündeki {{value1}} sabit taahhüt taşınamaz.",
  "copy.a10aaa33ec2b": "Bu işin zincirindeki bir katman korumalı işaretli; taşımak daha önce verilmiş bir karara aykırı.",
  "copy.7dfa9838ecea": "Bu işin gerekçesi zamanlamasının sabit olduğunu söylüyor.",
  "copy.2a341eb18771": "Yapılmazsa: {{value1}}",
  "copy.6133f0807b52": "En az hâli: {{value1}}",
  "copy.81b65fd6c3cb": "Bu işin zincirinde neden var olduğu hiçbir yerde yazmıyor; ",
  "copy.9422ff8c3b16": "bu taşımayı tartacak kayıtlı bir dayanak yok.",
  "copy.a7076ba728da": "Bu aralıkta kayıtlı bir plan sapması yok.",
  "copy.1bc02f40bf84": "En sık kaydedilen durum '{{value1}}' oldu, {{value2}} kez.",
  "copy.26bc24b31e8e": "{{value1}} sapma hâlâ kararsız.",
  "copy.b7e837ef59e8": "'{{value1}}' bu aralıkta {{value2}} kez saptı.",
  "copy.a1b8e0fa4c5e": "{{value1}} sapmanın {{value2}} tanesinde durum kaydedilmemiş; ",
  "copy.a0408b5ebf7f": "bu yüzden yukarıdaki sayımların dışında.",
  "copy.bec111a03f58": "Henüz kayıtlı bir Yaşam Rehberi kaydı yok.",
  "copy.b5245233af13": "Son {{value1}} günde {{value2}} aktif Yaşam Rehberi kaydının ",
  "copy.6fd14fb5ada1": "{{value1}} tanesine takvimdeki hiçbir iş işaret etmedi.",
  "copy.23a84669b07a": "Son {{value1}} günde {{value2}} değerin ",
  "copy.579cba010278": "{{value1}} Yaşam Rehberi kaydı hiçbir gerekçe tarafından referans alınmıyor; ",
  "copy.b5c3e0e0b20a": "bu yüzden hiçbir şey onlara işaret edemezdi.",
  "copy.a204852333db": "{{value1}} değer hiçbir işe ya da gerekçeye bağlı değil.",
  "copy.3850d2f9d5b8": "Kayıtlı her Yaşam Rehberi kaydına işaret eden bir iş vardı.",
  "copy.293d5b1aa033": "Kayıtlı her düşünme oturumu damıtılmış.",
  "copy.8a23cc20edef": "{{value1}} düşünme oturumu damıtılmadı. En eskisi {{value2}} ",
  "copy.c464c1ada355": "tarihinde başlamış.",
  "copy.56ba1b4212e8": "Bunların {{value1}} tanesi yapay zekâ konuşmasıydı; kendilerinden geriye bir şey bırakmazlar.",
  "copy.b318dcb978db": "sağlık",
  "copy.7e4f926c3ad8": "başka iş",
  "copy.02b15c6e3b82": "dış talep",
  "copy.9529971f2657": "sosyal çekim",
  "copy.389dc4ac4cea": "bölünme",
  "copy.f2800545f5c6": "yanlış ortam",
  "copy.a832ec323637": "belirsiz ilk adım",
  "copy.eab25f465c20": "aşırı dolu gün",
  "copy.72c12a1bcb29": "dürtü",
  "copy.fc0f08491017": "zamanı kaçırma",
  "copy.0b43fef81114": "fikir değişikliği",
  "copy.6cceb6797962": "Diğer",
  "copy.74a138bb214e": "{{value1}} tarihinde başlar",
  "copy.1bc5d1757c18": "Tarih aralığı yok",
  "copy.3e5935f82e60": "Proje planları yüklenemedi",
  "copy.38121313783e": "Yol haritası mevcut Plan kayıtlarından oluşturuluyor.",
  "copy.243127822c10": "Bu projede henüz uygulama yolu yok",
  "copy.709244e9bc0c": "Bir Plan oluştur veya projeye ilk görevini ekle; yol haritası bunlardan kendiliğinden oluşur.",
  "copy.f986b9614445": "Plan Oluştur",
  "copy.c91aba09216b": "Görev Ekle",
  "copy.dcd046ec2dbc": "Yol haritası",
  "copy.a096c030358a": "plan ·",
  "copy.d1b13d4a8f86": "görev",
  "copy.00d5877e44d8": "{{value1}} yol haritası bölümü",
  "copy.6e2a79f55473": "Bu plan henüz görev içermiyor.",
  "copy.407e36e98956": "Plansız görevler yol haritası bölümü",
  "copy.ff31f68d2e4e": "Plansız Görevler",
  "copy.57f71ccb1495": "{{value1}} planını aç",
  "copy.e369bc68f28f": "{{value1}} planını kapat",
  "copy.a5dad7f25733": "{{value1}} planına görev ekle",
  "copy.9c8dc1cf5b36": "{{value1}} bölümünü aç",
  "copy.1a8c381978b5": "{{value1}} bölümünü kapat",
  "copy.b82be70f7b41": "Plan bağlantısı olmayan proje görevleri",
  "copy.d9213c57bd8f": "Plansız Görev",
  "copy.f7bbb5f5f938": "{{value1}} yol haritası satırı",
  "copy.221b0d54eba1": "{{value1}} rutin tarafından üretildiği için sırası sabittir",
  "copy.67ff73739d5f": "{{value1}} görevini yol haritasında taşı",
  "copy.d95ff01826ea": "Tamamla",
  "copy.402abf10461d": "{{value1}} görev seçenekleri",
  "copy.3016b062babe": "Yol haritası bölümü",
  "copy.ee1cd50e9422": "Otomatik",
  "copy.8ef99fb122d4": "Sonraki eylemden çıkar",
  "copy.85d47e334f73": "Sonraki eylem yap",
  "copy.73c20fa761c3": "Kuluçkada",
  "copy.41d1408114e4": "Sırada",
  "copy.9025b4af025a": "Bekliyor",
  "copy.358761a6d440": "Bırakıldı",
  "copy.863970dc7976": "Yavaş",
  "copy.03ce5e32d829": "İstikrarlı",
  "copy.d5fc8b35a698": "Güçlü",
  "copy.a7b0faa129e1": "Projeler yüklenemedi",
  "copy.a0c660e99ca9": "Projelerine şu anda ulaşılamıyor.",
  "copy.f89cb491abf6": "Yeni Proje",
  "copy.c1d13d7c2006": "Sabit çalışma bağlamı",
  "copy.de7a323e3316": "Sabit Çalışma Bağlamı",
  "copy.a8a6638f858e": "Sabitlemeyi Kaldır",
  "copy.1470a04d04f5": "Sabit Proje bulunamadı",
  "copy.d5d743df7db3": "Daha önce sabitlenen Proje etkin listede bulunmuyor; arşivlenmiş, tamamlanmış veya kaldırılmış olabilir. Sabitleme kendiliğinden temizlenmedi.",
  "copy.41c371264c71": "Eski Sabitlemeyi Temizle",
  "copy.4605a3f88446": "Proje Listesi",
  "copy.82a9662f058f": "Proje listesi filtreleri",
  "copy.8f93ad45246c": "Proje Görünümü",
  "copy.f5f4274fb83a": "Izgara",
  "copy.82bc3b799a70": "Proje Kapsamı",
  "copy.f43a65ad8268": "Tümü",
  "copy.db43eb3a415c": "Bekleyen",
  "copy.9f69ace7d31c": "Sessiz",
  "copy.7aa2f0cd1743": "Henüz proje yok",
  "copy.cff38bcaeb76": "Yürüttüğün işi bir proje olarak kur; bağlamını değerlerinle ilişkilendir.",
  "copy.5b1cbf5f0da1": "Proje Oluştur",
  "copy.71f8ea0c4304": "Bu kapsamda proje yok",
  "copy.ccf6d08b16aa": "Seçili kapsam şu anda boş. Tümü'ne dönerek bütün projeleri görebilirsin.",
  "copy.684b63183ab9": "Tümünü Göster",
  "copy.6963914f2d1d": "Sıradaki görev",
  "copy.442afc0cf1b8": "Devam adımı",
  "copy.d1ac5a241441": "Sonraki adım",
  "copy.1b3bff965d67": "Henüz belirlenmemiş",
  "copy.172b7d4d339b": "Henüz etkinlik yok",
  "copy.fd0a1d3aca32": "Bugün etkinlik var",
  "copy.922273f761ca": "{{value1}} gün önce etkinlik",
  "copy.57dc2f7e8008": "Süregelen",
  "copy.2202120a7050": "Sabit Bağlam",
  "copy.aa84ba71b83e": "Bugün Takvimde",
  "copy.a8fccb947f36": "açık görev",
  "copy.5e2de63aa88b": "{{value1}} projesinde çalış",
  "copy.2fa8031dc345": "Çalış",
  "copy.c8def36b1e87": "{{value1}} proje işlemleri",
  "copy.9427ff3c9348": "Çalışma Bağlamı Olarak Sabitle",
  "copy.d74672c7a485": "{{value1}} projesini sırala",
  "copy.f5c3d31594e2": "açık",
  "copy.d11adcf86204": "Gerekçe",
  "copy.551dcd000b65": "Hedef Tarihi",
  "copy.342e3acf41bd": "Kayıt tamamlanamadı. Girdilerin korundu; yeniden deneyebilirsin.",
  "copy.17365728fdeb": "Yeni Hedef",
  "copy.b3c4dd8fb911": "Yeni Karar",
  "copy.3db72c32a531": "Kaydı Düzenle",
  "copy.dde0156891d6": "Kayıt tamamlanamadı. Yeniden deneyebilirsin.",
  "copy.c52a645e2e52": "Hedef tarih başlangıçtan önce olamaz.",
  "copy.f08d0ac673b6": "Projeyi düzenle",
  "copy.54bdf889f3b7": "Yeni proje",
  "copy.1cff8a95c840": "Tür",
  "copy.5d2de8a024e9": "Proje Türü",
  "copy.8b1d8ef85a5c": "Sonlu",
  "copy.b45241034f39": "Bir sonu var. İlerleme, tamamlanan adımların yüzdesiyle gösterilir.",
  "copy.df2e77d167d2": "Bitmez, sürer. Yüzde anlamsız olduğu için ilerleme yerine ivme gösterilir.",
  "copy.bfc1b3ab3841": "Başlangıç tarihi",
  "copy.bcfa426cc696": "İsteğe bağlı.",
  "copy.2606f5319785": "Hedef tarih",
  "copy.b69c98ecf1ff": "Başlangıç durumu",
  "copy.61bb51ce89c0": "Bu proje ne?",
  "copy.11fa42d8d90f": "Aylar sonra döndüğünde bunu okuyacaksın.",
  "copy.18e58c7f199e": "Boş bırakılırsa nötr renk kullanılır.",
  "copy.7c8913909479": "Hazırlıkta",
  "copy.bc54ef813b1f": "Vazgeçildi",
  "copy.047c2449e34f": "Taslağa taşı",
  "copy.07d3d48ca151": "Hazırlığa al",
  "copy.961372575881": "Sıraya al",
  "copy.408ea7f6cf64": "Etkinleştir",
  "copy.f833e2ee282f": "Beklemeye al",
  "copy.2a095c3cabfc": "Projeyi tamamla",
  "copy.33b676b0f6bc": "Vazgeçilmiş olarak işaretle",
  "copy.3b160a96f171": "Proje yüklenemedi",
  "copy.afe760df18ad": "Proje bağlamına şu anda ulaşılamıyor.",
  "copy.d612732f3b38": "gündür sessiz",
  "copy.3daf2fff2c2c": "Çalışmaya Başla",
  "copy.191b0603d4f0": "Odağı Aç",
  "copy.e1c82b244d81": "Sessizlik Uyarısını Gizle",
  "copy.1ec7d153bbba": "Proje arşivlendi",
  "copy.e06a6ae0d6e1": "Proje durumu:",
  "copy.735cc1089609": " Son etkinlik {{value1}} gün önce.",
  "copy.ee032de9519b": "Plan ve Görevler",
  "copy.abbbdafe41fa": "Bilgi",
  "copy.cafb2d991bbe": "Kayıtlar",
  "copy.1ab7d4e05916": "Proje alanları",
  "copy.dc1584411506": "Proje nabzı",
  "copy.0da445e7ea0c": "%{{value1}} tamamlandı",
  "copy.88a93acfd287": "adım tamam",
  "copy.91153b6dcd8d": "Süregelen ivme",
  "copy.0ecb87dea952": "Son 14 günün etkinliği",
  "copy.709f61be9264": "Açık iş",
  "copy.6b8109fda8f4": "Toplam odak",
  "copy.b285e093161c": "son 30 gün",
  "copy.a7e8918bb093": "Son hareket",
  "copy.1f77b946be71": "Henüz yok",
  "copy.5f0449fb0881": "Son 14 gün",
  "copy.d3a509cbb45a": "Son 14 günde kayıtlı hareket yok",
  "copy.aaea24fd087c": "Son 14 günün {{value1}} gününde hareket var",
  "copy.45f1df635ca2": "Kayıtlı hareket yok",
  "copy.d67fd1eade7d": "günde hareket",
  "copy.cc84ed58d30c": "Sıradaki Adım",
  "copy.55621d139e10": "Bu projede sırada duran tek somut iş.",
  "copy.49a045dce14b": "Sonraki eylem olarak işaretlendi",
  "copy.ad20041b627c": "Sıradaki açık adım",
  "copy.c8ac517ad54a": "Odağa Al",
  "copy.e214951b92fa": "Sıradaki adım belirlenmemiş",
  "copy.08b7076f76cb": "Plan ve Görevler alanında bir görevi sonraki eylem yapabilirsin.",
  "copy.7e6015a1e7fd": "{{value1}} kayıtlı odak",
  "copy.450e34383453": "Bu projede kayıtlı odak oturumları.",
  "copy.b3f4ab9d9353": "Henüz kayıtlı odak yok",
  "copy.d788d83a1661": "Çalışmaya Başla düğmesi bu projeyi Çalışma Masasında açar; oradan bir odak oturumu başlatabilirsin.",
  "copy.69ee6c35cf67": "{{value1}} odak oturumları",
  "copy.5ba42e6b3117": "Görev odağı",
  "copy.56a1b5e0a0a4": "Proje odağı",
  "copy.52fd74ad0e8c": "Bu projeye ait planlanmış bir zaman bloğu yok.",
  "copy.0f96e260e163": "Rutinler ilerleme değil, pratik içindir.",
  "copy.056888383259": "Bu projeye bağlı rutin yok.",
  "copy.14f044ebc736": "Son Hareketler",
  "copy.1bd447ff7d11": "Uygulama akışı",
  "copy.3ffe851b993c": "Bu projede tekrar eden pratikler. İlerleme yüzdesine katılmazlar.",
  "copy.17e65528e54c": "Rutin Ekle",
  "copy.087b5e1f5458": "Bu projeye bağlı rutin yok",
  "copy.0d0e6b1179c4": "Tekrar eden bir pratiği rutin olarak kur; görevlerden ayrı yürür.",
  "copy.9fe517066f83": "Plan Akışları",
  "copy.9c1e3e4e960c": "Planlar mevcut kayıtlardır; bu alan ikinci bir Plan türü oluşturmaz.",
  "copy.88674a9343cb": "Yeni Plan",
  "copy.65b62fa2a97f": "Bu projede henüz plan yok",
  "copy.38ae071d3d47": "İlk planı burada oluştur; görev ve rutinlerini planın ayrıntısından ekleyebilirsin.",
  "copy.92d52f5436f0": "rutin",
  "copy.5961c82c4566": "Akışı Aç",
  "copy.d7b10601ab66": "Proje Notları",
  "copy.bf8520b6670b": "Notun asıl kaydı Hafıza'da kalır; buradan not çalışma penceresinde açılır.",
  "copy.464553d5a5e5": "Not Penceresini Aç",
  "copy.c859ca9f6287": "Bu projeye bağlı not yok",
  "copy.f9b6af81231d": "Hafıza'daki bir notu proje bağlamına bağladığında burada görünür.",
  "copy.f6e12c702775": "Notları ve haritaları aynı anda açık tutmak için Çalışma Masasını kullan; oradaki not penceresi on sekmeye kadar taşır ve iki notu yan yana gösterebilir.",
  "copy.74e539d03179": "Devam noktası kaydedilemedi. Birazdan tekrar dene.",
  "copy.186be30b87a9": "Nerede kaldım",
  "copy.7398776fb04e": "Eskimiş olabilir",
  "copy.b78b1dfbe6c9": "Bağlamı Düzenle",
  "copy.ebb190623345": "Kaldığın Yerden Devam Et",
  "copy.58401602527e": "Bu proje için henüz bir bağlam notu yok. Çalışmayı bırakırken iki cümle yazmak, döndüğünde en pahalı işi ortadan kaldırır.",
  "copy.8cb8ff0b6679": "Bağlam Ekle",
  "copy.d1d4842118a6": "Devam Noktasını Düzenle",
  "copy.7a16ee08ad5d": "Çalışmaya döndüğünde bağlamı hızla kurabilmek için nerede kaldığını ve ilk adımı kaydet.",
  "copy.e80a64890ef6": "Nerede bıraktım",
  "copy.f7ffe853b913": "Kendi cümlelerinle.",
  "copy.29a4b61730db": "Sonraki somut adım",
  "copy.61c7d5146530": "Döndüğünde ilk yapacağın şey.",
  "copy.4dc58bf18c71": "Girdiğin bilgiler korunuyor.",
  "copy.229131437d95": "Hedefler ve Kararlar yüklenemedi",
  "copy.e507fff9b198": "Kanonik kayıt listesine şu anda ulaşılamıyor.",
  "copy.e17ccb1e9466": "Yeni",
  "copy.46a574f1e9f6": "Henüz {{value1}} yok",
  "copy.37674e1e8aa6": "İlk kaydı oluştur",
  "copy.81b1e645c2af": "{{value1}} kaydını düzenle",
  "analysis.source.planned_minutes": "planlanan süre",
  "analysis.source.focused_minutes": "gerçek odak süresi",
  "analysis.source.completed_tasks": "tamamlanan görevler",
  "analysis.source.routine_expected": "beklenen rutin oluşumları",
  "analysis.source.routine_completed": "tamamlanan rutin oluşumları",
  "analysis.source.journal_entries": "günlük girişleri",
  "analysis.source.average_energy": "bildirilen enerji",
  "analysis.source.life_records": "yaşam kayıtları",
  "analysis.source.recorded_deviations": "kaydedilen sapmalar",
  "analysis.source.unresolved_deviations": "sonuçlandırılmamış sapmalar",
  "analysis.source.unplaced_period_dates": "yerleştirme tarihi olmayan dönemler",
  "analysis.cause.energy": "Enerji yetmedi",
  "analysis.cause.sleep": "Kötü uyku veya fazla uyuma",
  "analysis.cause.health": "Sağlık",
  "analysis.cause.mood": "Duygusal durum",
  "analysis.cause.motivation": "Motivasyon eksikliği",
  "analysis.cause.competing_work": "Başka iş zamanı aldı",
  "analysis.cause.external_demand": "Başkasının zaman ihtiyacı",
  "analysis.cause.social_pull": "Plan yerine insanları seçtim",
  "analysis.cause.interruption": "Kesinti",
  "analysis.cause.wrong_environment": "Uygun olmayan ortam",
  "analysis.cause.missing_input": "Gerekli bir şey hazır değildi",
  "analysis.cause.unclear_next_step": "Sonraki adım belirsizdi",
  "analysis.cause.underestimated": "İş tahmin edilenden büyüktü",
  "analysis.cause.overpacked_day": "Gün fazla doluydu",
  "analysis.cause.impulse": "Bir dürtüyü izledim",
  "analysis.cause.lost_track_of_time": "Zamanın farkına varmadım",
  "analysis.cause.travel": "Yolculuk veya uzakta olma",
  "analysis.cause.changed_mind": "Fikrimi değiştirdim",
  "analysis.cause.not_recorded": "Kaydedilmedi",
  "copy.006ac77b363e": "Varsayılan",
  "copy.51382faca61a": "Vurgu",
  "copy.7186643b6973": "Olumlu",
  "copy.5f2dc55f3010": "Dikkat",
  "copy.56cbcafc5dc7": "Kritik",
  "copy.8b57b7c3fc93": "Seri 1",
  "copy.088c74357a15": "Seri 2",
  "copy.5072edd2c9da": "Seri 3",
  "copy.df4c30dad96c": "Seri 4",
  "copy.9b1b06de1912": "Seri 5",
  "copy.e9efb97603ed": "Seri 6",
  "copy.5aed93824f10": "Sağlık",
  "copy.b6e1d2675f6a": "İnsanlar",
  "copy.be44001fbb93": "Ölçüm",
  "copy.46cdb4c6b7de": "Gözlem",
  "copy.74a0c4ce3e49": "İş",
  "copy.724f88c86b7c": "İlham",
  "copy.e281bb7cdf8c": "Simge yok",
  "copy.7ab8389a3c35": "Teknik Yönetim",
  "copy.3a0c546bc9b0": "Yaşam alanları yüklenemedi.",
  "copy.e5f3a083f846": "Henüz yaşam alanı yok",
  "copy.71dcf8feeb8f": "Yaşam Alanı, birlikte anlamlı olan tabloların üst grubudur. Sistem hazır alan veya örnek kayıt eklemez; neyi takip edeceğine sen karar verirsin.",
  "copy.fe3471c3dbaf": "İlk Alanı Oluştur",
  "copy.af56db355d8d": "{{value1}} · Teknik Yönetim",
  "copy.37639fea53ab": "Alan yapısı, tablolar ve arşiv işlemleri",
  "copy.a15d45f7923b": "Yaşam Teknik Yönetimi",
  "copy.32c8e9ea4f00": "İlişki sözlüğü ve gelişmiş veri yapısı",
  "copy.416fd8570eed": "Veri yapısı",
  "copy.406314516701": "Yeni alan ve tabloları yalnız yapıyı değiştirmek istediğinde oluştur.",
  "copy.24eac4a6e498": "Yeni Alan",
  "copy.79a3ab411803": "Bu yaşam alanı",
  "copy.460246b08dcd": "{{value1}} alanı.",
  "copy.f3504972b527": "Kalıcı alan sayfası",
  "copy.c92458d5623d": "Alanı düzenle",
  "copy.1cc822887fbf": "Teknik bilgiler",
  "copy.43decee4ab33": "Bölüm",
  "copy.38ae403eca98": "Oluşturma kanalı",
  "copy.e030216f29c1": "Revizyon",
  "copy.05366b6aeaa9": "Tablolar",
  "copy.fbfc8d3aa100": "Tablo ekle",
  "copy.10561ce0320d": "Alan tabloları yüklenemedi.",
  "copy.d620f98f53dd": "Bu alanda henüz tablo yok",
  "copy.a78a501abf78": "Alanı geri yükledikten sonra kayıt yapısını kurabilirsin.",
  "copy.e031fc67e4ba": "İlk tabloyu ve sütunlarını tanımlayarak kayıt almaya başla.",
  "copy.79bfffb0e9da": "İlk tabloyu oluştur",
  "copy.e966fdffbd55": "Birincil",
  "copy.986fce6a1bd1": "Sütunlar",
  "copy.7597deca31f0": "Alanı geri yükle",
  "copy.885132eda3a7": "Arşiv ve tehlikeli işlemler",
  "copy.9e4ac22ebc68": "Alan ve tabloları yeniden etkinleştirilecek.",
  "copy.2a2e038322d1": "Alanla birlikte tüm tablolar arşivlenecek. Kayıtlar silinmez ve geri yükleme mümkündür.",
  "copy.6aae37e5c497": "Alanı arşivle",
  "copy.66bbebdd96c0": "Yaşam alanları ve tabloları",
  "copy.edd76b71ac69": "{{value1}} tablolarını kapat",
  "copy.bf7ca3035a97": "{{value1}} tablolarını aç",
  "copy.e35aa22be2b8": "{{value1}} alanını sırala",
  "copy.4066bc5087a5": "tablo ·",
  "copy.2100a9fbe962": "kayıt",
  "copy.8f42f21e0861": "{{value1}} alanına hızlı kayıt ekle",
  "copy.57213045df0f": "{{value1}} seçenekleri",
  "copy.0545ee0386ea": "Teknik yönetim",
  "copy.2b94cca1a1f8": "Tablolar yüklenemedi.",
  "copy.05c5cf40b2d8": "{{value1}} tablosunu sırala",
  "copy.92e5629c0438": "{{value1}} tablosuna hızlı kayıt ekle",
  "copy.90b8aff0a702": "Tablo ayarları",
  "copy.4c6fda4c2194": "Alanı yönet",
  "copy.c3b523e02788": "Son kayıt {{value1}}",
  "copy.d670f9a15e01": "Henüz kayıt yok",
  "copy.81ead8d21995": "Gün ayrıntısı",
  "copy.6ded619e99ac": "{{value1}} gününe dön",
  "copy.26a6c053dd52": "Güne dön",
  "copy.9ccad9eb93d7": "Gün açılamadı",
  "copy.0a2bead0e5a2": "Anlıklar ve Yaşam kayıtları şu anda birleştirilemiyor.",
  "copy.cf12a060f399": "Bu günde kayıt yok",
  "copy.eace9b4a752c": "Kayıt kaldırılmış veya arşivlenmiş olabilir.",
  "copy.7ec2e922e10b": "Günün akışı",
  "copy.e057379d19c8": "Metinsiz Anlık",
  "copy.f3a263703afc": "Adsız kayıt",
  "copy.10a6934fd767": "Aç / düzenle",
  "copy.2fbb343f76d3": "Alt kayıtlar",
  "copy.3e84a55be4d4": "Adsız alt kayıt",
  "copy.d684417157c4": "Gün boyu",
  "copy.db1fc6fe932b": "Yaşam alanı",
  "copy.038fa350cfbe": "Alan ve tablolar yükleniyor…",
  "copy.13143fd5adf9": "Yaşam alanı yükleniyor",
  "copy.693196b298a6": "Alanlara dön",
  "copy.51d0a3039515": "Yaşam alanı açılamadı",
  "copy.3d722e895669": "Kayıt bulunamadı veya bu hesaba ait değil.",
  "copy.ce7d1d42560a": "Rehbere dön",
  "copy.27a1b49c7c8a": "Hızlı Ekle",
  "copy.01a1d73626ce": "Teknik Ayarlar",
  "copy.88e8d06e084f": "Alan görünümü",
  "copy.bc9507f1119e": "Bu tablo için henüz kısa bir açıklama yok.",
  "copy.969541f3a9be": "Aç →",
  "copy.e92f6f072935": "Yönet",
  "copy.57a735d1bc50": "Yaşam tablosu",
  "copy.d1ef4bd752a1": "Tablo ve kayıtlar yükleniyor…",
  "copy.b629dbd292f4": "Yaşam tablosu yükleniyor",
  "copy.d18900b873ac": "Yaşam tablosu açılamadı",
  "copy.aa6a7497da41": "Tablo bulunamadı veya bu hesaba ait değil.",
  "copy.01ebf76b1587": "{{value1}} alanının kayıt tablosu.",
  "copy.fe63913f462d": "Bu yaşam tablosu",
  "copy.b3d96f45800f": "Kayıt ayrıntısı yükleniyor…",
  "copy.e472e7591201": "Yaşam kaydı yükleniyor",
  "copy.d444ab9de681": "Yaşam kaydı açılamadı",
  "copy.1e0c515a265c": "{{value1}} tablosundaki kayıt ayrıntıları.",
  "copy.71a5d0434330": "Kaydı düzenle",
  "copy.62eadbcde5a1": "Bu yaşam kaydı",
  "copy.fb36b18b09f8": "Kayıt bilgileri",
  "copy.f727def4d3ea": "Bu tablo sürümünde gösterilebilecek etkin sütun bulunmuyor.",
  "copy.59987d013169": "Eski sürümden kalan alanlar · {{value1}}",
  "copy.6ff8021ebc21": "Tarih",
  "copy.6e3182c4323e": "Gerçekleşme",
  "copy.450aa8b43828": "Kayıt kökeni ve teknik bilgiler",
  "copy.fe59abe12ce9": "Kanal",
  "copy.d49a6b6a9911": "Tablo sürümü",
  "copy.6b85f191c37d": "Yapısal ve semantik ilişkileri birlikte gör, yeni bir bağlantı kur.",
  "copy.9d119cdc2fad": "Göster",
  "copy.edd22bd7915c": "Doğrudan semantik bağlantılar ve kanonik yapısal ilişkiler birlikte okunur.",
  "copy.09de32e78e2f": "Gizle",
  "copy.641572dd08ef": "Bağlantı ekle",
  "copy.033adbaccbdf": "Bağlantı grafiği yüklenemedi.",
  "copy.51a38ddad35d": "Grafik güvenli sınırda kısaltıldı. Daha dar bir derinlik seçebilirsin.",
  "copy.1894aabd94da": "Henüz bağlantı yok",
  "copy.a3169a401651": "Bu kaydı başka bir kanonik kayda semantik ilişkiyle bağla.",
  "copy.b9f70be342e0": "Bağlantı yolunu göster",
  "copy.73c829609fde": "Dolaylı bağlantı yolları",
  "copy.8ff3ebd85597": "Bunlar doğrudan bağlar değil, grafikte ulaşılan devam yollarıdır.",
  "copy.3c6e69792734": "Bağlantı yolu derinliği",
  "copy.223a655159bd": "2 adım",
  "copy.af1aeec2f531": "3 adım",
  "copy.f44f4335ee0f": "Bağlantı yolunu gizle",
  "copy.c3d3b2d2aadb": "Bağlantı yolları ·",
  "copy.2b9656ceb8e1": "adım",
  "copy.c4761e6f458e": "Bu derinlikte dolaylı bir yol bulunamadı.",
  "copy.69f2de3366f0": "Tanım, hangi kayıtların aday olacağını ve çokluk kuralını belirler.",
  "copy.d898e93fefc5": "Bağlantıyı kur",
  "copy.588d6e54daa7": "Bağlantı kurma · adım {{value1}} / 3",
  "copy.62fc44108e2e": "İlişki",
  "copy.fa5a09428e34": "İlişki sözlüğü yüklenemedi.",
  "copy.1f30ff52f9d5": "Yeniden dene",
  "copy.b3dbf14c3cfe": "Uygun ilişki tanımı yok",
  "copy.be53ebbf9188": "Bu kayıt türünden başlayabilen bir ilişki kuralı oluştur.",
  "copy.5e122dc318bd": "İlişki tanımı oluştur",
  "copy.1b4e8bd48759": "İlişki seç",
  "copy.33aa5d6245fa": "İlişki sözlüğünü yönet",
  "copy.ca4cfb5ac261": "Adaylarda ara",
  "copy.aa084b75ae58": "Bağlantı adayları yüklenemedi.",
  "copy.dd59623b6ec2": "Bu aramayla eşleşen hedef yok",
  "copy.e2ace8039e2c": "Bağlanabilecek hedef yok",
  "copy.2f5cfabecf65": "Arama ifadesini değiştir veya hedef türü kurallarını kontrol et.",
  "copy.91b001f14534": "İlişki tanımı bu kayıt için uygun bir hedef bulamadı.",
  "copy.45d6a88358b2": "Bağlantı kurulamadı. Aynı bağlantı mevcut veya çokluk kuralı izin vermiyor olabilir.",
  "copy.a0c505de95cf": "Bilinmeyen kayıt",
  "copy.f60f95cd8833": "İlişki alanı",
  "copy.0b687eb7efea": "Yapısal · salt okunur",
  "copy.b34f5aa1e5cf": "Bağı kaldır",
  "copy.b305d2edd361": "Bağlantı yolu",
  "copy.7916c8f0474b": "Bağlantı",
  "copy.a931270430aa": "Sütun ekle",
  "copy.e37f0d7a676d": "Adsız sütun",
  "copy.9a7c94a5811c": "sorun",
  "copy.bcb71bbc0918": "Sütun ayarları",
  "copy.285bc2afc213": "Yayımlanan sütunun anahtarı ve türü sabittir; diğer özelliklerini yeni sürümde değiştirebilirsin.",
  "copy.3b3be9720106": "Anahtar yayımlandıktan sonra değişmez.",
  "copy.1ec68d7b1270": "Sütunu yukarı taşı",
  "copy.ab4fb90fc778": "Sütunu aşağı taşı",
  "copy.2b4964d75877": "Sütunu kaldır",
  "copy.2afbc15a4f89": "Sütun adı",
  "copy.f420a172db2c": "Sabit anahtar",
  "copy.10a469da1596": "Sütun türü",
  "copy.9cdc77349ec2": "Yardım metni",
  "copy.a0394ceabdea": "Zorunlu",
  "copy.336355b87746": "Süren odak oturumu",
  "copy.6b0622af7e2a": "Küçültülmüş odak aracı",
  "copy.0fdd6fe86763": "Odak oturumunu göster",
  "copy.4f07c3435a02": "Odak aracını geri aç",
  "copy.38e6169082e7": "Serbest odak",
  "copy.a1f7017325e2": "Küçültüldü",
  "copy.3aa182dd7f4d": "Devam Et",
  "copy.60e5c559bebb": "Odağı bitirmek için pencereyi aç",
  "copy.e4d33a7ed882": "Düşünce",
  "copy.a5dc85625c13": "Dış etken",
  "copy.ed36dab58b62": "Odak oturumu yükleniyor",
  "copy.0d589a59bbce": "Odak durumu yüklenemedi",
  "copy.ab48e1b2ded5": "Etkin bir oturum varken yenisini başlatmamak için bağlantıyı yeniden kontrol et.",
  "copy.1eb709f11f91": "Odaklanıyorsun",
  "copy.2cf3944afc10": "plan {{value1}} · {{value2}} aşıldı",
  "copy.9ff3cfd0230d": "Bitir",
  "copy.7a98ee8218f8": "Kesinti Kaydet",
  "copy.b3723e02de60": "Kesintiler",
  "copy.f560a85f28c0": "Ekle",
  "copy.7dcb8d8a1f44": "Kesintiler yüklenemedi.",
  "copy.d43b28a96543": "· dönüldü",
  "copy.6c9b2ee8e169": "Geri döndüm",
  "copy.1767a9911a15": "Bu süreyi kaydetme",
  "copy.b475943ff92b": "Oturum duraklatılmaz; yalnızca neyin araya girdiği kaydedilir.",
  "copy.7983505ec7a7": "Kısa not",
  "copy.9dfaf42e8c5a": "Aklıma başka bir iş geldi…",
  "copy.acd3087a9623": "Kesinti kaydedilemedi. Yeniden deneyebilirsin.",
  "copy.cbf490822ecf": "Bu süre silinsin mi?",
  "copy.5fd236031438": "Kayıt tamamen kaldırılır; Analiz ve tahmin kalibrasyonu bunu görmez.",
  "copy.06d437fdb1ec": "Kayıt silindi",
  "copy.f698e9b40f9f": "Sil",
  "copy.a709665e24c1": "Yarıda kalan bir oturum da bir bilgidir; silmek yerine bitirmeyi seçebilirsin.",
  "copy.20fd3324e83d": "{{value1}} kaydedildi",
  "copy.76be2ff67ec5": "Oturumu Bitir",
  "copy.236be6c08fc6": "Bitir ve Kaydet",
  "copy.0a48283dfb4b": "Gerçekleşen",
  "copy.01e23f52e395": "Planlanan",
  "copy.abe27110bf41": "İkisi de saklanır. Fark bir eksiklik değil; gelecekteki tahminleri düzeltmek için kullanılan tek gerçek veri.",
  "copy.c7acd66b8b1f": "Oturum notu",
  "copy.e82bdabda759": "Ne yaptın, nerede takıldın?",
  "copy.4372d5a5bae6": "Bu görevi de tamamla",
  "copy.c04930fdbdaf": "Proje bağlamı yüklenemedi",
  "copy.402dcf53a405": "Kaldığın yer bilgisini korumak için bağlam yüklenmeden oturum bitirilemez.",
  "copy.2b852c38b7dc": "Proje bağlamı yükleniyor",
  "copy.40623d6cb92c": "Döndüğünde ne bulmak istersin?",
  "copy.34a6e5830b53": "Oturum kaydedilemedi. Girdilerin korundu; yeniden deneyebilirsin.",
  "copy.ae00bb8257d7": "Bir görev seç",
  "copy.bbe177d05785": "Bir proje seç",
  "copy.697017f40e1b": "Neye odaklanıyorsun?",
  "copy.37d32bded40e": "Doğrudan bir görevin süresini kaydet",
  "copy.b433a33b7a78": "Odağı proje ilerlemesine bağla",
  "copy.be10f7dfff22": "Bağımsız bir çalışma süresi kaydet",
  "copy.2d0befbb0034": "açık uçlu",
  "copy.be32d1d067c2": "Oturum süresi",
  "copy.0b90e5e7c067": "Serbest",
  "copy.519d3e7b2439": "Odak Bağlamı",
  "copy.cbf2d4ee6b34": "Odaklanacağın görev",
  "copy.3a5225cf13b3": "Görev seç",
  "copy.b3ed047212a6": "Odaklanacağın proje",
  "copy.7a56642b9b4e": "Proje seç",
  "copy.3aaf784e61e6": "Görev ayrıntısı yüklenemedi",
  "copy.e97500323136": "Serbest odak için bir ad (isteğe bağlı)",
  "copy.e84ca90d27cc": "Odak adı",
  "copy.788ed0399e53": "Başla",
  "copy.756ea4145328": "oturum",
  "copy.d0e801668500": " · bugün",
  "copy.d184b6486c45": "Oturum Notunu Düzenle",
  "copy.a3d459cbea3d": "Odak Kaydını Sil",
  "copy.ad10a3d997bb": "Odak kaydı silinsin mi?",
  "copy.a801162aa7e9": "Bu süre Analizden ve tahmin kalibrasyonundan da kalıcı olarak çıkarılır.",
  "copy.2f19a67aefd5": "Kalıcı Olarak Sil",
  "copy.75faff011bd7": "Odak kaydı silindi",
  "copy.61c4f34ff837": "Oturum notu güncellendi",
  "copy.b206bfcb333a": "Süre ve görev/proje ilişkisi değişmez; yalnızca oturum notu güncellenir.",
  "copy.4ac04bae2047": "Oturum notu güncellenemedi. Girdin korundu; yeniden deneyebilirsin.",
  "copy.fc9a20fc1741": "Çalışma oturumuna bağlı odak",
  "copy.ad5f7f339e2e": "Görev bağlamıyla açıldı",
  "copy.7ff707e28284": "Proje bağlamıyla açıldı",
  "copy.df9dbf7ef489": "Serbest veya bağlı bir oturum başlat",
  "copy.cacf66669d10": "Odak aracını küçült",
  "copy.8d46d6726f04": "Odak penceresini kapat; etkin oturum varsa sürer",
  "copy.3f214a88c36c": "Sabit — tarihin kendisi anlamı",
  "copy.f45f695ba882": "Bağlı — ancak bir gerekçeyle kayar",
  "copy.d8acc1aa2fc4": "Kaydırılabilir — dönem içinde serbest",
  "copy.a3bc7f7df94f": "Bırakılabilir — bu seferini kaçırmak az şey kaybettirir",
  "copy.1448aa633fde": "Ne için var",
  "copy.3d4502c278e5": "Tek cümle. Her yerde bunun yanında görünecek.",
  "copy.a6b077a5d4a1": "Neden bu uzunlukta",
  "copy.7fa5f589348c": "Dört ay değil de bir yıl olmasının sebebi. Beşinci ayda bırakmak istediğinde okuyacağın şey bu.",
  "copy.69910eaaea39": "Neden şimdi",
  "copy.e80320352083": "Hayatın bu dönemine konulmasının sebebi. Sonra 'sonbahara alabilir miyim?' sorusunu bu cevaplayacak.",
  "copy.283d53287910": "Yapılmazsa ne olur",
  "copy.35d5ce90f9e0": "Dürüst ol. 'Pek bir şey olmaz' da geçerli ve rahatlatıcı bir cevaptır.",
  "copy.560b06c0a4da": "Bittiğinde ne kazanacaksın",
  "copy.723127c3156d": "İşe yaradığını nasıl anlarsın",
  "copy.8b59fcdc559a": "Bırakma işareti",
  "copy.a1aa7cbb61f6": "Çıkış şartı olmayan bir taahhüt müebbete dönüşür.",
  "copy.dc670a4b67f8": "Kötü bir günde en az hâli",
  "copy.1e56d2f4528f": "Esneklik",
  "copy.39dbc0fbb0d7": "Feda sırası",
  "copy.11a1820cb7cf": "1 önce gider, 5 en son. Hesaplanmaz — senin talimatın.",
  "copy.963fc6a7cda9": "Korumalı",
  "copy.070901e9ffeb": "Hiçbir otomatik düzenleme buna dokunmaz.",
  "copy.db03659a642a": "Gerekçe kaydedilemedi. Girdilerin korundu; yeniden deneyebilirsin.",
  "copy.57a2348d770b": "Bu şeyin üstündeki hiçbir katmanda gerekçe yazılmamış. Buraya yazacağın şey zincirin tamamı olacak.",
  "copy.e8c89ef26df6": "Üst katmanlardan devralınan",
  "copy.bd9095d3dd77": "Kaldığım yere dön",
  "copy.1d3e2b0e8bc0": "Yeni bir karar vermeden açık bağlama geri git.",
  "copy.0cf7aee6c1fc": "Aklındaki yükü olduğu gibi günlüğe bırak.",
  "copy.b12be1e247c3": "En küçük işi seç",
  "copy.0277ee4e1eab": "Düşük enerji ve kısa zamana uyan tek bir aday gör.",
  "copy.f17dbd1265af": "Bilinçli dinlen",
  "copy.34edef8ab700": "Planı değiştirmeden kısa bir ara vermeyi seç.",
  "copy.50f2a1b041f6": "Açık bağlama geri dön",
  "copy.4de9b6a2e754": "Günlüğe zihinsel boşaltım yaz",
  "copy.cfd5195e2c90": "En küçük uygun görevi aç",
  "copy.bf0dcfc3d815": "On dakika bilinçli dinlen",
  "copy.44cc547f3928": "Dağıldım akışından seçildi.",
  "copy.cccfa77e9fb2": "Yalnız bir sonraki adım",
  "copy.4d54b8e1a767": "Şu an senden bir plan kurman beklenmiyor",
  "copy.82b994f7ebd6": "← Seçeneklere dön",
  "copy.e8dd7ab46696": "Odak oturumuna geri dön",
  "copy.b3fe8f40dc61": "Bugünün açık bağlamına dön",
  "copy.b4816d84781e": "Açık oturumun ve bıraktığın bağlam korunuyor.",
  "copy.5dec85d562b9": "Yeni iş eklemeden bugünkü planı tekrar gör.",
  "copy.b7e193af9550": "Geri dön",
  "copy.97c8955d0a2d": "Odak oturumuna geri döndü.",
  "copy.74001fd02bd4": "Günlük planı açtı.",
  "copy.db9f2db062e9": "Günlüğe olduğu gibi yaz",
  "copy.e9284333b7e8": "Sıralamak ya da göreve dönüştürmek zorunda değilsin.",
  "copy.085c7ec71b1c": "Zihinsel boşaltım için günlüğü açtı.",
  "copy.ac89735730db": "Aday bulunamadı",
  "copy.48bb85678fcc": "Kısa zamana ve düşük enerjiye uyan ilk kayıt. Planın değişmedi.",
  "copy.197f42744f7a": "Görevi aç",
  "copy.7d1ac7685702": "Önerilen en küçük görevi açtı.",
  "copy.ca82585fdd38": "Şu an küçük bir aday görünmüyor",
  "copy.a3544bf9d826": "Yeni bir görev üretmeden zihnini boşaltabilirsin.",
  "copy.f3c1e63c3076": "Günlüğü aç",
  "copy.606fce172095": "Uygun görev bulunamadı; günlüğü açtı.",
  "copy.ca14d38b2291": "On dakika bilinçli ara",
  "copy.f43babd41101": "Bu seçim hiçbir görevi veya takvim kaydını değiştirmez.",
  "copy.191a6f516185": "Arayı başlat",
  "copy.e74e95928b16": "Bilinçli dinlenmeyi başlattı.",
  "copy.c481a4f87d86": "Kullanılamayan Proje bağlamı",
  "copy.4d25a65559b0": "Bağımsız çalışma",
  "copy.a83ca4087283": "Artık kullanılamayan çalışma bağlamını temizle",
  "copy.1881e2853f90": "Bu Proje bağlamını Çalışma sayfaları arasında koru",
  "copy.45bff68a213b": "Yalnız bir Proje bağlamı sabitlenebilir",
  "copy.8cea46171ea6": "Bağlamı Temizle",
  "copy.c3e683cb28a7": "Bağlamı Sabitle",
  "copy.78f21b12f64e": "Seçili Proje etkin listede bulunmuyor; arşivlenmiş, tamamlanmış veya kaldırılmış olabilir. Çalışma bağlamını temizleyerek devam edebilirsin.",
  "copy.2ae781a94b58": "Çalışma bağlamları yüklenemedi",
  "copy.2ebe2eba26b2": "Masadaki Araçlar",
  "copy.3ace95a91811": "Oturum bağlamını bozmadan açılır",
  "copy.ac0de2f4c3c0": "Serbest Odak",
  "copy.106d3b1fd00a": "Bağımsız bir odak aç; oturuma bağlı odak için çalışma yüzeyini kullan.",
  "copy.4209e914bfa4": "Notlarla Çalış",
  "copy.227a769972c1": "Hafıza'daki başka bir notu pencereye al.",
  "copy.8d84e0bd50b7": "Kavramları Bağla",
  "copy.2034123c9ab1": "Bilgileri kavram haritasında düzenle.",
  "copy.3180a1d06ffe": "Kavram Haritası · Bağımsız çalışma",
  "copy.f9737968b2fd": "Proje çalışma alanı yüklenemedi",
  "copy.141f8139077d": "Proje kaldırılmış veya bu çalışma bağlamına erişilemiyor olabilir.",
  "copy.565175276319": "Not Penceresi",
  "copy.cd86f37c386e": "Şu an",
  "copy.7d5b7402fc6e": "Kavram Haritası · {{value1}}",
  "copy.2704572c3ed8": "Çalışma bağlamı kaydedildi",
  "copy.f94aa1a5150e": "Çalışma bağlamı kaydedilemedi",
  "copy.70587a8dabc5": "Kaldığın Yer",
  "copy.d6aacedbd609": "Bağlam notu",
  "copy.de5062658026": "Neredeydin, neyi çözüyordun, hangi bilgi önemliydi?",
  "copy.c9428f99c477": "Sıradaki somut adım",
  "copy.8a6a591578f8": "Geri döndüğünde ilk ne yapacaksın?",
  "copy.1d76f1e324b8": "Sıradaki İşler",
  "copy.6a22bf323242": "Bu Projenin açık görevleri; kalıcı sıralama proje planında yönetilir.",
  "copy.65e1ad711cdf": "Yeni adımları projenin Plan ve Görevler alanında düzenleyebilirsin.",
  "copy.a8a69edcaa9e": "Planlar yüklenemedi",
  "copy.f390637dec72": "Bu projede plan yok. Planlar, projenin Plan ve Görevler alanından oluşturulur.",
  "copy.867b4bf4357a": "dk",
  "copy.ed7b0597bb11": "son 30 günde odak ·",
  "copy.82e70c1d179f": "toplam oturum",
  "copy.6494487127f0": "Çalışma yüzeyi açıldı",
  "copy.57a32adc7c50": "Oturum notu oluşturuldu",
  "copy.5ababb6998c0": "Oturum notu açıldı",
  "copy.b168edcd36d4": "Ana görev değişti",
  "copy.04e44151b88b": "Çalışma bağlamı değişti",
  "copy.f0038635fd40": "Odak başladı",
  "copy.956e30081540": "Odak tamamlandı",
  "copy.86cab14e0fd7": "Oturum kapatıldı",
  "copy.1cfcb0e0c346": "Oturumlar",
  "copy.9a5d00963277": "Kaldığın çalışma bağlamları",
  "copy.082c5b661bba": "Yeni çalışma oturumu",
  "copy.31b9fad3e754": "Oturumlar yüklenemedi",
  "copy.a75340f85217": "İlk anlamlı notunla birlikte oturum burada görünür.",
  "copy.ef11f29168da": "Daha Fazla Oturum Getir",
  "copy.f32b8c72d580": "Oturum günlüğü",
  "copy.c91b9e0ca122": "Daha Eski Günlük Olaylarını Getir",
  "copy.65412e20f50b": "Çalışma {{value1}}",
  "copy.a23c43279ed8": "Çalışma oturumu başlatılamadı",
  "copy.16c8bf942416": "Yazdıkların bu yüzeyde duruyor; bağlantı geldiğinde yeniden deneyebilirsin.",
  "copy.1530bf14426b": "Oturum ve not oluşturuluyor…",
  "copy.3fd84e87bf4c": "Oturum notu artık mevcut değil",
  "copy.9f676ce9434f": "İlk anlamlı girdide oturum açılır",
  "copy.8b7b77b78bef": "Ana görev değiştirilemedi",
  "copy.326d955eb7ac": "Çalışma bağlamı önceki görevde kaldı.",
  "copy.6d3683dbfe92": "Oturum henüz kapatılmadı",
  "copy.a98b9baf338b": "Not kaydı tamamlandıktan sonra yeniden deneyebilirsin.",
  "copy.ed7b6d4d6bc3": "Çalışma oturumu kapatılamadı",
  "copy.5be192e2b90f": "Aktif çalışma yüzeyi",
  "copy.1cda7a55f788": "Düşünmeye başladığın yer",
  "copy.b49b642f4da3": "Bu oturum kapalı; notu Hafıza'da düzenleyebilirsin.",
  "copy.0e4bacc79b6a": "Yeniden Dene",
  "copy.a88b4fa851d1": "Yeni Oturum",
  "copy.f57f8c39267f": "Oturumla Odağı Aç",
  "copy.d00e6e559b1c": "Oturumu Kapat",
  "copy.922115e9e92a": "Çalışma oturumu yüklenemedi",
  "copy.38fe1543561e": "Ana görev",
  "copy.e62667b9b9c8": "Göreve bağlı değil",
  "copy.f5366701e102": "Çalışma başlığı",
  "copy.6b29008972a4": "Neyi anlamaya veya üretmeye çalışıyorsun?",
  "copy.f1a7b8a84677": "Çalışma notu",
  "copy.0b1711443289": "İlk düşünceyi yaz. Not ve çalışma oturumu birlikte, tek işlemde oluşur…",
  "copy.bd95ddbb7282": "Bağlam hazır",
  "copy.fa17e1d1883f": "Oturum açıldığında not, odak ve etkinlik bilgisi bu yüzeyde birlikte görünür.",
  "copy.4d17100a71c9": "Aranabilir",
  "copy.875bb07be1ea": "Özette göster",
  "copy.1ba822cc0684": "Seçenekler",
  "copy.ceec807c6551": "Her satıra benzersiz bir seçenek yaz.",
  "copy.588aae6aafd4": "En düşük",
  "copy.cc3dcc99e516": "En yüksek",
  "copy.edfe404908a0": "Ölçüm birimi",
  "copy.831ffef779b4": "Örnek: kg, km, ml.",
  "copy.fc4293f14ae2": "Para birimi",
  "copy.283563914155": "ISO kodu; örneğin TRY, EUR veya USD.",
  "copy.a671ef3bf83a": "En fazla karakter",
  "copy.9846864fe8ed": "İlişki tanımı",
  "copy.0e42058692eb": "Alan, bu tanımın aday ve çokluk kurallarını kullanır.",
  "copy.06e2c0165d52": "İlişki tanımları yüklenemedi.",
  "copy.ad5707c31404": "Üst sınır alt sınırdan küçük olamaz.",
  "copy.60d6891f17a7": "Varsayılan olarak evet",
  "copy.46964fd8474c": "Varsayılan değer",
  "copy.d520c328db39": "Varsayılan yok",
  "copy.6d15debcee9c": "Varsayılan seçimler",
  "copy.d2f234c495f7": "Önce sütun seçeneklerini ekle.",
  "copy.526f8ad89a9d": "Varsayılan tarih ve saat",
  "copy.c005e3ef8c5b": "Varsayılan süre (dakika)",
  "copy.b98832f7da8f": "Seçenek 1",
  "copy.7cf555385842": "Üst kayıt zorunludur.",
  "copy.a822bf0070b3": "Kayıt eklenemiyor",
  "copy.f8d08535fbf5": "Bu tablonun yayımlanmış bir sütun yapısı yok.",
  "copy.cf18882186be": "{{value1}} kaydı ekle",
  "copy.11a639de4e23": "Kaydı güncelle",
  "copy.e8d1493bfe8b": "Kaydı oluştur",
  "copy.5950aa34aa20": "Etkin kayıt",
  "copy.e0d9a7decf57": "Yeni kayıt",
  "copy.7fbcae4ad3d9": "sütun · yayımlanan v",
  "copy.515170d938a6": "Bu kayıt arşivde. Alanlarını değiştirebilir veya kaydı yeniden etkinleştirebilirsin.",
  "copy.a8e9ba13c3e8": "Kalıcı kayıt sayfasını aç",
  "copy.0d560aad7f5b": "Üst kayıt",
  "copy.436740d4eccb": "Üst kayıtlar yüklenemedi.",
  "copy.6f891e8e4afc": "Üst kayıt seç",
  "copy.92b0222f6306": "Kayıt alanları",
  "copy.4c62d67a8041": "Bu kaydı yeniden etkinleştirmek istiyor musun?",
  "copy.3152b9d97443": "Kayıt arşive taşınacak; daha sonra geri alınabilir.",
  "copy.fcd7700e64bf": "Arşivden çıkar",
  "copy.c6d04422e361": "Arşive taşı",
  "copy.dc5fc533111f": "Kayıt tarihi",
  "copy.6d0830c1e983": "Gerçekleşme zamanı",
  "copy.525f19e832a6": "Bitiş başlangıçtan önce olamaz.",
  "copy.6caa06b138cc": "Seç",
  "copy.276cd1b7e5b5": "Tek hedef seçilebilir",
  "copy.2c9c3bcc5b32": "Birden çok hedef seçilebilir",
  "copy.b99c6204f1b9": "Çoklu bağlantı",
  "copy.11f80f8cf5b1": "Bağlantıyı kaldır",
  "copy.c48e820e9b6c": "Henüz bağlantı seçilmedi.",
  "copy.0d364098bf4b": "Bu ilişki tek hedefe izin verir. Başka bir hedef seçmek için mevcut bağlantıyı kaldır.",
  "copy.4688865cdf49": "Yeni kayıt için yalnız bu ilişki tanımının izin verdiği adaylar gösterilir.",
  "copy.a3555e1aa356": "Adaylar yükleniyor…",
  "copy.969eccd7e467": "Bu aramayla eşleşen başka aday yok.",
  "copy.d9d28c3fe620": "Bu ilişki için seçilebilecek başka aday yok.",
  "copy.2685c287900e": "Bağlantı adayları",
  "copy.0b6a2e657a9d": "{{value1}} için en az bir seçim yap.",
  "copy.f339524cbafa": "{{value1}} negatif olmayan tam milisaniye olmalıdır.",
  "copy.b1b1da5a51e8": "{{value1}} geçerli bir sayı olmalıdır.",
  "copy.32e88fc5f837": "{{value1}} tam sayı olmalıdır.",
  "copy.c6c40d117da9": "{{value1}} {{value2}} değerinden küçük olamaz.",
  "copy.001a863d4b0e": "{{value1}} {{value2}} değerinden büyük olamaz.",
  "copy.3e3318af512f": "{{value1}} geçerli bir tarih ve saat olmalıdır.",
  "copy.d3955395c9c9": "Kayıt tarihi zorunludur.",
  "copy.1dbaa5054f97": "Gerçekleşme zamanı zorunludur.",
  "copy.967f23d70ff8": "Başlangıç ve bitiş zamanı zorunludur.",
  "copy.aff516febe59": "Kayıt kaydedilemedi. Bilgileri kontrol edip yeniden dene.",
  "copy.659793dbb28a": "Rehber kaydı",
  "copy.cb8ec45f8ad3": "Varlık",
  "copy.673e4e36fd5b": "Zamansız",
  "copy.a7616ceae060": "Aralıklı",
  "copy.e58573219562": "Zaman çizgisi",
  "copy.97e99d15be1d": "Kısa metin",
  "copy.52fdce9b9ec0": "Uzun metin",
  "copy.6288e89d4851": "Tam sayı",
  "copy.3633af0adabd": "Ondalık sayı",
  "copy.c7df4b07d57c": "Evet / hayır",
  "copy.c17048e6ca9a": "Tarih ve saat",
  "copy.6fcfc21a7061": "Tek seçim",
  "copy.74b57a1aad86": "Çoklu seçim",
  "copy.27b840ea8759": "Web adresi",
  "copy.9f2f4d66fa86": "İlişkili kayıt",
  "copy.100a8d1ce8b6": "Alan {{value1}}",
  "copy.61448e841093": "Alan adı zorunludur.",
  "copy.0768df1f8197": "Anahtar küçük harf, rakam, alt çizgi veya kısa çizgi kullanmalıdır.",
  "copy.dea7bef37790": "En az bir seçim seçeneği ekle.",
  "copy.e01d8c9f37bd": "Ölçüm birimi zorunludur.",
  "copy.ca9d31f6d5bd": "Para birimi kodu zorunludur.",
  "copy.ad1e311e3c89": "Bir ilişki tanımı seçmelisin.",
  "copy.0f20c2b1dd0d": "En düşük değer en yüksek değerden büyük olamaz.",
  "copy.65829f044732": "En düşük değer tam sayı olmalıdır.",
  "copy.37a4b19c9a81": "En yüksek değer tam sayı olmalıdır.",
  "copy.e303c5ad58bf": "Varsayılan değer tanımlanan alt sınırdan küçük olamaz.",
  "copy.ddffa1123b1f": "Varsayılan değer tanımlanan üst sınırdan büyük olamaz.",
  "copy.53c363caf4c7": "Karakter sınırı en az 1 olmalıdır.",
  "copy.1681512ce8ef": "Varsayılan metin karakter sınırını aşıyor.",
  "copy.d6336058bf2a": "Varsayılan seçim seçenekler arasında bulunmalıdır.",
  "copy.f0b2b189c6be": "Varsayılan seçimler benzersiz ve tanımlı seçeneklerden olmalıdır.",
  "copy.7eedb6ffc46e": "Varsayılan süre negatif olmayan tam milisaniye olmalıdır.",
  "copy.8370cffa685e": "Varsayılan tarih ve saat RFC 3339 biçiminde olmalıdır.",
  "copy.b8059304da02": "Sözleşmede en az bir alan bulunmalıdır.",
  "copy.4a7ceb5a6005": "“{{value1}}” anahtarı birden fazla kullanılıyor.",
  "copy.636fdb5eafeb": "Kayıt başlığı alanı mevcut sütunlardan biri olmalıdır.",
  "copy.13dd5f66b411": "İlişki alanı kayıt başlığı olarak kullanılamaz.",
  "copy.cac400c7ec07": "Hayır",
  "copy.c1ea630641d7": "{{value1}} bağlantı",
  "copy.12f5b9657481": "Bu alanda kullanılabilir tablo yok",
  "copy.23153e137765": "Arşivdeki alanın etkin bir tablosu bulunmuyor. Alanı geri yükledikten sonra yeni tablo oluşturabilirsin.",
  "copy.3f89d405ca85": "Kayıt yapısını tanımlayan ilk tabloyu oluştur.",
  "copy.6a31c0c610b2": "Tablo oluştur",
  "copy.0f1ec9f644e2": "Kayıt tablosu",
  "copy.43e460e9f515": "Tam sayfa",
  "copy.d4e50a9507fa": "Kayıt görünümü",
  "copy.140827893f56": "Yeni görünüm",
  "copy.2371d635aa7d": "Görünümü düzenle",
  "copy.9cbbce1b2fdf": "Kayıtlarda ara",
  "copy.ee262830ab0b": "Kayıtlarda ara…",
  "copy.fc38cc582bb7": "Görünüm türü",
  "copy.63393830d702": "Tablo",
  "copy.c0234ded5a1c": "Kart",
  "copy.7293b181ae7d": "Akış",
  "copy.1aa857883362": "Filtreler ve düzen{{value1}}",
  "copy.544ecff7c397": "Sıralama",
  "copy.7cc13871889f": "En yeni",
  "copy.6bd60b2c4146": "En eski",
  "copy.e25e294bd346": "Ada göre",
  "copy.3be6b46e60ae": "Kayıtları grupla",
  "copy.72c093cbd94c": "Gruplama yok",
  "copy.7070a81abb53": "Filtre alanı",
  "copy.5a98aabe37e5": "Filtre yok",
  "copy.060cb5de9135": "Filtre işlemi",
  "copy.ff02062be742": "İçerir",
  "copy.0b5a458a5347": "Eşittir",
  "copy.4387da82d5a8": "Boş değil",
  "copy.16e5d938d19e": "Filtre değeri",
  "copy.d801b37b3a25": "Filtre değeri…",
  "copy.46421177d26f": "Arşivdekileri göster",
  "copy.92dfa17d1f40": "Düzeni sıfırla",
  "copy.062b17469b60": "eşleşmenin",
  "copy.6ef1a9248bf5": "tanesi gösteriliyor. Arama, filtre, sıralama ve gruplama sunucuda bütün eşleşmelere uygulanır.",
  "copy.f4b5c7e0e2f3": "Yaşam kayıtları yüklenemedi.",
  "copy.479bfe7bd93c": "Bu görünümle eşleşen kayıt yok",
  "copy.0e333f240a2c": "Arama ifadesini değiştir veya etkin filtreyi temizle.",
  "copy.5ce588ad6970": "Yayımlanmış tablo yapısına göre ilk kaydı ekleyerek başla.",
  "copy.9cd93a2b25b1": "Arama ve filtreyi temizle",
  "copy.425ce7a0b289": "İlk kaydı ekle",
  "copy.c0db40e859f1": "Daha fazla kayıt yükle",
  "copy.405a2eb6e36d": "Yaşam kayıtları tablosu; daha fazla sütun için yatay kaydır",
  "copy.461903c31fd4": "sayfasını aç",
  "copy.42e8d6751cfb": "kaydını düzenle",
  "copy.26df4c031ec1": "bağlantı",
  "copy.35916465da8e": "Filtre değeri zorunludur.",
  "copy.2ac1e3d6eb57": "Filtre değeri en fazla 500 karakter olabilir.",
  "copy.e5b97c24ed71": "Kayıt görünümünü düzenle",
  "copy.4f52e9bdab2a": "Kayıt görünümü oluştur",
  "copy.8e6bb24be8b8": "Sütun, filtre, sıralama ve gruplama sunucuda saklanır; aynı görünüm diğer istemcilerde de okunabilir.",
  "copy.bc161950c700": "Görünümü güncelle",
  "copy.32e7ce8f0ed2": "Görünümü oluştur",
  "copy.16cd586772ea": "Görünüm adı",
  "copy.90a257d504b0": "Kayıt araması",
  "copy.91426b4dc742": "Bu görünüm açıldığında aranacak ifade",
  "copy.27bc2b348074": "Alanlar, sıralama ve filtre",
  "copy.70f7b8b381e3": "Gösterilecek alanlar",
  "copy.8ba6ca75b0af": "Gruplama alanı",
  "copy.350512a50f2c": "Varsayılan görünüm yap",
  "copy.346d8dd12fee": "Görünüm kaydedilemedi. Alan seçimini kontrol edip yeniden dene.",
  "copy.8a003516a94a": "Bu görünüm arşivlenecek; kayıtlar etkilenmez.",
  "copy.9ef30226f4c0": "Görünümü arşivle",
  "copy.0d3caafbd239": "Çoktan çoğa",
  "copy.2e541ac8ec28": "Birden çoğa",
  "copy.258c11864172": "Bire bir",
  "copy.a5503e701959": "İlişki sözlüğü",
  "copy.8293474593b5": "Yaşam alanı sütunlarının ve tüm semantik bağlantıların ortak, kullanıcı tanımlı kuralları.",
  "copy.d81c6876f344": "İlişki tanımla",
  "copy.d2d887d89da6": "Henüz bağlantı kuralı yok",
  "copy.e35ece82e967": "İlişki sütunu veya kayıt bağlantısı kullanmadan önce izin verilen kaynak ve hedef türlerini tanımla.",
  "copy.0de750b7b91a": "İlk ilişkiyi tanımla",
  "copy.c6a30b14472d": "Tüm kaynak türleri",
  "copy.b3697435c490": "Tüm hedef türleri",
  "copy.9587d48e6522": "İlişki tanımını düzenle",
  "copy.d4d1b191bbb7": "İlişki tanımını arşivle",
  "copy.e8c3e0322839": "” bağlantı kuralı arşivlenecek. Mevcut bağlantılar silinmez.",
  "auth.registration": "Kayıt",
  "copy.f59ac551f57f": "Ara veya bir yere git",
  "copy.f38bb94bc826": "Görev, proje, not, rutin ara…",
  "copy.eec61f6c4c28": "Arama yapılamadı",
  "copy.4f864d921594": "Sorgun korunuyor; bağlantı geri geldiğinde yeniden deneyebilirsin.",
  "copy.ce201cb1375d": "” için sonuç yok.",
  "copy.ec1cfccba261": "Global odak aracını aç",
  "copy.86c1fce4925a": "gez",
  "copy.87c0823f8b31": "yakala",
  "copy.6d06affe96b7": "Bu taslak silinsin mi?",
  "copy.39d0c84b44db": "Taslak Oluştur",
  "copy.7512b239d6b6": "Taslaklar yüklenemedi",
  "copy.1c72b13df135": "Henüz taslak yok",
  "copy.cd193d755ba5": "Aklına geleni {{shortcut}} ile yakala; türüne ve yerine sonra karar verirsin.",
  "copy.83bbc896e0b0": "Bekleyen taslaklar",
  "copy.878933c7d3e8": ". taslak ·",
  "copy.f010d2fb4dc7": "Önceki Taslak",
  "copy.7f68e932a6f0": "Sonraki Taslak",
  "copy.b34349abf096": "Dönüştür",
  "copy.2e1e6aba9879": "Diğer İşlemler",
  "copy.ef4220e5af6c": "Taslak Eklendi",
  "copy.2bd4cadb228f": "Ne olduğuna karar vermek için işlem sırasında seni bekliyor.",
  "copy.007e26c6418a": "Gelen Kutusu Taslağı",
  "copy.7e64bc3e17ff": "Düşünceyi şimdi kaydet; türünü ve yerini işlem sırasında belirlersin.",
  "copy.b4ad6c920f5e": "Taslağı kaydet",
  "copy.a307e848f85b": "Taslak metni",
  "copy.83456a81e6d9": "Proje, tarih veya tür seçmen gerekmiyor.",
  "copy.5605187daf88": "Aklında kalan düşünce…",
  "copy.8a0390b85b4f": "Taslağı Düzenle",
  "copy.100d490b8ba7": "Dönüştürmeden önce ham metni düzeltebilirsin.",
  "copy.1f650f02db64": "Bir kez yapılıp bitecek somut bir iş.",
  "copy.31ced9c28638": "Saklamaya değer bir bilgi.",
  "copy.e685a979e293": "Birden çok adımı olan bir çalışma.",
  "copy.5ed90abde0ed": "Tekrar edecek bir davranış.",
  "copy.3ec77b2c6110": "Damıtılmış, ilişkilendirilebilir atomik bilgi.",
  "copy.791eded9df4a": "Dönüştürüldü",
  "copy.27d3a7739ea1": "Neye Dönüşsün?",
  "copy.62179c14e2a0": "Hızlı görev tarihi",
  "copy.a239fe49ae00": "Boş bırakılırsa yalnızca güne yerleştirilir.",
  "copy.cba25d1c84f9": "Boş bırakırsan taslağın ilk satırı kullanılır.",
  "copy.1d436c8fdcd0": "Kısa ifade",
  "copy.304d29dca6e9": "Tek cümlede damıtılmış bilgi",
  "copy.60209ab3d033": "Uzun içerik gerekiyorsa Not olarak dönüştür.",
  "copy.b6efe3e72d36": "Proje rengi",
  "copy.a4fe32a75621": "Ayrıntıları sonra rutin ekranından düzenleyebilirsin.",
  "copy.923151ae4b79": "Belirli günler",
  "copy.21db5263d05b": "Gün aralığı",
  "copy.b94cb47a3530": "Haftalık kota",
  "copy.4e0bbee63aba": "Tekrar günleri",
  "copy.244915edb65f": "Kaç günde bir?",
  "copy.4ad756eca365": "Haftada kaç kez?",
  "copy.9e34e8d58b88": "{{value1}} düşünce Taslaklar'a eklendi",
  "copy.25aa86d86c3f": "Sınıflandırma sonraya kalabilir.",
  "copy.9199ed6be96c": "Yakalandı",
  "copy.91b856f8bfe6": "Kafanı boşalt",
  "copy.5e4146ed7823": "Ne olduğuna sonra karar verirsin.",
  "copy.017eefd3a09d": "Her satır ayrı bir öğe olur. Önceden sıralamaya veya düzenlemeye gerek yok.",
  "copy.714807d9ead7": "Tek düşünce",
  "copy.3e4862b7eda3": "satır",
  "copy.3c269e0591f0": "Yakalanacak düşünce",
  "copy.3ffc056ff075": "Kafandaki düşünceler",
  "copy.27099f50adb0": "Aklından geçen…",
  "copy.8229e2067826": "Aklındaki her şeyi alt alta yaz.\nSırayla, düzenli olmasına gerek yok.",
  "copy.8165e1751b03": "ayrı taslak oluşacak. Hepsi Taslaklar'da bekler; hiçbirine şimdi karar vermen gerekmiyor.",
  "copy.bd55afa192cb": "“{{value1}}” kalıcı olarak silinsin mi?",
  "copy.7e91bbcdd436": "Arşivden de kaldırılır ve geri getirilemez.",
  "copy.5d43b831c2b8": "Arşiv kayıt türü",
  "copy.58833783a7d0": "Geri almak kaydı eski çalışma alanına taşır.",
  "copy.a8c365081193": "Arşiv yüklenemedi",
  "copy.347508cd2511": "Arşivlenmiş {{value1}} yok",
  "copy.8740913ebf1a": "Buraya kaldırdığın kayıtlar silinmez; istediğin zaman geri alabilirsin.",
  "copy.325d8474bd73": "Kayıt ve bağlam",
  "copy.4a1729bec425": "Arşivlenme",
  "copy.543e1e2b1b30": "Arşivlenmiş {{value1}}",
  "copy.c85698aff1af": "Geri alındı",
  "copy.75cd572a9f22": "arşiv notu",
  "copy.970a95f7e5a9": "Diğer arşiv notları yüklenemedi. Yeniden deneyebilirsin.",
  "copy.2caeeb05616c": "Arşivlenme tarihi bilinmiyor",
  "copy.1dc7472b3156": "Kalıcı olarak silinsin mi?",
  "copy.b58104b1b96a": "Uzun Dönem",
  "copy.6fad8d09bd08": "Kısa Dönem",
  "copy.8b7c60d9a23d": "Tüm kayıtlar",
  "copy.dc6458c155c6": "Yaşam tabloları",
  "copy.7243719b1672": "Yaşam görünümleri",
  "copy.e5084b3d7f53": "Kayıt geri alındı",
  "copy.5c45ef0b0452": "{{value1}} kayıt geri alındı",
  "copy.1bff0d467a01": "Kayıtlar geri alınamadı",
  "copy.7e43776d39bc": "Bu kayıtlar Çöp Kutusu’na taşınamaz",
  "copy.f2f05727eafe": "Kayıt Çöp Kutusu’na taşındı",
  "copy.85bb4b7b4200": "{{value1}} kayıt Çöp Kutusu’na taşındı",
  "copy.bcdc2ea2a3cf": "30 gün içinde geri alabilirsin.",
  "copy.c9481516ef38": "Kayıtlar taşınamadı",
  "copy.be2fac37f500": "Bu görünümde arşivlenmiş kayıt yok",
  "copy.fdafc18b1eae": "Arşive kaldırdığın içerik silinmez; dilediğinde buradan geri alabilirsin.",
  "copy.abc78ab6cac5": "Kayıt kalıcı olarak silinemiyor",
  "copy.24cabd671054": "{{value1}} geçmiş kaydı korunmak zorunda. Kaydı geri alıp bağlantılarını gözden geçir.",
  "copy.5aa54c2af353": "Bu kayıt",
  "copy.bdb20024bae6": "{{value1}} kayıt kalıcı olarak silinsin mi?",
  "copy.d7187a2f212a": "Seçili kayıtlarla birlikte {{value1}} bağlı alt kayıt veya ilişki de etkilenecek.",
  "copy.c7069dd6a3e1": "Seçili kayıtlar Çöp Kutusu’ndan tamamen kaldırılacak.",
  "copy.6727a116935d": "Kayıt kalıcı olarak silindi",
  "copy.68c16b76c9dc": "{{value1}} kayıt kalıcı olarak silindi",
  "copy.9d7de68bccbb": "Kalıcı silme tamamlanamadı",
  "copy.77aef723beaa": "Çöp Kutusu boş",
  "copy.932aaa5c7e56": "Sildiğin kayıtlar burada en eski silinenden en yeniye doğru görünür.",
  "copy.8ac21a9cabb2": "Kayıt arama ve tür filtreleri",
  "copy.7fee5d58c7da": "Kayıt türü",
  "copy.0fabc7f67a53": "{{value1}} kayıt seçili",
  "copy.fa34472f76eb": "Görünen ilk {{value1}} kaydı seç",
  "copy.facf08d75d96": "Görünenlerin tümünü seç",
  "copy.c01ed86409d1": "{{value1}} kayıtlık seçim sınırına ulaştın.",
  "copy.3ef6f67a68aa": "Toplu işlemlerde en fazla {{value1}} kayıt seçebilirsin.",
  "copy.019ca1b70c96": "Toplu işlem için kayıt seç.",
  "copy.2b96339a744e": "Kayıtlar yüklenemedi",
  "copy.593703de1db6": "silindi",
  "copy.5412471b7fc4": "Otomatik silme güvenli bir bağımlılığı bekliyor",
  "copy.5d6938f2ba9e": "otomatik silinir",
  "copy.53e727197f13": "Geri alınca Arşiv’e döner",
  "copy.ec4bdb8ab67b": "Daha Fazla Göster",
  "copy.1f872f173f4c": "süresi dolduğunda",
  "copy.6132e88dcede": "{{value1}} gün sonra",
  "copy.b5d5656e5c0f": "Çok fazla kayıt seçildi",
  "copy.d020fa270189": "Tek bir toplu işlemde en fazla {{value1}} kayıt işlenebilir.",
  "copy.16e0cd0b2878": "Hafıza koleksiyonları yalnız Arşiv’den geri alınabilir; alt notlar silinmez ve Çöp Kutusu’na taşınmaz.",
  "copy.2781e5ac5672": "Taslaklar yalnız Arşiv’den geri alınabilir; Çöp Kutusu’na taşınamaz.",
  "copy.92a521b5fc10": "Taslaklar ve Hafıza koleksiyonları yalnız Arşiv’den geri alınabilir; Çöp Kutusu’na taşınamaz.",
  "copy.d87591c967d9": "{{value1}} gündür dokunulmadı",
  "copy.1dbded6f67f7": "Hiç gözden geçirilmedi",
  "copy.25f22ae5f0c0": "{{value1}} gündür hâlâ açık",
  "copy.698e3f961ac4": "{{value1}} gün önce yakalandı, işlenmedi",
  "copy.6ef56e918637": "Bunu yeniden görmek istemiştin",
  "copy.60d5f262aca4": "Gelecek hafta",
  "copy.991a8309369b": "Gelecek ay",
  "copy.b99719aeeee0": "Bir gün",
  "copy.4c033acaadc1": "İlk kez bakıyorsun.",
  "copy.dd61fabdb46b": "Son bakıştan",
  "copy.4c6a4b7471c7": "gün geçti.",
  "copy.ddcd9fab4d42": "içerik bir aydan uzun süredir açılmadı.",
  "copy.1a27744cbf0b": "Haftalık Sıfırlama",
  "copy.6d97f0018bd7": "Deste",
  "copy.924255972b30": "Unutulanlar",
  "copy.72bb05e8e781": "Gözden geçirme destesi yüklenemedi",
  "copy.095adb049560": "Boş bir deste göstermek yerine bağlantıyı yeniden deneyebilirsin.",
  "copy.244b6886c071": "Deste bitti",
  "copy.45ae05564f67": "Bir aydan uzun süredir bekleyen bir şey yok",
  "copy.491a9dae240a": "Şu an gösterilecek bir şey yok",
  "copy.f828bb795dc7": "{{value1}} içeriğe yeniden baktın. Gördüklerin bir hafta boyunca geri gelmez.",
  "copy.279a03385f54": "Yakın zamanda gözden geçirdiklerin bir hafta boyunca yeniden gelmez.",
  "copy.ad164ae80dbc": "Son dokunuş",
  "copy.8f38e98697e7": "Ne Zaman",
  "copy.43c20da85fe5": "Gördüm",
  "copy.55ddd44cd2d1": "Sonra Göster",
  "copy.e8e58f9e91e8": "Önceki Kart",
  "copy.325a4f757c71": "Sonraki Kart",
  "copy.c75d5b5a50a3": "Kartın kaynağı arşivlendi",
  "copy.fffc44606371": "Kaynak kayıt Çöp Kutusu’na taşınır ve oradan geri alınabilir. Yalnızca desteden kaldırmak için Gördüm, etkin listelerden kaldırıp saklamak için Arşivle seçeneğini kullanabilirsin.",
  "copy.5fa7808f21d9": "Kaynak kayıt Çöp Kutusu’na taşındı",
  "copy.0d5aa5d8ca2b": "Taslak göreve dönüştürüldü",
  "copy.7a64b8f8bbe5": "Taslak göreve dönüştürüldü ve tarihe yerleştirildi",
  "copy.c178f2e4b3a9": "Görev tarihe yerleştirildi",
  "copy.15ed364115d3": "Kart İşlemleri",
  "copy.3d4ed4f3f713": "Tarih Ver",
  "copy.fc1feb9caa5e": "Göreve Dönüştür",
  "copy.189accbafa61": "Taslak bir göreve dönüştürülür ve seçtiğin güne saatsiz olarak yerleştirilir.",
  "copy.f72beda5977b": "Görevin mevcut tarihi seçtiğin güne taşınır; saat ve süre korunur.",
  "copy.bdd466141565": "Görev seçtiğin güne saatsiz olarak yerleştirilir.",
  "copy.585227e698bc": "Tarihe Yerleştir",
  "copy.ce98b504980d": "Görevin mevcut tarihi okunamadı. İkinci bir tarih oluşturmamak için yeniden deneyin.",
  "copy.8e2e500a5b51": "son dokunuştan beri gün",
  "copy.f5c3b8f2b6a4": "kayıt daha var.",
  "copy.dd2cf338bef0": "Karar alanı",
  "copy.ccb1b66b9cd0": "Tamamlanmamış iş",
  "copy.7fe1f25cf50c": "Örüntü",
  "copy.09533afe9cfe": "Önümüzdeki hafta",
  "copy.d3b634b9c241": "Yakaladığın ama henüz bir şeye dönüştürmediğin düşünceler.",
  "copy.3f56dfb9884a": "Planı olmayan taahhütler. Her birinin bir çıkışı var.",
  "copy.f8861196c93b": "Bu hafta plana bağlanıp tamamlanmamış işler.",
  "copy.b1f0345aec0e": "Sessizleşen ya da sonraki adımı olmayan projeler.",
  "copy.14b123249cbe": "Bu hafta rutinler nasıl gitti? Burada yapacak bir şey yok, sadece bakılır.",
  "copy.28749557e31d": "Planlanan ile gerçekleşen zaman. Karşılaştırma, yargı değil.",
  "copy.08924cb29c7e": "Önümüzdeki hafta için şimdiden bağlı olan şeyler.",
  "copy.b6f9ff4bcd18": "Haftalık sıfırlama yüklenemedi",
  "copy.352f27fd1f67": "Açık döngüler şu anda bir araya getirilemiyor.",
  "copy.ea5809745de5": "Hafta Sıfırlandı",
  "copy.ffaee03cdda3": "Bu turda bir şey değişmedi. Bakmak da bir karardır — hiçbir şeyi taşımamayı seçmiş olabilirsin.",
  "copy.9bc36de238aa": "madde çözüldü. Geriye",
  "copy.1b9cbdc3bab6": "tane kaldı; onlar da bir sonraki hafta burada olacak.",
  "copy.c148c2d92fe6": "Günlük Takvime Dön",
  "copy.fcc5dbfdb00a": "Yeniden Keşfet'e Dön",
  "copy.907bd6b287d0": "karar bekleyen bir şey yok",
  "copy.119361552a5f": "{{value1}} madde kaldı",
  "copy.90a817d58d50": "Adımlar",
  "copy.b68a3150ea85": "Geri",
  "copy.844da8e8d489": "Sıfırlamayı Bitir",
  "copy.b91950d23ded": "Devam",
  "copy.eddb7bfb8697": "Bakış",
  "copy.a2f6cf4a30e2": "Tutarlılık",
  "copy.3573f3639f9a": "İki sayı yan yana duruyor; biri diğerinin hedefi değil. Aradaki fark, gelecekteki tahminleri düzeltmek için kullanılan tek gerçek veri.",
  "copy.1159e7bd858c": "Önümüzdeki Hafta Takvimde",
  "copy.bf455167c946": "Haftaya Bak",
  "copy.0b37a6968a9b": "Gelen kutusu boş",
  "copy.431f051dff63": "gün önce",
  "copy.9123f5b6da31": "Taslaklar'da İşle",
  "copy.33d1b4d34e9c": "Tarihsiz açık görev yok",
  "copy.3458e38301bc": "Her projenin bir sonraki adımı var",
  "copy.0d0701dd4242": "{{value1}} gündür sessiz",
  "copy.fa5e27df9b4d": "Sonraki adım tanımlı değil",
  "copy.b03603f65e2d": "İlişki tanımı arşivlenemedi. Bağlantıları kontrol edip yeniden dene.",
  "copy.c60029bdd3f2": "Yeni bağlantı kuralları oluştur, mevcut kullanıcı tanımlarını güncelle veya arşivle.",
  "copy.bccc27de3b81": "Kaynak ve hedef türleri kontrollü listeden seçilir; aday araması bu kurallara uyar.",
  "copy.f63044f8dff1": "Değişiklikleri kaydet",
  "copy.4612d0b22e56": "İlişkiyi oluştur",
  "copy.9006ce1450a2": "Bağlantı adı",
  "copy.c9b98c9096d8": "Ters yöndeki adı",
  "copy.8a24e4e6296f": "Anlam kategorisi",
  "copy.26bfbbe247de": "Yayımlanan kategorinin anlamı sabittir.",
  "copy.2d9fb7e34965": "Çokluk",
  "copy.968d3d7d6bb8": "İzin verilen kayıt türleri · {{value1}} → {{value2}}",
  "copy.a17187c568ca": "tümü",
  "copy.6fde6111d2d6": "Kaynak kayıt türleri",
  "copy.c425b1f9c7b3": "Hedef kayıt türleri",
  "copy.fef46aba9f28": "Belirli bir Yaşam tablosuyla sınırla",
  "copy.701c51b66812": "İsteğe bağlıdır. Boşken tüm izinli Yaşam kayıtları adaydır.",
  "copy.45c465e4ade6": "Yaşam tabloları yüklenemedi.",
  "copy.c2cddfaeaa32": "Tüm Yaşam tabloları",
  "copy.7ef9daa37b69": "Mevcut hedef tablo",
  "copy.9046e6e95efa": "Kaydın kendisine bağlanmasına izin ver",
  "copy.a65e091829b2": "İlişki tanımı kaydedilemedi. Tür ve çokluk kurallarını kontrol et.",
  "copy.066d6e58e8db": "Boş seçim tüm bağlanabilir türlere izin verir.",
  "copy.8e9f14a0daa0": "{{value1}} · Tablo stüdyosu",
  "copy.6a4dfec17637": "Yayımlanan tablo sürümü {{value1}}",
  "copy.2245aa49ed89": "Yeni sürümü yayımla",
  "copy.6e71d85d9727": "Tablo bilgileri",
  "copy.2f342c2f309a": "Tablo adı",
  "copy.c3217baf903c": "Tablo bilgilerini kaydet",
  "copy.cb49b1a90671": "Birincil tablo alanından bağımsız arşivlenemez.",
  "copy.159c97b94b6a": "Tablo ve kayıtları arşivlenecek.",
  "copy.9307ebd33494": "Tabloyu arşivle",
  "copy.d82fcf185dee": "Yayımlama akışı",
  "copy.452953bae789": "Kayıtlar yalnız yayımlanan sütun yapısıyla yazılır. Taslak değişiklikler yayımlanana kadar mevcut kayıtları etkilemez.",
  "copy.c285d4d31ef1": "Sürüm yok",
  "copy.7e2b18dbac6b": "Taslak hazır",
  "copy.d62779cb6647": "Yeni taslak",
  "copy.8ae1c64a4552": "Taslak aranıyor",
  "copy.cd0de2724a68": "Tablo yayımlama adımları",
  "copy.09456abb31a5": "Yayımlanan",
  "copy.ac1d5a2e4fc8": "Kaydedilmemiş",
  "copy.0f3133690dd9": "Doğrulama",
  "copy.970dbbd01996": "Hazır",
  "copy.764dc2c1c245": "Düzeltme gerek",
  "copy.38a23c50f075": "Teknik sözleşme özeti",
  "copy.61fce33c56cc": "Kayıt başlığı alanı",
  "copy.793553198477": "İlk uygun alanı otomatik seç",
  "copy.68e9401f6d6f": "Taslak sütun yapısı denetleniyor…",
  "copy.6f5817e083bf": "Yayımlamadan önce düzelt",
  "copy.271ca82210f7": "Sözleşme doğrulandı",
  "copy.22ff3717a8cd": "Sözleşme doğrulanamadı",
  "copy.46a3df3e8376": "Taslak tablo kurallarına uymuyor.",
  "copy.4e8b339e360e": "Doğrula",
  "copy.0d6f1fa66a0c": "İşlem tamamlanamadı. Sözleşmeyi kontrol edip yeniden dene.",
  "copy.04ecad6d68e6": "Yaşam rehberi yüklenemedi",
  "copy.0f2a8cb32d3a": "Rehber bölümlerine şu anda ulaşılamıyor.",
  "copy.584cdb264fb5": "Yaşam rehberin henüz boş",
  "copy.934059f89377": "Sık başvurduğun bilgileri görmek için ilk bölümünü ve tablosunu oluştur.",
  "copy.ae89d6527ab4": "İlk Bölümü Oluştur",
  "copy.1676ecedfef4": "Bölüm yapısı, tablolar ve arşiv işlemleri",
  "copy.46d1d9343679": "Rehber Teknik Yönetimi",
  "copy.b00161b761dd": "Rehber yapısı",
  "copy.1dba8cbb49d6": "Yeni bölüm ve tabloları yalnız rehber yapısını değiştirmek istediğinde oluştur.",
  "copy.341a597b790c": "Yeni Bölüm",
  "copy.93e14ad49287": "Yaşam alanı adı zorunludur.",
  "copy.5c03c6a017b1": "Rehber bölümü adı zorunludur.",
  "copy.37445df2ff1f": "İlk tablo adı zorunludur.",
  "copy.84b770b3cd9a": "İlk tablo alt bileşen olamaz.",
  "copy.261c7540aec3": "Rehber Bölümü Oluştur",
  "copy.d43ef6864841": "Yaşam Alanı Oluştur",
  "copy.58eb21d61454": "{{value1}} ve ilk yayımlanmış tablosu son adımda tek işlemle oluşturulur.",
  "copy.772e527bf179": "Rehber bölümü",
  "copy.8b03bcbfe02f": "İleri",
  "copy.b67770da4471": "Rehber bölümü adı",
  "copy.b3398d737675": "Yaşam alanı adı",
  "copy.029bcd4d8716": "Bölüm açıklaması",
  "copy.2d6881c4cc50": "Alan açıklaması",
  "copy.519248ffd903": "Bu",
  "copy.743c0fc065bf": "rehber bölümünün",
  "copy.edd0394ed3ce": "yaşam alanının",
  "copy.f3fbe80ac981": "ilk kayıt tablosunu adlandır.",
  "copy.4a041b84dc79": "İlk tablo adı",
  "copy.3d0c2647c7ae": "Sabit tablo anahtarı",
  "copy.23a676000f40": "API ve içe aktarma akışlarında değişmeden kalır.",
  "copy.895db68fc4dc": "Tablo açıklaması",
  "copy.d4c6f53bcf95": "Kayıtların davranışını ve gün görünümüne nasıl yerleşeceğini belirle.",
  "copy.67c0eff09485": "Tablo türü",
  "copy.50684197d101": "Zaman modeli",
  "copy.2a801af9df3e": "Varsayılan:",
  "copy.0ef12a5feae7": "Rehber kaydı · Zamansız",
  "copy.bdfa5100770c": "Kayıt · Tarihli",
  "copy.e925de1d7606": "Listelerde kaydı adlandırmak için kullanılır.",
  "copy.fbd385992fa5": "Otomatik seç",
  "copy.5aeb95963477": "İlk tablo",
  "copy.661cbe609a69": "Tür ve zaman",
  "copy.4ccc9faad342": "Özet",
  "copy.8388c5c8329a": "Oluşturma adımları",
  "copy.e53130a9b5f3": " · tamamlandı",
  "copy.70d9341ebe2d": " · şu anki adım",
  "copy.459a85c9febb": "Simge",
  "copy.708170f044f8": "Renk",
  "copy.90d85f17f926": "Teknik anahtar",
  "copy.ec7eb3211ca1": "Sütun",
  "copy.2009fb1f0202": "{{value1}} sütun",
  "copy.bab645e5c03d": "Kayıt başlığı",
  "copy.0295a00221ed": "Oluşturduktan sonra sütun yapısını taslak olarak değiştirebilir, doğrulayabilir ve yeni bir sürüm olarak yayımlayabilirsin.",
  "copy.a3ec194b754f": "Yeni tablo ilk sütun yapısıyla yayımlanır ve hemen kayıt kabul eder.",
  "copy.3b876bbf1cd1": "Rehber bölümünü düzenle",
  "copy.5a0ce35faa68": "Yaşam alanını düzenle",
  "copy.3133a3c28333": "Bölüm adı",
  "copy.9f714c45abd0": "Alan adı",
  "copy.3579a5b8dce0": "Tablo davranışı ve gelişmiş bilgiler",
  "copy.9d713a223446": "Üst tablo",
  "copy.bb0b15dd1edc": "Üst tablo seç",
  "copy.8bcb09b0bcbd": "API ve içe aktarma akışlarının kullandığı teknik kimliktir.",
  "copy.8b0c7ea640c5": "Anlık Ekle",
  "copy.b439385a6437": "Alanları Yönet",
  "copy.c4784b0418f3": "Yaşam Takibi filtreleri",
  "copy.0efe3ec5aabf": "Yalnızca Günlük",
  "copy.74550c419675": "Yalnızca yaşam kayıtları",
  "copy.8323692324bd": "Yapay zekâ",
  "copy.b281ae2e796d": "İçe aktarılanlar",
  "copy.0059bfc57922": "Alan",
  "copy.d54bcd05c8f3": "Tüm alanlar",
  "copy.8bf3a6d0df60": "Tüm tablolar",
  "copy.45bddbcb6875": "Gün görünümü",
  "copy.c40f7d0950e0": "Yaşam Takibi yüklenemedi",
  "copy.285b1875cfbb": "Anlıklar ve Yaşam kayıtları şu anda günlere ayrılamıyor.",
  "copy.2918a5654af6": "Bu aralıkta henüz kayıtlı gün yok",
  "copy.8999cbfc0da5": "Bir Anlık yazdığında veya zaman modeli olan ilk Yaşam kaydını eklediğinde gün kartın burada oluşur. Hazır alan ya da örnek veri eklenmez.",
  "copy.87c7502c13ef": "İlk Anlığı Ekle",
  "copy.43dee155316c": "Daha eski günleri yükle",
  "copy.fbd92ea86a82": "{{value1}} gününü aç",
  "copy.0075c6e1e9a0": "Bu günde metinli Anlık yok.",
  "copy.031bba4c548c": "Metinli Anlık yok",
  "copy.a3b7164d7c6a": "{{value1}} etkin · {{value2}} arşivde",
  "copy.8587f70236da": "Henüz alan yok.",
  "copy.f70cdb62bf29": " · Arşivde",
  "copy.9000af688106": "Takip alanı",
  "copy.c97f66731503": "arşivde. İçerik okunabilir; yeni kayıt ve yapı değişiklikleri kapalıdır.",
  "copy.5467d01eb6a7": "İlişkiler",
  "copy.d7f5fdb60cc9": "Kanıtlar",
  "copy.858a9be12c12": "Çelişkiler",
  "copy.a23213933cdb": "İlham kaynakları",
  "copy.90cc7f4dc17e": "Yapısal bağlantılar",
  "copy.7a420f3e332d": "Takvim yerleşimi",
  "copy.ced8500c67fe": "Kavram haritası",
  "copy.1db88548e667": "Destek oturumu",
  "copy.739b8cd2f14e": "Zaman aralığı",
  "copy.b2049dcb8a3c": "Planda yer alır",
  "copy.a6ea09d691c9": "Projeye bağlı",
  "copy.e3837823e3c2": "Görev içerir",
  "copy.47e669e7ff32": "Plan içerir",
  "copy.b0dbf6a93fd4": "Rutin içerir",
  "copy.28fbadb82823": "Takvime yerleştirir",
  "copy.19d47c06250d": "Takvim yerleşimi var",
  "copy.e557fbaab0bf": "Rutinden üretildi",
  "copy.ee92528df6be": "Üretilen görev",
  "copy.a337c65b08e5": "Karar içerir",
  "copy.0f7528e72bf3": "Bileşenidir",
  "copy.ccadf68fa051": "Bileşen içerir",
  "copy.5442d9060293": "Semantik bağlantı",
  "copy.dd72880443c1": "Yapısal bağlantı",
  "copy.38002356a18d": "Çekirdek",
  "copy.7d8abd0da909": "Bakım",
  "copy.2eea40cbb218": "Fırsatçı",
  "copy.7af4c349fb9d": "Dönem açılamadı",
  "copy.78f04cf3e9eb": "Dönem Çöp Kutusu’na taşınmış olabilir veya şu anda bağlantı kurulamıyor.",
  "copy.0abf4b7a8fc8": "Dönem Çöp Kutusu’na taşınsın mı?",
  "copy.1a8b07ef8509": "Dönem Çöp Kutusu’na taşınır ve oradan geri alınabilir. Bağlı Proje, Plan ve Hedef kayıtları değişmez.",
  "copy.92927aa3ef87": "Dönem Çöp Kutusu’na taşındı",
  "copy.16f3f595bbcd": "Nedeni Düzenle",
  "copy.3aa06f43ba21": "Tanımlanan tarihler, görsel katman ve dönemin bugüne göre konumu.",
  "copy.88e8dd312c7e": "Projeler ve Planlar",
  "copy.364e8742ce26": "Bu dönem içinde yürütülen çalışma yapıları.",
  "copy.c1cf91466150": "Bağla",
  "copy.4c1fb80b2c23": "Bağlı Proje veya Plan yok",
  "copy.cb0dff93af92": "Bu dönem içinde yaşayacak Projeleri ve Planları buraya bağlayabilirsin.",
  "copy.1a65304d7bbf": "Proje veya Plan Bağla",
  "copy.300e07fc2cae": "Bağlı Projeler ve Planlar",
  "copy.86b532cacc4d": "Dönem İşlemleri",
  "copy.d5f884547452": "Aktif",
  "copy.6911d0495ff2": "Başlangıç ve bitiş açık",
  "copy.e0f706a9fb97": "Başlangıç açık",
  "copy.ab8c2f45b191": "Bitiş açık",
  "copy.8cee198fd0e8": "Tarih aralığı tamam",
  "copy.d0c0e63c1d17": "Dönem özeti",
  "copy.5a7da2d1e277": "Dönem Türü",
  "copy.0a1f9917215a": "Zaman Katmanı",
  "copy.304db21f017c": "Katman",
  "copy.ffef64f0fede": "Katman yalnız görsel yerleşimdir",
  "copy.f674ff6c1716": "Tarih Tanımı",
  "copy.c4d301935fdf": "Bağlı Yapılar",
  "copy.fd7c6fe87254": "Başlangıç ve bitiş bağımsız olarak boş bırakılabilir. İki tarih de tanımlandığında dönem zaman çizgisinde görünür.",
  "copy.855dd841aecb": "Görsel yerleşim: Katman",
  "copy.9d464093c415": "Gerçekleşen:",
  "copy.d344e67ff4af": "Sürüyor",
  "copy.bd3283c11c1a": "Tanımlı tarih",
  "copy.6a627696616d": "Tarih belirtilmedi",
  "copy.b60d30a533c6": "Dönemin Nedeni",
  "copy.052f64253f7f": "Bu dönemin yaşam yönündeki yeri ve neden şimdi ele alındığı.",
  "copy.5170c7e2b097": "Tanımla",
  "copy.3515d148a822": "Amaç",
  "copy.7fa0b48ea5dd": "Bu dönemin amacı henüz tanımlanmadı.",
  "copy.e8c2527e6f34": "Neden Şimdi?",
  "copy.c015baf3b1c6": "Zamanlama gerekçesi henüz yazılmadı.",
  "copy.9ba5599dc0cc": "Bağlantı kullanılamıyor",
  "copy.b9a09af98f64": "Kayıt burada kopyalanmaz; aynı Proje veya Plan kaydı bu dönemde görünür.",
  "copy.0f3e725ce1e0": "Başlığa veya açıklamaya göre ara",
  "copy.1e77d1f6af90": "Kayıtlar yükleniyor",
  "copy.e581e06e0f6e": "Getir",
  "copy.fb9f51fe9250": "Rol",
  "copy.929f9d605996": "Destekleyici",
  "copy.3a8ae4aa6cee": "yüklenemedi.",
  "copy.cc7b5c053839": "Bağlantı kurulamadı. Seçimin korundu; yeniden deneyebilirsin.",
  "copy.7f0a8a67ae79": "Hedefler",
  "copy.79e7ec232ff0": "Kanonik Hedefler; bu dönemle ilişki ortak Bağlantılar panelinden kurulur.",
  "copy.272ee08c0fe3": "Henüz Hedef yok",
  "copy.39ca63b48f14": "İlk kanonik Hedefi oluştur; ardından bağlantısını ortak panelden kur.",
  "copy.79cbfb691685": "İlk Hedefi Oluştur",
  "copy.346035bbb822": "Tüm dönemler {{value1}} yıla yayılıyor. Akıcı kullanım için bugüne en yakın {{value2}} yıllık pencere gösterildi.",
  "copy.14229a90f7e0": "Katman sayısı değiştirilemedi. Dönem yerleşimlerini kontrol edip yeniden dene.",
  "copy.b431c281c054": "Önceki aralık",
  "copy.68301023374a": "Sonraki aralık",
  "copy.b5ad9573bff2": "Tümünü sığdır",
  "copy.c32257eb5cbc": "Zaman ölçeği",
  "copy.14ebad4d1610": "Katman sayısı",
  "copy.ee3c3652d518": "Katman azalt",
  "copy.5bef49e1db50": "Katman ekle",
  "copy.beee11d3fc80": "Daha Fazla Dönem Getir",
  "copy.eb919147f805": "Henüz Yerleştirilmemiş",
  "copy.43ddef184c3f": "{{value1}} yerleştirilmemiş dönemi",
  "copy.b83684a6a002": "· Katman",
  "copy.cc3f40f85ca4": "Yerleştir",
  "copy.a5b0558447b9": "Bu tarih aralığında {{value1}} katman da dolu. Yerleşim değiştirilmedi.",
  "copy.d0e13459fdd1": "Yerleşim güncellenemedi. Zaman çizgisi yeniden yüklendi.",
  "copy.f3afc42428d6": "Bu bırakma alanında {{value1}} katman da dolu. Yerleşim değiştirilmedi.",
  "copy.298cc3007f8c": "Dönem zaman çizgisi",
  "copy.3505736508ac": "Geçersiz bırakma alanı: bu tarih aralığında kullanılabilir katman yok.",
  "copy.452f7fb9e112": "Hizalandı: {{value1}} → {{value2}} {{value3}} · {{value4}} · Katman {{value5}}",
  "copy.05af2bb52072": "başka dönem",
  "copy.28622351a58d": "Sürükle: tarih ve katman · Shift: hassas hareket · Kenarlar: başlangıç/bitiş · Ok tuşları: erişilebilir alternatif",
  "copy.763e2d30091d": "Liste olarak göster",
  "copy.4a1848d0ed11": "Dönem listesi",
  "copy.bf5abe9b8e8f": "Açık başlangıç",
  "copy.ad54d5052bba": "Açık bitiş",
  "copy.483992a9e2d1": "Yerleşimi Düzenle",
  "copy.b946c04bbc9a": "{{value1}} başlangıcını değiştir",
  "copy.d8a599e9eb42": "{{value1}}, Katman {{value2}}. Ok tuşlarıyla taşı.",
  "copy.f4c19f8840c1": "{{value1}} bitişini değiştir",
  "copy.36d21936edf3": "Geçersiz tarih aralığı",
  "copy.563085d157bd": "açık başlangıç",
  "copy.4a8cd3bc5a73": "açık bitiş",
  "copy.22becce5badd": ", {{value1}} açık görev",
  "copy.e1ffcba16869": "Dönemi Düzenle",
  "copy.380e872bea1f": "Dönem Oluştur",
  "copy.02f15b581054": "Tarihlerini, görsel katmanını ve yaşam ölçeğini güncelle.",
  "copy.abc934a19a5e": "İçinde bir amacı olan bir hayat parçası. Yürütülebilir değil — altındaki işlere anlam verir.",
  "copy.929f8fa2f9da": "Ölçek",
  "copy.afdb7a6fcfd2": "Zaman çizgisi katmanı",
  "copy.13b3f7bf6cc0": "Bağlayıcılık",
  "copy.4a9625a3ae32": "Yokluyorum — olmayabilir",
  "copy.3f0f9c402640": "Niyetliyim",
  "copy.d4ae18405e3f": "Söz verdim",
  "copy.fd399bcf7c0f": "Bitiş tarihi başlangıçtan önce olamaz.",
  "copy.e088fc7be49e": "Tarihler boş bırakılabilir. İki tarih de tamamlandığında dönem zaman çizgisine yerleşir.",
  "copy.998e50bbb7e3": "Hedefler dönem oluşturulduktan sonra ayrıntı sayfasından bağlanır; yürütme kapasitesi ve dinlenme kuralları Planlayıcı'da kalır.",
  "copy.6af8624b8d50": "Zaman çizgisine yerleştirmek için başlangıç ve bitiş tarihlerini tamamla.",
  "copy.791889afdf62": "Yerleşim güncellenemedi. Bilgilerin korunuyor; yeniden deneyebilirsin.",
  "copy.0f7acb876fe6": "Tek başlangıç, tek bitiş ve görsel katmanı birlikte güncelle. Çakışan bir dönem varsa sistem onu en yakın boş katmana taşır.",
  "copy.a5fd2c3893bd": "Katman yalnız görsel yerleşimdir; dönemin anlamını değiştirmez.",
  "copy.139a10264cf2": "Plan bulunamadı",
  "copy.c10489842ab5": "Bu bağlantıda bir plan kimliği yok.",
  "copy.8d1529342457": "Plan yüklenemedi",
  "copy.80e402eb3665": "Plan silinmiş olabilir veya şu anda sunucuya ulaşılamıyor.",
  "copy.e74052e88611": "en az bir görev veya rutin",
  "copy.a49636c72799": "Planın durumu değiştirilemedi.",
  "copy.e7b434a9b167": "Bu plan için henüz açıklama yazılmadı.",
  "copy.8304853ab5b4": "Taslağa Al",
  "copy.0286d7cad515": "Etkinleştirmek için",
  "copy.db2984dc76b6": "ekleyin.",
  "copy.97e79018f0d8": "Sıralı Görev Akışı",
  "copy.69af571f32a7": "Tarihsiz görevlerde yalnız sıradaki adım genel listelerde görünür. Bu plan içinde bütün adımlar görünür.",
  "copy.43a3d58e4b71": "Bu planda görev yok",
  "copy.8d74eec05124": "İlk uygulama adımını eklediğinizde görev akışı burada oluşur.",
  "copy.b9cf1e4871cd": "İlk Görevi Ekle",
  "copy.3eb7270bd052": "Rutinler plan kurulduktan sonra bu bağlama eklenir.",
  "copy.aea035b02ae3": "Rutinleri Yönet",
  "copy.68f4f4b9a87f": "Bu planda rutin yok",
  "copy.96bcecce0e8c": "Tekrar eden uygulama adımlarını daha sonra buradan bağlayabilirsiniz.",
  "copy.df4a8c3db38c": "Plan özeti",
  "copy.6f3c27d67821": "Bağımsız Plan",
  "copy.5ed83639ab41": "Görev İlerlemesi",
  "copy.a3742b9734ab": "Henüz görev yok",
  "copy.0c2deb578739": "Henüz oluşum yok",
  "copy.daebc159a763": "{{value1}} görev sırası",
  "copy.3366af89311d": "{{value1}} rutin tarafından sıralanır",
  "copy.9dc9cb81d6d7": "Durum Bilinmiyor",
  "copy.1ffa720fef90": "Genel Listede",
  "copy.a0b136334423": "Yalnız Planda",
  "copy.f81a270ad5c1": "{{value1}} liste görünürlüğü",
  "copy.cdd55786e02a": "{{value1}} zamanlamasını düzenle",
  "copy.59ac3cf98517": "Planlanan süre yok",
  "copy.03a3be428311": "Planlanan süre {{value1}}",
  "copy.9882025b673c": "Planın tarih sınırı yok",
  "copy.bfd2e9ec35ed": "Rutinin tarih sınırı yok",
  "copy.bdbbed71e904": "Bu plandaki etkin aralık: {{value1}} · Rutinin kendi aralığı: {{value2}}",
  "copy.e0b05c8d7324": "Plan kaydedilemedi. Yeniden deneyin.",
  "copy.623e519ea5b9": "Plan adı zorunludur.",
  "copy.518fad2c1a39": "Başlangıç ve bitiş birlikte seçilmelidir.",
  "copy.8b1b196e813d": "Planı Düzenle",
  "copy.6d1ecad349c8": "Planın kapsamını ve çalışma aralığını tanımlayın. Görevler ve rutinler daha sonra plan ayrıntısından eklenir; semantik bağlar ortak Bağlantılar panelinde yönetilir.",
  "copy.ef34af7a1d51": "Projesiz plan",
  "copy.b5fa2e4a903c": "Tarih aralığı belirlenmedi",
  "copy.ba34b2fd646c": "Tarih sınırı yok",
  "copy.73aa2d75c533": "Rutinin kendi aralığı: {{value1}}",
  "copy.f9882d2541a4": "Bu plandaki etkin aralık: {{value1}}",
  "copy.8a0b7c83e9aa": "Rutin bağlantıları kaydedilemedi. Yeniden deneyin.",
  "copy.6dcea34e6d37": "Plan Rutinlerini Yönet",
  "copy.34a7272e65f4": "Rutinleri bağlayın ve yalnız bu planda kullanılacakları tarih aralığını belirleyin. Bu tarihler rutinin kendi tanımını değiştirmez.",
  "copy.db792ab5ced3": "Rutinleri Kaydet",
  "copy.a79c68f74b2d": "Rutinlerde Ara",
  "copy.bc3482cf26e7": "Plan Rutinleri",
  "copy.349a08c7a711": "Bağlantı tarihini boş bırakırsanız Planın başlangıç veya bitiş tarihi kullanılır. Rutin kendi tarih aralığının dışında yine oluşum üretmez.",
  "copy.a9a9c9e16159": "Diğer rutinler yüklenemedi",
  "copy.0bfae90fadc6": "Mevcut bağlantıları görebilir veya kaldırabilirsiniz; yeni bir rutin eklemek için listeyi yeniden yükleyin.",
  "copy.0ae9722fb298": "Bağlanabilecek rutin yok",
  "copy.4fb4a17e274e": "Önce Rutinler sayfasında bir rutin oluşturun.",
  "copy.c560d2492775": "Aramayla eşleşen rutin yok",
  "copy.56751f567f26": "Farklı bir başlık veya bağlam deneyin.",
  "copy.fb8d508c1376": "Bağlı",
  "copy.899f7ab0a013": "Bu plandaki bağlantı tarihleri",
  "copy.c39af090ea2f": "Etkin aralık:",
  "copy.59075d4fa3fe": "{{value1}} bağlantı tarihlerini temizle",
  "copy.011d55aefcd7": "Tarihleri Temizle",
  "copy.b3dc8ba4aff4": "{{value1}} bağlantı başlangıç tarihi",
  "copy.64071ccb610e": "{{value1}} bağlantı bitiş tarihi",
  "copy.0b55754c7340": "Rutinin kendi aralığı:",
  "copy.93312536225b": "Arşivlenmiş bir rutin yeniden kaydedilemez. Diğer bağlantıları değiştirmeden önce bu rutinin seçimini kaldırın veya Rutinler sayfasından geri yükleyin.",
  "copy.27b4eefdef1f": "Plan durumuna göre filtrele",
  "copy.67ef93689230": "Tüm Durumlar",
  "copy.4a16a8e1275f": "Etkin Planlar",
  "copy.14a803d9acaf": "Duraklatılanlar",
  "copy.a44b1c556989": "Tamamlananlar",
  "copy.b642eadf7f02": "İptal Edilenler",
  "copy.3236ea169953": "Henüz plan yok",
  "copy.43c803ce46ea": "Bu durumda plan yok",
  "copy.daa03929678c": "Bir plan; zaman aralığını, sıralı görevlerini ve o aralıkta geçerli rutinleri birlikte gösterir. Hedef gibi semantik ilişkiler ortak Bağlantılar panelinden kurulur.",
  "copy.4251c7b23585": "İlk Planı Oluştur",
  "copy.73ac916651d6": "{{value1}} planını sırala",
  "copy.7b0d5cffae67": "Kapsam",
  "copy.19a48a60f80e": "Görev Durumu",
  "copy.bd03ca7dad02": "projesi",
  "copy.5f4fc24534ee": "Ayrıntıyı Aç",
  "copy.0e8b8adf29a2": "Kişisel alan",
  "copy.8d3acf9bc42d": "Tüm gün",
  "copy.cdbb6c818fc5": "{{value1}} planlı kayıt, korunan zamanla toplam {{value2}} kesişiyor.",
  "copy.97cd70bd8c6f": "Planlı ve korunan zaman, kalan uyanık süreyi {{value1}} aşıyor.",
  "copy.6e01fa30ba57": "Bu günde {{value1}} korunan zaman bulunuyor.",
  "copy.148afd948550": "Plan ve korunan zaman dışında {{value1}} açık zaman bulunuyor.",
  "copy.ce6182e5a852": "Bu günün kayıtlarında dikkat çekebilecek bir örüntü bulundu.",
  "copy.6ee0f005f655": "Korunan Yaşama Zamanı",
  "copy.9caccd9df722": "Plan dışında kalmasını istediğin dinlenme, keyif ve ilişki alanları.",
  "copy.6ee0d295bf76": "Korunan zaman ekle",
  "copy.c20ca4db5102": "için korunan bir zaman tanımlı değil.",
  "copy.98a00fa412c1": "Korunan zaman",
  "copy.2b7c80cc9b5c": "Planlama gözlemleri",
  "copy.aa955a174652": "AI gözlemi:",
  "copy.ee85a93741e6": "“{{value1}}” silinsin mi?",
  "copy.99b1bdef2437": "Bu zaman artık günlük kapasite hesabında korunmayacak.",
  "copy.6bf9e0080742": "Korunan zaman silindi",
  "copy.1a669f572aaa": "Korunan zaman silinemedi",
  "copy.88b26571e318": "Bu alanlar gün kapasitesinde planlı işten ayrı görünür; görevleri otomatik olarak taşımaz.",
  "copy.953e891c543b": "Zaman Ekle",
  "copy.8da662775cf2": "Korunan zamanlar yüklenemedi",
  "copy.3f612249c199": "Henüz korunan zaman yok",
  "copy.a7f80051b068": "Uyku, dinlenme, yemek, hareket veya kişisel zamanını planın dışında görünür tutabilirsin.",
  "copy.040cffe162d6": "{{value1}} zamanını düzenle",
  "copy.a84b95a3a8ab": "{{value1}} zamanını sil",
  "copy.ef626a1f4110": "Korunan zamanın adını yaz.",
  "copy.c069738b0c08": "Başlangıç ve bitiş saatini birlikte seç.",
  "copy.d0b870c1c55a": "Bitiş saati başlangıç saatinden sonra olmalı.",
  "copy.5c946d4870ed": "Son geçerlilik günü ilk günden önce olamaz.",
  "copy.6485ee83fa7b": "Korunan zaman eklendi",
  "copy.601ded68bff8": "Korunan zaman güncellendi",
  "copy.c53c184d76a2": "Korunan zaman kaydedilemedi. Alanları kontrol edip yeniden deneyebilirsin.",
  "copy.326c0cde5770": "Korunan Zaman Ekle",
  "copy.da76dfd3e3c0": "Korunan Zamanı Düzenle",
  "copy.d9ed1ead0888": "Bu kayıt yalnızca zamanın anlamını ve yerini gösterir; görevleri değiştirmez.",
  "copy.1d97c9fec35a": "Ad",
  "copy.1968988727dc": "Örn. Akşam dinlenmesi",
  "copy.0834ffadb2fd": "Günler",
  "copy.072a779858ba": "Tekrarlanan günler",
  "copy.31565069849f": "Gün seçilmezse kayıt her gün geçerli olur.",
  "copy.68a01c9826c4": "Geçerlilik ve görünürlük",
  "copy.8d04adbd691f": "İlk gün",
  "copy.b51cb4cab2c8": "Son gün",
  "copy.403b54e5bad3": "Neden korunduğu",
  "copy.5a66003ed8be": "İstersen bu alanın sende neyi koruduğunu yaz.",
  "copy.e7cbf5c7729e": "Çakışmayı belirgin göster",
  "copy.8d85780e3da3": "Planlı bir görev bu zamana değdiğinde gözlem olarak görünür.",
  "copy.2b77c37eabf0": "Kapasite hesabına dahil",
  "notes.filtered_title": "Bu filtrelere uyan not yok",
  "notes.filtered_description": "Aramayı ve filtreleri temizleyin ya da yeni bir not oluşturun.",
  "notes.clear_filters": "Filtreleri temizle",
  "copy.4be9e99a2c39": "{{value1}} tarihine taşındı",
  "copy.45cc224f3d80": "Saat ve planlanan süre korundu.",
  "copy.2428ea8c2ccd": "Takvim kaydı taşınamadı",
  "copy.e6c4207d9f13": "Mevcut zamanlama korunuyor; yeniden deneyebilirsin.",
  "copy.0e34d0419e45": "Görev tarihsizleştirilsin mi? Tarih ve saat kaldırılır; görev kalır.",
  "copy.b88019aa289e": "Kaldır",
  "copy.72f0b2814f11": "Yalnız Saati Kaldır",
  "copy.8db3815f273a": "Tarihsizleştir",
  "copy.e5c5555013e4": "{{value1}} önce",
  "copy.ad281cacd4cb": "Hızlı Taşı",
  "copy.f7f801432011": "Bir Gün Geri",
  "copy.baa86253b900": "Bir Gün İleri",
  "copy.a31a3d5209b8": "Bu blok gece yarısını geçiyor",
  "copy.a18692783a0c": "Görev detayını aç",
  "copy.3a428a31e175": "Hafta",
  "copy.c85a3445186c": "Ay",
  "copy.7a3d5c66c512": "Yıl",
  "copy.567d2861e924": "Adsız görev",
  "copy.4969f1984525": "Takvim Zamanlama Alanı",
  "copy.c59d374175b7": "Takvim dönemi ve görünümü",
  "copy.68684cad283f": "çakışma",
  "copy.d1b88dc70ce7": "Belirli tarihe git",
  "copy.c57487f54670": "Belirli Tarihe Git",
  "copy.64b89017e71e": "Takvim Görünümü",
  "copy.435aa213b79a": "Önceki Dönem",
  "copy.34288f4523b4": "Sonraki Dönem",
  "copy.2ea0ab5cf924": "Takvim yüklenemedi",
  "copy.f5d1384a3532": "Takvimdeki görevlerine şu anda ulaşılamıyor.",
  "copy.8b39f318881d": "Takvimdeki görev ·",
  "copy.4194b609427e": "çakışan kayıt",
  "copy.0ae0df91657c": "Çakışma yok",
  "copy.323f88bce5fc": "Seçerek düzenle · Masaüstünde sürükleyerek taşı",
  "copy.094e329c373a": "Görev Takvime Eklendi",
  "copy.9d209943b397": "Görev Takvime Eklenemedi",
  "copy.11b0a0f5a4b4": "Görev tarihsiz olarak kaldı; yeniden deneyebilirsin.",
  "copy.e5dd861fed38": "Görev Takvime Taşındı",
  "copy.e4ae77e21aa9": "Takvim Kaydı Taşınamadı",
  "copy.d36596a5bad3": "Mevcut tarih ve saat korunuyor; yeniden deneyebilirsin.",
  "copy.a4de876fc31d": "{{value1}} takvimine taşındı",
  "copy.23d364bbcf30": "Görev saatsiz alana bırakıldı.",
  "copy.04628d31520b": "Saat ve süre güncellendi.",
  "copy.0123c78626eb": "Önceki tarih ve saat geri getirildi.",
  "copy.028381aafdcf": "Görev Seçili Tarihe Eklendi",
  "copy.254d2c4ef745": "Görev Planlanamadı",
  "copy.09c509a72b8c": "Mevcut plan korunuyor; yeniden deneyebilirsin.",
  "copy.6dc5b1b6637f": "Görev Tarihsizleştirildi",
  "copy.eb3f061ed1e9": "Takvim tarihi ve saati kaldırıldı; görev korunuyor.",
  "copy.fa2f5bb50075": "Görev Tarihsizleştirilemedi",
  "copy.34736a99c8f5": "Mevcut takvim kaydı korunuyor; yeniden deneyebilirsin.",
  "copy.02b0326d5995": "Adsız Görev",
  "copy.121ec13991c7": "Planlanacak Görevler",
  "copy.765289e9da60": "Tarihsiz Görevler bırakma hedefi",
  "copy.65a45ef05ebf": "Sürükle ve Tarihsizleştir",
  "copy.3ad2c522a011": "Görevleri gün ya da saate sürükle.",
  "copy.e548d2b67eba": "{{value1}} · {{value2}}. {{value3}} tarihine eklemek için seç veya takvimde bir gün/saat üzerine sürükle.",
  "copy.bf9c3c011d51": "{{value1}} · {{value2}}. Seçili Tarihe Ekle.",
  "copy.cfcaa4fe24c1": "Planlanacak görev yok.",
  "copy.a0f11fd3836c": "{{value1}} saat aralığı",
  "copy.1ee05cadf5e6": "Saati Olmayan Görevler",
  "copy.8df6ec34132f": "Gün içinde, saat bekliyor",
  "copy.05df844d9f2d": "{{value1}} saatsiz görev alanı",
  "copy.d086b15fde52": "Bu güne saatsiz görev bırakılmamış.",
  "copy.e05143c2dc77": "· Bugün",
  "copy.62d546f04e0c": "Saatsiz",
  "copy.3159a7fbc91b": "saatsiz",
  "copy.df3c2a61209e": "{{value1}} saatli görev alanı",
  "copy.a80c6803c5b3": "Süre {{value1}} olarak değiştirildi",
  "copy.46fd03c54674": "Görev süresi değiştirilemedi",
  "copy.23db35574d60": "Önceki süre geri getirildi.",
  "copy.846f0ac09a53": "Zaman çakışması",
  "copy.34ad4b19462d": "{{value1}} takvim öğesini aç · {{value2}}",
  "copy.84315466a95a": "Süreyi değiştir",
  "copy.97a4891899f5": "{{value1}} · Gün Planını Aç",
  "copy.7f2193270b7f": "kayıt daha",
  "copy.d4271592aa66": "{{value1}} · {{value2}} kayıt",
  "copy.65fdaf5aa32f": "{{value1}} · {{value2}} kayıt{{value3}}",
  "copy.eddaa78d27e9": " · günü planla",
  "copy.524d77f07472": " · boş günü planla",
  "copy.922970e0dc97": "Zamanlama Korundu",
  "copy.32cb50ba8a7a": "Görev günün görevleri alanına bırakıldı; tarih ve saat değiştirilmedi.",
  "copy.955ee8d107f2": "Gün Planı",
  "copy.c2c0c5e32e96": "Gün Planı Görünümü",
  "copy.811f29689449": "Dairesel Akış",
  "copy.d11a92bd9f4a": "Saat Tablosu",
  "copy.da6b786b2bcc": "Gün planı yüklenemedi",
  "copy.bf3935864545": "Seçili günün takvim kayıtlarına şu anda ulaşılamıyor.",
  "copy.4db5ed5675f0": "Gün planı zamanlama bırakma hedefleri",
  "copy.06218a631907": "Görevi bu alanlardan birine bırak",
  "copy.36525fb3546f": "Yalnız Saati Kaldır bırakma hedefi",
  "copy.f64d1be8a5c0": "Tarih korunur",
  "copy.b44940cd7eec": "Sonraki Güne Ertele bırakma hedefi",
  "copy.70cd0bcfca5f": "Sonraki Güne Ertele",
  "copy.cff7d599fef0": "Saat korunur",
  "copy.5930c5536cb1": "Tarihsizleştir bırakma hedefi",
  "copy.ab72d2b2af60": "Tarih ve saat kalkar",
  "copy.9a5e325a9623": "Günün Görevleri",
  "copy.866753ea0a6c": "Bu güne henüz görev yerleştirilmemiş.",
  "copy.32700da22c1a": "Saat bekliyor",
  "copy.544e3ddadc82": "{{value1}} takvim öğesini aç",
  "copy.f55ed15e7068": "Bildirimler, {{value1}} okunmamış",
  "copy.bf8e8e9e5f41": "Bu oturumda teslim edilen hatırlatıcılar",
  "copy.22103a46d24d": "Henüz bildirim yok",
  "copy.fefb442f15a2": "Bu sekme açıkken teslim edilen hatırlatıcılar burada görünür.",
  "copy.8e5b0b3db3d7": "Son bildirimler",
  "copy.ead388599a02": "Tarayıcı bildirimleri açık",
  "copy.564e9113da50": "Hatırlatıcıları tarayıcıda da göster.",
  "copy.d1b502d5bc18": "İzin isteniyor…",
  "copy.0de3ec9400c0": "Bu tarayıcı sistem bildirimlerini desteklemiyor; uygulama içi bildirimler burada görünür.",
  "copy.9015c3eda7fb": "Tarayıcı izni kapalı; uygulama içi bildirimler burada görünmeye devam eder.",
  "copy.1edbe5d0d161": "Teslim edildi",
  "copy.156f054c5d19": "Gün kapasitesi",
  "copy.e3ff6c057763": "kalan boş zaman",
  "copy.ffb3343777bb": "boş zaman",
  "copy.62c1abea616b": "Kalan günün planlı ve korunan zaman dağılımı",
  "copy.84c49fe82a6d": "'te bitiyor — ertesi güne taşıyor.",
  "copy.86cda89bf510": "planlı",
  "copy.2e5ae066befc": "korunan",
  "copy.9e583f76b263": "uyanık",
  "copy.aa833a0bd7bf": "Açık zaman aralıkları",
  "copy.028f50732ae1": "Açık aralıklar",
  "copy.e5ceb645a780": "Planlı ve korunan zaman, kalan uyanık süreyi",
  "copy.d1b53062af38": "aşıyor.",
  "copy.7c590a630796": "Bugün takvimde iş yoktu",
  "copy.0f0415606643": "Buraya koyduğun her şey tamam",
  "copy.9031bd5e5eac": "Bugünün takvim işleri tamam",
  "copy.60b9577bcda2": "Birkaç karar alanı açık",
  "copy.ac23d768bb65": "Takvimsiz bir gün de bir gündür. Uzlaştırılacak bir zamanlama yok.",
  "copy.d54b023b7bbc": "Bekleyen bir karar kalmadı. Günü kapatabilirsin.",
  "copy.901df9adda50": "Sistemde karar bekleyen başka şeyler var, ama onlar bugünün işi değil.",
  "copy.89b7dfdcabc5": "Bugüne bağladığın işlerden bazıları hâlâ açık.",
  "copy.60347f9d0b0c": "Takvimdeki iş",
  "copy.ec4c3940cafb": "Kaydedilen odak",
  "copy.3378237f49d0": "Bekleyen kararlar",
  "copy.883dbaa94e8d": "Sonraki taahhüt",
  "copy.b92e5120e9a5": "Gün Kapandı",
  "copy.a52ece1329ab": "Günü Kapat",
  "copy.79c4b04b6ee8": "Tamam",
  "copy.d089deff4e75": "Bekleyen karar yok.",
  "copy.6b93617606da": "Kapatmak yine de mümkün; hiçbir şey silinmez.",
  "copy.4ddec81a8054": "Gün uzlaştırması yüklenemedi",
  "copy.ae7431c5ad30": "Planın durumu doğrulanmadan günü kapatamayız.",
  "copy.011c6e5ef854": "Yatma saatine",
  "copy.9e89e4826d45": "boş zaman kaldı.",
  "copy.d9441d91da97": "Not (isteğe bağlı)",
  "copy.00782a540398": "Bugünle ilgili not etmek istediğin bir şey…",
  "copy.5469858dcc53": "Buraya koyduğun her şey yerinde. Gerisi yarına.",
  "copy.172099767158": "Bu gün kapatıldı.",
  "copy.70e8fb4fae39": "takvim işi",
  "copy.523294ebb6b2": "gününü yeniden aç",
  "copy.df9f4b74bc0c": "Anlık bağlam yüklenemedi",
  "copy.85bb10ea023f": "Çizelge, dönem ve son durum kayıtları birlikte okunamadı.",
  "copy.31884e949336": "Anlık Bağlam",
  "copy.01ad6ba43265": "aktif dönem",
  "copy.91bfc2b7ef5b": "aktif proje",
  "copy.8a5db2e94a0a": "kalan görev",
  "copy.78ea7fdf394d": "kalan çizelge",
  "copy.7345e60c81aa": "Bitmesine {{value1}}",
  "copy.d70974e70320": "Başlamasına {{value1}}",
  "copy.5f820fa37979": "Bugün tamamlanmayı bekleyen görev yok.",
  "copy.cc760ec022c0": "Aktif Yön",
  "copy.9640929920ab": "Aktif dönem veya proje yok.",
  "copy.bd7cf36cf2be": "Yaklaşanlar",
  "copy.76f4d3fa4845": "Yaklaşan proje tarihi yok.",
  "copy.09b39d3a25eb": "geciken görev",
  "copy.8f1aed8fecc4": "açık taslak",
  "copy.03f3621b3140": "Odak sürüyor",
  "copy.78c9c070ec98": "Saatini değiştirmek için gün akışına sürükle",
  "copy.3f5bfafe54a5": "Saat seçilmedi",
  "copy.467ed1a61153": "Saate sürükle",
  "copy.6a51ba2a4c79": "Şimdi",
  "copy.06942e808a97": "Geçti",
  "copy.83893db25b56": "{{value1}} dk önce hatırlat",
  "copy.5c3f46032c57": "Hatırlatıcı var",
  "copy.69a3d194baa8": "Tarihsiz görev yok",
  "copy.92001100eca6": "Bir güne bağlanmamış görünür açık görev bulunmuyor.",
  "copy.22748dcebc7f": "boş",
  "copy.871e490c3da8": "sonrası",
  "copy.79777ba97d30": "Şu an {{value1}}",
  "copy.05663d97d4ed": "Başlarken",
  "copy.fdd029276778": "Exognitos hatırlamayı üstlenir; sen düşünmeye devam et.",
  "copy.548cc182668c": "Aklında tuttuğun her şeyi buraya bırakabilirsin. Tek kural: yakalarken karar vermek zorunda değilsin — ne olduğuna sonra bakarsın.",
  "copy.4df9fa6e0f2b": "Aklından geçen bir şeyi yakala",
  "copy.da2535304a18": "Bir iş, bir fikir, unutmak istemediğin bir cümle. Sınıflandırmak sonraki adım.",
  "copy.c0f848957280": "Bir alan ve bir proje aç",
  "copy.8064b8ebb97d": "Alan hayatının süregelen bir parçası — “Üniversite”, “Sağlık”. Proje ise biten bir iş.",
  "copy.3126e14f2045": "Düzenle'ye git",
  "copy.f8ce84ed4d50": "Tek Bir Şeyi Bugün Takvime Ekle",
  "copy.f07e4b1a435a": "Tarihsiz listesinden bir görevi saate sürükle. Gün kapasitesi ne kadar yerin kaldığını söyler.",
  "copy.a6c2ff64f0bf": "Bugün için sıradaki görev yok.",
  "copy.473acc1fd33b": "Yarınki ve tarihsiz görevler bu kartta öne alınmaz.",
  "copy.6a98ba6759ef": "Yaklaşıyor",
  "copy.183896bdd9c4": "Görev tamamlandı",
  "copy.2477007bad7e": "Zaman bilgisi",
  "copy.89f8e5676026": "'da başlıyor",
  "copy.338b15bb3ad7": "Sıradaki görev eylemleri",
  "copy.506fb0c58f9d": "Şimdi Ne?",
  "copy.2969d21826b2": "Görevi Tamamla",
  "copy.5f6769fd00eb": "İşlenmemiş taslak",
  "copy.1f588431fe4d": "Önemli, takvimde yok",
  "copy.613e6d93b76f": "Sonraki adımı yok",
  "copy.d7e693d58a3e": "Karar bekleyenler yüklenemedi",
  "copy.a0f2d38d2933": "Boş görünmesi veri olmadığı anlamına gelmeyebilir.",
  "copy.949d313bac52": "Planı ya da kararı eksik bir taahhüt yok.",
  "copy.f60f7e41e4f6": "Açık döngüler, henüz planı ya da kararı verilmemiş ve dikkatini meşgul etmeye devam eden taslaklar, görevler veya projelerdir.",
  "copy.88da7c754722": "tane daha karar bekliyor",
  "copy.e1becffa59af": " · {{value1}} gün",
  "copy.156d843f1117": "Görev zamanlama bırakma hedefleri",
  "copy.6879dbd9f7d3": "Gerçekleşen odak",
  "copy.0654294bbd2f": "Hafta görünümü yüklenemedi",
  "copy.e92e98582d3f": "Bu aralığın plan ve odak özeti alınamadı.",
  "copy.972e3131cb1b": "öğe",
  "copy.4eece1005539": "Bu hafta",
  "copy.20e352b074a6": "planlandı,",
  "copy.072cd074faf8": "odak kaydedildi.",
  "copy.d248747f7370": "Ay görünümü yüklenemedi",
  "copy.f475ea7072b8": "Takvim özeti şu anda alınamıyor.",
  "copy.45fd575db625": "1 saat önce",
  "copy.279bedb85334": "Zamanlama kaydedilemedi. Bilgileri koruduk; yeniden deneyebilirsin.",
  "copy.207ee1b4fd46": "Zamanlamayı Kaydet",
  "copy.6b2e51ccbd5b": "Tarih zorunludur.",
  "copy.0afcaf7e8ba5": "Boş bırakılırsa görev bu tarihte saatsiz görünür.",
  "copy.678617918c97": "Yalnız saat belirtilen görevlerde kullanılabilir.",
  "copy.1e64449a0aab": "Görevin Saati Kaldırıldı",
  "copy.b54cee1d05c2": "Tarih korundu; görev artık saatsiz.",
  "copy.39bcc93a77b7": "Görevin Saati Kaldırılamadı",
  "copy.539731aa1bb7": "Görev Sonraki Güne Ertelendi",
  "copy.e0e274d7db42": "Saat korundu.",
  "copy.274186eea66f": "Görev Ertelenemedi",
  "copy.0c887af84ab0": "Tarih ve saat kaldırıldı; görev korunuyor.",
  "copy.b3f2c677de5b": "Görev görev kutusuna bırakıldı; tarih ve saat değiştirilmedi.",
  "copy.53a1a38c4b64": "Sıradaki",
  "copy.e8697e13892a": "Görev Oluştur",
  "copy.f1d48e85474e": "Önceki",
  "copy.ffe6922f5329": "Sonraki",
  "copy.8563f1a3e765": "Günün çizelgesi yüklenemedi",
  "copy.1b4218323223": "Zaman çizelgesine şu anda ulaşılamıyor.",
  "copy.6c5b950cdabd": "Gün Akışı",
  "copy.6f067d3d2a06": "zamanlı",
  "copy.320bbb51ca6c": "Gecikmişler",
  "copy.2755cbdb10d5": "Bu güne görev eklenmemiş",
  "copy.ba19f680628f": "Görev ekle ile doğrudan bu gün için oluşturabilirsin.",
  "copy.dc6bbd7e39f1": "Geçmiş güne kalan veya planlanan bitişi geçen açık görev bulunmuyor.",
  "copy.ca91214c14b4": "Takvim Ayrıntıları",
  "copy.c44bfda2d42d": "{{value1}} saatsiz görev · {{value2}} gecikmiş · {{value3}} tarihsiz",
  "copy.7a0236f9b07b": "Takvim ayrıntısı",
  "copy.a7caf0331a44": "Ajanda",
  "copy.7b1ff8940b18": "Gün Kapasitesi",
  "copy.041b04b13dd8": "Açık Döngüler",
  "copy.1df768b69f7a": "Şimdi Ne Yapsam?",
  "copy.9b946942b0e0": "Bugünün Planına Dön",
  "copy.d16975e3682b": "Seçili gün özeti",
  "copy.8baf2bd56c8d": "Gün kapatıldı",
  "copy.a517fd9ccd5e": "Seçili gün",
  "copy.1367d164d3de": "Bu gün için açık bir görev yok",
  "copy.bbff3cc44852": "toplam",
  "copy.972f55dfde4d": "şu anda takvimde",
  "copy.c43fadb32d41": "birazdan başlıyor",
  "copy.b41304448c97": "saati geçti",
  "copy.be0d4d7a11b0": "bugünün rutini",
  "copy.31c67cc7d301": "süreye uyuyor",
  "copy.30e4f975a6db": "Elindekine göre sıralanır",
  "copy.429cfaae4507": "Ne kadar vaktin var?",
  "copy.f0af7abef99b": "Fark etmez",
  "copy.7431192d0860": "Enerjin nasıl?",
  "copy.4962e8ad77d5": "Rutinler dahil",
  "copy.888fdc89e9bb": "Öneriler yüklenemedi",
  "copy.7a40fc5340cd": "Seçimlerin korundu. Bağlantını kontrol edip yeniden deneyebilirsin.",
  "copy.e95be2508a09": "Bu koşullara uyan bir şey yok",
  "copy.d920fadb0297": "Süreyi biraz uzatmayı ya da rutinleri dahil etmeyi dene.",
  "copy.7a2c6f3cc690": "Şu an bekleyen bir iş görünmüyor.",
  "copy.fb62ef2f7f99": "Hepsi birden fazla geliyorsa",
  "copy.6bdceb20bea9": "Bazen sorun hangi işin seçileceği değil, kafanın dolu olması.",
  "copy.99dec6f1fe61": "Yıl görünümü yüklenemedi",
  "copy.bbc1ce402c1d": "Yıllık hareket ve proje özeti eksik olduğu için sıfırmış gibi gösterilmiyor.",
  "copy.b7fd9da06d85": "Ölçü",
  "copy.4b19a5512c11": "Hareketli gün",
  "copy.997a63cd3cea": "geçen günlerin %{{value1}}'i",
  "copy.79028a6a0938": "henüz başlamadı",
  "copy.30ea21e2b1fb": "En uzun seri",
  "copy.6a443fe02638": "Yıl Isı Haritası",
  "copy.950979c16ee9": "kayıtlı odak süresi",
  "copy.b639cf07f7a3": "tamamlanan iş sayısı",
  "copy.f77cc3558af2": "{{value1}} tamamlanan iş",
  "copy.df8c91e0cb09": "Bu Yıl Yaşayan Projeler",
  "copy.f9bc6ea72598": "son dokunulana göre",
  "copy.f0159e35020a": "Açık proje yok. Yıl görünümü bir plan yüzeyi değil; burada gösterilecek bir şey olmaması da bir cevaptır.",
  "copy.9ab725a48080": "ihmal",
  "copy.ffd6025ead4a": "{{value1}} gün önce",
  "copy.9c0ada37bf74": "az",
  "copy.bac07d9099f7": "çok",
  "copy.4d87bf4a4f86": "Geri Al",
  "copy.d48d2105e0de": "aç",
  "copy.5bcfa78d10bb": "Tahmini süre",
  "copy.52631b805293": "Bilgi türü",
  "copy.b5a5f13a5a99": "Proje türü",
  "copy.1602666d69e6": "Tekrar Dene",
  "copy.cc3a034f37ac": "Yaşam alanları",
  "copy.da066049de59": "arşivlendi",
  "copy.254bb97b57f1": "not",
  "copy.03db18f5e980": "Zaman Çizgisi",
  "copy.fef9549d3b6c": "Bağlantıyı Kaldır",
  "copy.0549f9596210": "Kayıt Türü",
  "copy.d469d789b381": "başlangıç",
  "copy.cb2f38934e37": "bitiş",
  "copy.29640274b07e": "{{value1}} Projesine Dön",
  "copy.16610570205e": "Planlara Dön",
  "copy.99f96301643e": "Değişiklikleri Kaydet",
  "copy.982883a3ffc7": "Tamamlanan görev",
  "copy.bff2f01c32e8": "Rutin ayrıntısı",
  "copy.baf2e1b17246": "Görev ayrıntısı",
  "copy.c1fc8fefe11e": "gün",
  "copy.64879f7d6b96": "plan",
  "copy.77d8cdbe3a1c": "odak",
  "copy.d2ad57acc9b2": "Şu An",
  "copy.189fca6d12be": "Sıradaki Görev",
  "copy.1350e9df4f9a": "Yakala",
  "copy.a568461fb985": "Karar bekleyen bir şey yok",
  "copy.201ebd24501b": "Kaynak rutini aç",
  "copy.829baf39688d": "Gelecek Hafta",
  "copy.49f9a444a20e": "tamamlanan",
  "copy.66b72e853724": "gecikmiş",
  "copy.81af230f2a77": "yüksek öncelik",
  "copy.5b09d3fe7430": "bugün",
  "copy.816d65211cc4": "Çalışma bağlamı",
  "copy.cd670e8f865d": "açık iş",
  "copy.093575e59d1c": "Not Seç",
  "copy.df461377a4b8": "Bu Projeye bağlı not yok",
  "copy.1b0d554a536f": "Hafıza'daki bir notu Proje bağlamına bağladığında burada görünür.",
  "copy.1bae74831f56": "Modern Light",
  "copy.735c05e384d9": "Temiz, dengeli ve gün ışığına uygun.",
  "copy.66e1c11b287a": "SaaS Navy",
  "copy.c5d975e18199": "Exognitos'un katmanlı lacivert kimliği.",
  "copy.3af07dceb19d": "OLED Black",
  "copy.88dbcb2b0903": "Saf siyah zeminde düşük ışık tüketimi.",
  "copy.87477d444bd6": "Nordic Cold",
  "copy.8de5e0a8a700": "Soğuk, berrak ve sakin çalışma yüzeyi.",
  "copy.320515b8209b": "Solarized Light",
  "copy.a4830d3dd2fd": "Yumuşak sıcaklıkta uzun odak oturumları.",
  "copy.af30a45d7674": "Monokai",
  "copy.b195b5c41545": "Yüksek okunurluklu koyu renk uyumu.",
  "copy.faf73cec0083": "High Contrast",
  "copy.331e054eab13": "Belirgin sınırlar ve güçlü erişilebilirlik.",
  "copy.a565583a03f2": "Pastel Minimalist",
  "copy.13b7ae63ab89": "Hafif pastel katmanlarla sakin görünüm.",
  "copy.12d74372034a": "Sepia / Focus",
  "copy.42e50ee6cccf": "Okuma ve yazma için düşük parlamalı tonlar.",
  "copy.84ad688ed1e8": "Cyberpunk",
  "copy.76e9049df535": "Gece çalışmaları için neon vurgulu koyu yüzey.",
  "copy.72505bef1243": "{{value1}} penceresini kapat",
  "copy.38ed0d380a85": "Pencere",
  "copy.cba3f60c03a3": "planlanan",
  "reorder.moveUp": "Yukarı taşı",
  "reorder.moveDown": "Aşağı taşı",
  "reorder.previousCollection": "Önceki koleksiyon",
  "reorder.nextCollection": "Sonraki koleksiyon",
  "memory.recent": "Son Kullanılanlar",
  "memory.unfiled": "Dosyalanmamış",
  "notes.open_count_one": "{{count}} not",
  "notes.open_count_other": "{{count}} not",
  "window.moment": "Anlık",
  "window.note": "Not",
  "records.columns_one": "{{count}} sütun",
  "records.columns_other": "{{count}} sütun",
  "copy.a33a25f4d3e2": "Beslenme",
  "copy.f3821eae3e3a": "Kahve",
  "copy.819b1dd8e6d1": "Uyku",
  "copy.1d8412f6c563": "Egzersiz",
  "copy.4afe6f98a42d": "Okuma",
  "copy.1e99298c6679": "Aktivite",
  "copy.2d88a3a2842e": "Su",
  "copy.bc462b2ecd4b": "Zihin",
  "copy.086f264fd79b": "Ev",
  "copy.d48ba7f37166": "Dinlenme",
  "copy.a8372e80d2c0": "Yemek",
  "copy.96c3fdb57013": "Hareket",
  "copy.229f48383140": "Keyif",
  "native.settings_scope": "Hesap güvenliği, planlama tercihleri, bildirimler ve yedekleme yönetimi için tarayıcıdan giriş yapmanız gerekir. Tema ve dil bu cihazda kaydedilir.",
  "native.theme_saved": "Tema bu cihazda kaydedildi.",
  "native.first_party_only": "Bu işlem tarayıcı oturumu gerektirir. Devam etmek için Exognitos sunucunuzda bir tarayıcı üzerinden oturum açın.",
  "copy.55717dfa8365": "uyku",
  "copy.a0afc8df4fba": "duygu durumu",
  "copy.1885d0e630e3": "isteksizlik",
  "copy.9f7ed878b7b6": "eksik girdi",
  "copy.4b11b17f565f": "hafife alma",
  "copy.3711561cf43c": "seyahat",
  "copy.2257c79ccb2c": "Bedensel",
  "copy.14fae0715e36": "Dijital",
  "copy.32b335d50f71": "{{value1}} · Teknik Ayarlar",
  "copy.0a456b7b2bd9": "Tablo v{{value1}} · {{value2}}",
  "copy.8db4d93dad5f": "{{value1}} (dakika)",
  "copy.a355f1e38138": "Derecelendirme",
  "copy.237b14cbb480": "Para",
  "copy.bd1865998b12": "Destekleyenler",
  "copy.d457637e75b3": "Referanslar",
  "copy.10678047e8c1": "Kararlar",
  "copy.b90ce029f217": "{{value1}} sekmesini kapat",
  "copy.3d83a8d317a1": "{{value1}} Ara",
  "copy.906d37bd6ca1": "{{value1}} — Katman {{value2}}",
  "copy.e8981f05ef10": "Durgun",
  "copy.32ba741f788e": "Beklemede",
  "copy.810cbf5caace": "{{value1}} ilerlemesi %{{value2}}",
  "copy.e3a882374659": "{{value1}}. parça başlığı",
  "copy.f234713b8ba6": "{{value1}}. parça açıklaması",
  "copy.90468135b048": "{{value1}}. parça tahmini",
  "copy.8e42dc2f2a0a": "Hafif",
  "copy.04eb32d1dad7": "Dengeli",
  "copy.0145e636965f": "Dolu",
  "copy.c498427f0fd2": "{{value1}} odak",
  "copy.c68b57d25e86": "{{value1}} dk odak",
  "copy.e6cf2b3feab3": "{{value1}} serisi",
  "copy.67d8b8f89953": "Alt bileşen",
  "copy.00e9738b77c7": "Evet",
  "common.yes": "Evet",
  "time.minute_unit": "dk",
  "focus.planned": "planlanan",
  "count.records_one": "{{count}} kayıt",
  "count.records_other": "{{count}} kayıt",
  "count.routines_one": "{{count}} rutin",
  "count.routines_other": "{{count}} rutin",
  "count.entries_one": "{{count}} günlük girdisi",
  "count.entries_other": "{{count}} günlük girdisi",
  "count.notes_one": "{{count}} not",
  "count.notes_other": "{{count}} not",
  "count.open_tasks_one": "{{count}} açık görev",
  "count.open_tasks_other": "{{count}} açık görev",
  "count.links_one": "{{count}} bağlantı",
  "count.links_other": "{{count}} bağlantı",
  "count.expected_repetitions_one": "{{count}} beklenen tekrar",
  "count.expected_repetitions_other": "{{count}} beklenen tekrar",
  "project.kind": "{{kind}} proje",
  "plan.completedTasks": "{{completed}}/{{total}} tamamlandı",
  "plan.taskCount_one": "{{count}} görev",
  "plan.taskCount_other": "{{count}} görev",
  "plan.routineCount_one": "{{count}} rutin",
  "plan.routineCount_other": "{{count}} rutin",
  "plan.projectContext": "{{project}} projesi",
  "plan.activationNeeds": "Etkinleştirmek için {{requirements}} ekleyin.",
  "plan.dateFrom": "{{date}} tarihinden itibaren",
  "plan.dateUntil": "{{date}} tarihine kadar",
  "copy.3cb899cfe418": "Tablo sözleşmeleri ve alan yapısı",
  "copy.e79aeddc061d": "Alt sınır üst sınırdan büyük olamaz.",
  "copy.42e6814599b4": "Tabloda en az bir sütun bulunmalıdır.",
  "copy.3c45dd397ac5": "Tablo adı zorunludur.",
  "copy.5bdd8a1922d7": "Tablo anahtarı zorunludur.",
  "copy.9a6c607b6579": "Alt bileşen için bir üst tablo seçmelisin.",
  "copy.c8374ff9d987": "Tabloyu oluştur",
  "count.tables_one": "{{count}} tablo",
  "count.tables_other": "{{count}} tablo",
  "capacity.finish": "Planın bitiş saati {{time}}.",
  "capacity.finish_next_day": "Planın bitiş saati ertesi gün {{time}}.",
  "common.saved": "Kaydedildi",
  "common.save_failed": "Kaydedilemedi",
  "draft.position": "{{position}}. taslak",
  "draft.awaiting_decision": "karar bekliyor",
  "lifecycle.archived": "{{relative}} arşivlendi",
  "lifecycle.deleted": "{{relative}} silindi",
  "lifecycle.purge": "{{relative}} otomatik silinir",
  "lifecycle.loaded_one": "{{loaded}} / {{count}} kayıt",
  "lifecycle.loaded_other": "{{loaded}} / {{count}} kayıt",
  "lifecycle.in_hours_one": "{{count}} saat sonra",
  "lifecycle.in_hours_other": "{{count}} saat sonra",
  "lifecycle.in_days_one": "{{count}} gün sonra",
  "lifecycle.in_days_other": "{{count}} gün sonra",
  "settings.token_description": "Exognitos API'sini kullanan harici istemciler ve kişisel otomasyonlar için. Anahtar yalnızca bir kez gösterilir; sunucuda sadece özeti saklanır.",
  "settings.token_example": "Kişisel otomasyon",
  "copy.5f7a7234cadc": "{{value1}} · mevcut saat korundu.",
  "copy.37ef45dfecb9": " · {{value1}} plan",
  "copy.3af257399a40": "{{value1}} plan",
  "copy.463f6b36181b": "{{value1}} fazla",
  "copy.d465c2470b9b": "{{value1}} eksik",
  "copy.1129e6f195d9": "tam",
  "copy.8056fa473913": "{{value1}} — neden var, ne kadar oynayabilir",
  "copy.8bd64f0953c4": "anahtar_yok",
  "copy.e27b15bdd6b4": " · Birincil",
  "copy.1d2171dfa528": "Simgesiz",
  "copy.ee788f265d93": "{{value1}} · Katman {{value2}}",
  "copy.ffc83b12853f": "Belirlenmedi",
  "copy.8fd6cbabf5c7": "Belirtilmedi",
  "copy.0ada951030d2": "Nokta",
  "capacity.no_protected_time": "{{date}} için korunan bir zaman tanımlı değil.",
  "graph.moveLeft": "Sola taşı",
  "graph.moveRight": "Sağa taşı",
  "graph.moveUp": "Yukarı taşı",
  "graph.moveDown": "Aşağı taşı",
  "graph.positionControls": "Seçili öğeyi taşı",
  "common.done": "Bitti",
  "calendar.starts_at": "{{time}}'da başlıyor",
  "copy.0ed1d2d09021": "Kaydedildi",
  "copy.4a758db5ca03": "Uygulama Tercihleri",
  "copy.6659fe1e3d47": "Uygulamalarını, sayfalarını ve mevcut verilerine bağlanan bölümleri düzenle.",
  "copy.a8d781429ae5": "Bu tercihler gelecekteki istemciler için saklanır; kayıtlarını veya bu uygulamanın görünümünü değiştirmez.",
  "copy.43d6dcf757ac": "Tercihler kaydedildi.",
  "copy.3bb53e9680a2": "Yapılandırma sürümü",
  "copy.688beea357c1": "Kaydedilmemiş değişiklikler",
  "copy.0c2c51e4661f": "Tercihleri Kaydet",
  "copy.fc5c50ef318d": "Sunucudaki sürüm yüklendi.",
  "copy.a50a4d15fe6e": "Taslağı Bırak ve Güncel Sürümü Yükle",
  "copy.99b3483f6523": "Düzenlemelerin bu ekranda duruyor. Başka bir yerde kaydedilen değişiklikleri incelemek için güncel sürümü yükleyebilirsin.",
  "copy.856bc41534c9": "Uygulamalar",
  "copy.5f31a25fcaf7": "Uygulama Ekle",
  "copy.9eb7f9f64a25": "Başlıksız uygulama",
  "copy.44e12f10ded1": "İlk uygulamanı tanımla",
  "copy.822c3a81d828": "Her uygulama kendi temasını, gezinmesini ve sayfalarını taşır.",
  "copy.28eb7fffb49b": "Uygulama Ayarları",
  "copy.e084b5eea7a9": "Uygulamayı Kaldır",
  "copy.2853b96ba748": "Uygulama başlığı",
  "copy.45eeba145e0d": "Uygulama simgesi",
  "copy.96f7afcd5c27": "Örneğin layout, book veya calendar.",
  "copy.a5461f4c0529": "Sistemden devral",
  "copy.28cf21da3f15": "Gezinme",
  "copy.0c5f3b1bd7a8": "Sekmeler",
  "copy.5c79a1eab176": "Yan menü",
  "copy.a5dcca48cc57": "Uygulama sırası",
  "copy.e4fe8d0e28b4": "Sayfalar",
  "copy.7b2663103076": "Sayfa Ekle",
  "copy.5d06b118097b": "Başlıksız sayfa",
  "copy.5106bdff196a": "Bölümler eklemek için bir sayfa oluştur.",
  "copy.5a53946315f9": "Sayfa başlığı",
  "copy.7b4d62143b9e": "Sayfa simgesi",
  "copy.e642a7b048b0": "Sayfa sırası",
  "copy.7cd9551f12bb": "Bölüm Ekle",
  "copy.83c3c3ffb201": "Sayfayı Kaldır",
  "copy.87aff7711fbd": "Grafik",
  "copy.2e0e960ab320": "Form",
  "copy.27cfdaca01d9": "Yeni bölüm başlığı",
  "copy.db5146cb3e89": "Bölüm türü",
  "copy.bf9c6aa8ddb6": "Bölümü Ekle",
  "copy.3204886cf413": "Bölümü Kaldır",
  "copy.58b36ae862b2": "Bölüm başlığı",
  "copy.055e31886669": "Bölüm sırası",
  "copy.722321b13e12": "Kaynak kullanılamıyorsa bağlantısı korunur. Değiştirmek veya kaldırmak senin seçimin.",
  "copy.772ee7942483": "Alan tercihi ekle",
  "copy.fa1d29624e38": "Alan seç",
  "copy.e124590b234d": "Alan başlığı",
  "copy.2f9e6238fbcd": "Alan sırası",
  "copy.6f91491cdecd": "Alan genişliği",
  "copy.6fae3b65e2fd": "Dar",
  "copy.55d67233d4f2": "Geniş",
  "copy.d790f77977be": "Alan görünür",
  "copy.0dd8979879a6": "Alan Tercihini Kaldır",
  "copy.f0871d080fa8": "Kullanılamayan bağlantı · {{value1}}",
  "copy.8307feac4930": "Kaynak yaşam alanı",
  "copy.5ac4d3202695": "Kaynak tablo",
  "copy.78dfebdbad89": "Tablo seç",
  "copy.f9351deabcef": "Bölüm veri kaynağı",
  "copy.e6b81cb9ab09": "Metrik",
  "copy.a70227f2b004": "seç",
  "copy.ca875b810113": "Kaynak listesi yüklenemedi. Mevcut bağlantı korunuyor.",
  "copy.9a52b79184fb": "Yeni uygulama",
  "copy.28042b224c01": "Yeni sayfa",
  "copy.7ccfa7dc3a8b": "Yapılandırma 32 KiB sınırını aşıyor.",
  "copy.2d36b3af02e3": "Uygulama başlığı gerekli.",
  "copy.ba7a621542ac": "Sayfa başlığı gerekli.",
  "copy.fd34e632182a": "Sayfa kimlikleri farklı olmalı.",
  "copy.179d1617ca60": "Bölüm başlığını ve veri kaynağını seç.",
  "copy.09352c277bc0": "Bölüm kimlikleri farklı olmalı.",
  "copy.67d62e0cf37c": "En fazla 100 farklı kaynak bağlantısı kaydedilebilir.",
  "copy.1f85b0be8bfb": "Bisiklet",
  "copy.f96f0d389edb": "Sürüşlerini gerçek başlangıç ve bitiş zamanlarıyla takip et.",
  "copy.705478b22b47": "Sürüş",
  "copy.96adcb9014db": "Sürüşler yükleniyor…",
  "copy.fe7117237b93": "Sürüş durumu yüklenemedi.",
  "copy.b42bc8f68e62": "Başladığında zamanı kaydedelim. Bitişte kat ettiğin mesafeyi girebilirsin.",
  "copy.3d4346eaa5f8": "Sürüşü Başlat",
  "copy.c645f5cc33cf": "Sürüş Geçmişi",
  "copy.bf31b9eebeb3": "Devam Ediyor",
  "copy.1539053a4448": "km ·",
  "copy.733c2ee7d8e1": "Süre bilinmiyor",
  "copy.a99857a976ec": "{{value1}} dakika",
  "copy.583e845fb2b9": "Henüz sürüş yok",
  "copy.bb848390ff47": "İlk sürüşünü başlattığında burada görünecek.",
  "copy.e8b9af762b47": "Daha Fazla Sürüş",
  "copy.6605b4fc99c1": "Başlangıç:",
  "copy.2be1cc81940d": "Kat edilen mesafe (km)",
  "copy.d07d8cb7a13f": "Sürüş notu",
  "copy.3849fa116307": "Sürüşü Bitir",
  "copy.a2fb4a244d23": "Sürüşü İptal Et",
  "copy.c1d7321c99af": "Haftalık sürüş hedefim",
  "copy.0900d63069c3": "Haftalık Mesafe Hedefi",
  "copy.51e4f1661693": "Hedef adı",
  "copy.f4bec7617fa3": "Haftalık mesafe (km)",
  "copy.23c4811424e0": "Hedefe ulaşınca bildirim kuralı hazırla",
  "copy.e91a7e3e77e2": "Kural taslak olarak oluşturulur. Etkinleştirmeden önce koşulunu ve izinlerini gözden geçirebilirsin.",
  "copy.2cb542d1c5e8": "Hedef Oluştur",
  "copy.5ad83ee1934c": "Hedef ve mesafe metriği oluşturuldu.",
  "copy.fe6635052630": " Bildirim kuralı etkinleştirme bekliyor.",
  "copy.8d4d1ebe70cb": "Cihaz Takibi",
  "copy.418e405cc78f": "Bağladığın kaynakların gönderdiği kullanım özetleri ve açıkça izin verdiğin ayrıntılar.",
  "copy.d972535b7dfd": "Kaynaklar",
  "copy.917c4296a86b": "Kaynak adı",
  "copy.38794d3950b0": "Örneğin telefonun veya masaüstü bilgisayarın.",
  "copy.5d98ea8091dc": "Kaynak Bağla",
  "copy.12f45de44b90": "bağlantı bilgisi",
  "copy.bb4778423f88": "Bu anahtar yalnız şimdi gösterilir. Kaynak uygulamandaki bağlantı ayarına ekle.",
  "copy.3ca6ac67a497": "Kaynak anahtarı",
  "copy.2f926e1823f1": "Kaynak kimliği",
  "copy.9ce9962b8f3a": "Özet gönderim adresi",
  "copy.23bae416da8c": "Gönderimler ayrıca hesabına ait oturum veya erişim izniyle doğrulanır.",
  "copy.e4e61b2226e3": "Bilgileri Kaydettim",
  "copy.d69f95702ca8": "Henüz bağlı kaynak yok",
  "copy.0b6dfe21167b": "Kaynak bağlamak otomatik veri toplamayı başlatmaz. Özetler, bağlantı kurduğun uygulamadan gelir.",
  "copy.9b81681880bd": "Daha Fazla Kaynak",
  "copy.0a135e8ffef7": "Kaynak iptal edildi",
  "copy.499bf7692c68": "Son bildirim: {{value1}}",
  "copy.a445342a6684": "İlk bildirim bekleniyor",
  "copy.e285643805c5": "Ham Kayıtlar",
  "copy.690417ea5fc6": "Kullanım özetleri uygulama adı ve süreyi içerir. Aşağıdaki ayrıntılar ayrı izne bağlıdır ve en fazla 7 gün saklanır.",
  "copy.97e0ab438911": "Tam web adreslerini kabul et",
  "copy.9f5ba294e9a9": "Ziyaret edilen sayfaların URL bilgileri.",
  "copy.ef01003113c6": "Konum verilerini kabul et",
  "copy.7671c675d53f": "Koordinatlar ve varsa doğruluk bilgisi.",
  "copy.18a5fc1c6918": "Sensör ölçümlerini kabul et",
  "copy.a847672fc372": "Ölçüm adı, değeri ve birimi.",
  "copy.2a4442e7766b": "İzinleri Kaydet",
  "copy.0a91e47db9f7": "Kaynağı İptal Et",
  "copy.27d86f3453a6": "Uygulama Kullanım Özetleri",
  "copy.53a81625aa1e": "Özetler yüklenemedi.",
  "copy.21e5fcde743a": "Uygulama özeti",
  "copy.9494ff896e95": "dakika",
  "copy.ceed4effcbad": "Henüz kullanım özeti gelmedi",
  "copy.a74a2416ab5f": "Bağlı kaynak uygulama adı, gün ve süre bildirdiğinde burada görünür.",
  "copy.478d989276b0": "Daha Fazla Özet",
  "copy.2e8f0cd5002a": "{{value1}} · Son 7 Gün",
  "copy.aa9df4372465": "· Saklama sonu:",
  "copy.edd6b90b35fc": "Saklanan ham kayıt yok",
  "copy.747a5170f6ad": "Daha Fazla Kayıt",
  "copy.ed1636e9edb4": "Yaşam tablosunda göstergeleri ve kuralları aç",
  "copy.0086705bf008": "Eklenti durumu yüklenemedi.",
  "copy.6efdba1e3b49": "Eklenti duraklatıldı",
  "copy.f6ebaf5fe861": "Eklenti bu sunucuda kullanılamıyor",
  "copy.1e5a48393cf5": "Eklentiyi kurarak başla",
  "copy.0abbccd05656": "Kurulumu ve veri bağlantılarını Eklentiler sayfasından yönetebilirsin.",
  "copy.667cf9262cd4": "Eklentilere Git",
  "copy.5d0ff2924cf9": "İşlem tamamlanamadı. Bilgilerin korunuyor; yeniden deneyebilirsin.",
  "copy.10f2b815b3e8": "Bağlı yaşam kayıtlarını oku",
  "copy.7ecad28739c2": "Yaşam kaydı ekle",
  "copy.3386c3f4990d": "Bağlı yaşam kayıtlarını güncelle",
  "copy.037a80749a2c": "Gösterge oluştur",
  "copy.bea39ec71bc6": "Not oluştur",
  "copy.9ca03fe880be": "Görev oluştur",
  "copy.8e8e0e19a97f": "Otomasyon kuralı oluştur",
  "copy.98dc109ccd4f": "Cihaz kaynaklarını yönet",
  "copy.29c548ae35f9": "Uygulama tercihlerini yönet",
  "copy.639aef43290a": "Arkadaşlık ve paylaşımları oku",
  "copy.331a5174ee15": "Arkadaşlık ve paylaşım işlemleri yap",
  "copy.2c8d8cd444eb": "Eklentiler",
  "copy.8c7c945d91c8": "İhtiyacın olan araçları seç; yaşam tabloları ve kayıtların kendi alanında kalsın.",
  "copy.b28ee640545f": "Eklentiler yüklenemedi.",
  "copy.b3e770b31603": "Sürüm {{value1}} · ",
  "copy.e046fde19b35": "Bu sunucuda kullanılamıyor",
  "copy.52359bff7a01": "Kurulmadı",
  "copy.fcb56964b290": "Paket yeniden kullanılabilir olduğunda kurulumu yönetebilirsin.",
  "copy.75ed829a8997": "Kurulumu Hazırla",
  "copy.0ac834fe8fb1": "{{value1}} kurulumu",
  "copy.9818e2a138ff": "Kurulum sürümü",
  "copy.9d43a2409cfb": "· Yapılandırma",
  "copy.1b1c77b22442": "Eklentinin çalışma izni kapatılacak. Yaşam tabloların, kayıtların ve bağımsız notların korunacak.",
  "copy.36428c193647": "Eklentiyi Kaldır",
  "copy.83d9740654be": "Verilen izinler",
  "copy.323bb127f585": "Veri bağlantıları",
  "copy.935b502585dc": "→ Yaşam tablosu",
  "copy.25b1fe3f0719": " · {{value1}}",
  "copy.60ff93f4c166": " · Gerekli bağlantı",
  "copy.e7e4e49676d4": "Bu eklenti yaşam tablosu bağlantısı gerektirmiyor.",
  "copy.ccf19139a978": "Paket kullanılamıyor",
  "copy.5b1528d7eaef": "Mevcut yaşam verilerine Yaşam Alanları üzerinden ulaşabilirsin.",
  "copy.6fe37c3bdfe3": "Her bağlantı için yeni alan oluştur veya kendi tablonu ve sütunlarını açıkça seç. Kurulumdan önce oluşacak yapıyı görebilirsin.",
  "copy.d92b326973e4": "Verilecek izinler",
  "copy.21c83a3764e1": "Kurulumu Önizle",
  "copy.aa18ef3838f0": "Kurulum önizlemesi",
  "copy.9d7072cd5d3f": "Yeni alan: {{value1}}",
  "copy.6789aeb3d8e8": "Seçili yaşam tablosuna bağlanacak",
  "copy.811c45f9d941": " · Gerekli",
  "copy.7aad969cd5cd": "Görünüm:",
  "copy.1496e196745c": "Göstergeler:",
  "copy.a1eb87a8ee12": "Kurallar:",
  "copy.faed1c91a9cf": "Bu Yapıyla Kur",
  "copy.369b830913df": "Veri alanı",
  "copy.358adcf132f1": "Yeni yaşam alanı oluştur",
  "copy.d73ccb3bcbd6": "Mevcut tabloya bağla",
  "copy.1d2e0afe73eb": "Yeni alan adı",
  "copy.cb5b6f8ecbf3": "Alan seç…",
  "copy.b6ea434ba347": "Tablo seç…",
  "copy.ae6ed6c2b574": "{{value1}}{{value2}}",
  "copy.87e58e822bce": " (gerekli bağlantı)",
  "copy.951eb471ccab": "Sütun seç…",
  "copy.34a46bf73ec9": "Müzik profili",
  "copy.e9007ad9184a": "Görünen ad",
  "copy.a36362d47352": "Deneyim",
  "copy.b57b778343eb": "Yeni başladım",
  "copy.1c84c913b43a": "Öğreniyorum",
  "copy.30cdff931539": "Deneyimliyim",
  "copy.2c7ae4aaa2ca": "İlgi alanları",
  "copy.a6af5a04d4b5": "Virgülle ayırabilirsin.",
  "copy.6325dea6c244": "Profili Kaydet",
  "copy.fd3b91f48bcf": "Müzik",
  "copy.e15ab1b0024c": "Dersler",
  "copy.ac84369bcfc5": "Sosyal",
  "copy.9b021253b62b": "Otomasyon için API Anahtarları",
  "copy.c992cca4bbe8": "Kendi yönettiğin betik ve otomasyonlar için yalnız gereken izinleri seç. Mobil uygulama bağlantıları kullanıcı onaylı OAuth ve PKCE akışını kullanır.",
  "copy.14ebc8f336bc": "Anahtar oluşturuldu. Seçtiğin izinler ve süre aşağıda görünüyor.",
  "copy.4826a4d6d841": "Haftalık görev raporu",
  "copy.1b61c02832b4": "Geçerlilik süresi",
  "copy.c17be279a432": "7 gün",
  "copy.7f6561d2dcc3": "30 gün",
  "copy.cefd7e103aef": "90 gün",
  "copy.92e13c747aca": "1 yıl",
  "copy.a60cc5698432": "Gün sayısı belirle",
  "copy.b5494a373a33": "Geçerlilik (gün)",
  "copy.1e0e5b7693f5": "1 ile 3650 arasında tam gün sayısı gir.",
  "copy.f57dfa8706e1": "İzinler ·",
  "copy.4d67b1a83350": "seçili",
  "copy.99f091d467cd": "Okuma, yazma ve kalıcı silme ayrı izinlerdir. Hiçbiri kendiliğinden seçilmez.",
  "copy.1cec1d05e0a4": "İzin listesi yüklenemedi",
  "copy.9bc1d2827060": "Hassas veri erişimi",
  "copy.67b7baabf5bc": "İşlem tamamlanamadı. Seçimlerin korunuyor; yeniden deneyebilirsin.",
  "copy.5adf087a5d38": "Anahtar Oluştur",
  "copy.50c68b000177": "Bu anahtar yalnız şimdi gösterilir. Otomasyonunun güvenli anahtar deposuna kaydet.",
  "copy.2c9b3940a44a": "Yeni API anahtarı",
  "copy.b64f22a34976": "Anahtar kopyalandı.",
  "copy.2639a19c47c0": "Otomatik kopyalama kullanılamıyor; anahtarı seçerek kopyalayabilirsin.",
  "copy.f3a3ab8b7554": "Anahtar gösterimi kapatıldı.",
  "copy.6e76d65010a3": "Gösterimi Kapat",
  "copy.abe5087cfa97": "Son kullanım {{value1}}",
  "copy.75c85fb1b572": "Henüz kullanılmadı",
  "copy.6cf114b274f2": "“{{value1}}” anahtarı iptal edilsin mi?",
  "copy.2e766eb55fc9": "Bu anahtarı kullanan otomasyon hemen erişimini kaybedecek.",
  "copy.b2e46ff48b43": "Anahtarı İptal Et",
  "copy.ca7577d56ebc": "{{value1}}: {{value2}}",
  "copy.45bdb76025c4": "Süresi doldu",
  "copy.e730651f6ff6": "Süre sonu",
  "copy.f71518fbed39": "Süresiz eski anahtar",
  "copy.0aa789557e43": "Tam hesap yetkisi — kapsamı sınırlandırılmamış eski anahtar",
  "copy.dbd3b3d5eec7": "Ders oturumlarını, kabul ettiğin dökümleri ve ödevlerini birlikte takip et.",
  "copy.b7f3cb802463": "Ders Oturumlarına Dön",
  "copy.ec893839bbfd": "Dersleri Yönet",
  "copy.3abe87489ce4": "Dersler yüklenemedi.",
  "copy.9b6625ca3c1a": "Ders Oturumu Kaydet",
  "copy.136935360f24": "Ders",
  "copy.7b5cbd5295e7": "Ders seç",
  "copy.64d30660d82b": "Oturum konusu",
  "copy.95461782840f": "Kabul edilen metin / döküm",
  "copy.a6cf41d5fbc2": "Bu metin, Kaydet dediğinde bağımsız bir Hafıza Notu olarak oluşturulur.",
  "copy.031af18cbbf7": "Not oluşturmak için kurulumdaki Not iznini aç.",
  "copy.d5b31d35f977": "Ödevler",
  "copy.0d20cc37cf49": "Her satır bir görev oluşturur. En fazla 20 görev ekleyebilirsin.",
  "copy.55ad188fd85d": "En fazla 20 görev ekle.",
  "copy.3412f27fc553": "1 Not",
  "copy.1d482808af49": "Not eklenmeyecek",
  "copy.c5802f9a400f": "görev oluşturulacak",
  "copy.8a05a67d8c44": "Oturumu Kaydet",
  "copy.214618a6447d": "İlk Dersi Ekle",
  "copy.de29d8cc5255": "Ders Geçmişi",
  "copy.34bdb1f6aa69": "Ders geçmişi yüklenemedi.",
  "copy.fa7b378b0145": "Ders kaydı",
  "copy.22d5d99695b5": "Ders Notu",
  "copy.caed731365a4": "Ödev",
  "copy.c1804d0700fc": "Henüz ders oturumu yok",
  "copy.caf99cf67701": "Daha Fazla Oturum",
  "copy.93945bcbe03a": "Daha Fazla Ders",
  "copy.6a042122c9b5": "Derslerin",
  "copy.220b6079b8bf": "Ders adı",
  "copy.60ae12bd8819": "Ders açıklaması",
  "copy.f6cd5f1d9b36": "Ders Ekle",
  "copy.a82b78619a75": "Bildirim kutusuna ekle",
  "copy.5af333aa331b": "Yaşam kaydı oluştur",
  "copy.c1ef3d9b851a": "Belirli yaşam kaydını güncelle",
  "copy.5a5ac0e40ef6": "Metin notu oluştur",
  "copy.9edbc70310ee": "Yapılacak işlem",
  "copy.64cd2520f628": "Hedef yaşam alanı",
  "copy.5e0c55ccadef": "Hedef tablo",
  "copy.cad5b8c7192f": "Bağlı tablo ·",
  "copy.6b2bf84ef3f5": "Güncellenecek kaydın UUID’si",
  "copy.eb344064f7e5": "Bu alanlara girdiğin sabit değerler kullanılır. Önizleme, güncel tablo tanımına göre doğrular.",
  "copy.bc9e28d56fd2": "Hedef tablo açılamadı.",
  "copy.674b96f88f1c": "İçerik",
  "copy.2dae389a126e": "Bu bildirim için bağlı cihazlara da gönder",
  "copy.446d8455cad1": "Bildirim kutusuna her durumda kaydedilir. Dış iletim için etkin bir bildirim aboneliği gerekir.",
  "copy.505845aefef7": "Başlangıç anı",
  "copy.d8193729233a": "Bitiş anı",
  "copy.f58ce3124b7e": "Gerçekleşme anı",
  "copy.e84ac40c7b97": "2026-09-05T10:00:00+03:00",
  "copy.b80bca0f8cfc": "Saat dilimi farkını içeren tam tarih ve saat.",
  "copy.b78b92cac81b": "Eşit",
  "copy.5ee26309ac48": "Eşit değil",
  "copy.8e11577c8ad8": "Büyük",
  "copy.29150002bc1b": "Büyük veya eşit",
  "copy.2369172f664e": "Küçük",
  "copy.69ba5abe07fe": "Küçük veya eşit",
  "copy.6bf936ffe8c6": "Koşul",
  "copy.3ae15d8ae058": "Alt koşul · düzey {{value1}}",
  "copy.c036f1855d16": "Koşul türü",
  "copy.91d386bb210c": "İki değeri karşılaştır",
  "copy.e562b1bb7e41": "Hepsi doğru (VE)",
  "copy.c31d80fdd2ab": "En az biri doğru (VEYA)",
  "copy.7bc104cccc02": "Tersi (DEĞİL)",
  "copy.6a1a25093722": "Sol değer",
  "copy.3de740d7f47c": "Karşılaştırma",
  "copy.d408fcb27258": "Sağ değer",
  "copy.963ec26bec36": "Alt koşul {{value1}} kaldır",
  "copy.94f5ea5a3be5": "Alt koşul ekle",
  "copy.81c70eab8f54": "{{value1}} kaynağı",
  "copy.3e50031b3919": "Sabit sayı",
  "copy.6c5c281c636e": "Gösterge sonucu",
  "copy.27efeed1f6e1": "Kişisel parametre",
  "copy.bd61590cb01a": "Boş değer: bilinmiyor. Sıfır olarak kabul edilmez.",
  "copy.acf847765a5c": "Gösterge seç",
  "copy.efddcbb1d387": "Parametre seç",
  "copy.d2988c56e56e": "Bağlı kaynak ·",
  "copy.064b47456f4c": "Kaynaklar yüklenemedi.",
  "copy.7568a87aa273": "İşlem tamamlanamadı. Bilgileri kontrol edip yeniden deneyin.",
  "copy.54a1ffa89e8b": "Oluşturma",
  "copy.49ef9aa594d6": "Güncelleme",
  "copy.f083ca59254a": "Arşivleme",
  "copy.6fc44ff00346": "Geri yükleme",
  "copy.73640dd07f8f": "Kuralı düzenle",
  "copy.5beefee35741": "Kural taslağı oluştur",
  "copy.9f61b3143665": "Taslağı kaydet ve incele",
  "copy.ff16e0956bbc": "Kural adı",
  "copy.e8b55c4a6440": "Değişiklikler etkin kuralı duraklatır. Yeni taslağı inceleyip yeniden etkinleştirmen gerekir.",
  "copy.df9f6afd1768": "Ne zaman değerlendirilsin?",
  "copy.dbffd0d5f991": "Bu tablonun kayıtları değiştiğinde",
  "copy.7cfe6753dbb3": "Belirli aralıklarla",
  "copy.a1862de3c67f": "Elle çalıştırıldığında",
  "copy.32c9f037a092": "Değerlendirme aralığı (dakika)",
  "copy.21513bd8a354": "/32 koşul. Eksik değer sonucu bilinmiyor yapar ve işlem başlatmaz.",
  "copy.5d27ccf49443": "Koşul sağlandığında",
  "copy.9ca611f7b87e": "Yalnızca ilk kez sağlandığında",
  "copy.ff0d043a7f84": "Sağlandığı her değerlendirmede",
  "copy.ccf543146995": "İşlemler arası en az saniye",
  "copy.7a679fdd8b9c": "Koşul doğruysa yapılacaklar",
  "copy.95baf5e2c127": "İşlem {{value1}} kaldır",
  "copy.6c4c014c0b88": "İşlem ekle",
  "copy.e9af5e757542": "Kaynak kullanılamıyor",
  "copy.793e99d63039": "Kural işlemleri",
  "copy.90aeae7ab952": "Kural oluştur",
  "copy.da948d8a9364": "Tüm kişisel kurallarımı göster",
  "copy.e19620ee82f2": "Kurallar önce taslak olarak kaydedilir. Etkinleştirmeden önce yapılacak işlemleri ve gerekli izinleri incele.",
  "copy.e6653ad658f0": "Kurallar yüklenemedi",
  "copy.4ba1e9696011": "Henüz kural yok",
  "copy.7f538a0793a7": "Bir göstergeyi hedefinle karşılaştırıp kişisel bir bildirim veya kayıt işlemi tanımlayabilirsin.",
  "copy.5be328049bdb": "İlk kuralı oluştur",
  "copy.af6ccd214f24": "Kayıt değişikliği",
  "copy.918567637ef5": "Her {{value1}} dakika",
  "copy.2046bd8bde18": "Elle çalıştırma",
  "copy.d6f18add81d9": "{{value1}} düzenle",
  "copy.2f13ac074c7d": "{{value1}} çalışma geçmişi",
  "copy.546ba7afcb8f": "{{value1}} arşivle",
  "copy.d8a7bae75ccb": "Şimdi değerlendir",
  "copy.3c55dab34b65": "Önizle ve etkinleştir",
  "copy.fba220891e80": "Son çalışma:",
  "copy.80b606aa2888": "Sonraki 10 kural",
  "copy.64aa5a127dfe": "Değerlendirme sıraya alındı. Sonucu kuralın çalışma geçmişinden izleyebilirsin.",
  "copy.b1083eb54ddf": "Kuralı incele ve etkinleştir",
  "copy.d7dbb07cdde5": "İzin ver ve etkinleştir",
  "copy.4828c199d392": "Güncel durumu önizle",
  "copy.7285152e54fc": "Koşul şu anda:",
  "copy.1c5b653893e8": "Bilinmiyor",
  "copy.8cae5ab460c1": "Doğru",
  "copy.9520c878eaac": "Yanlış",
  "copy.83c3d10a3638": ". Önizleme işlem çalıştırmaz.",
  "copy.0227d3052adf": "Hedef tablo:",
  "copy.22e129ecb19a": " · Kayıt: {{value1}}",
  "copy.2b130af50743": "Yazılacak değerler",
  "copy.d8e1ce802374": "Boş",
  "copy.f2887fd2471d": "Bağlı cihazlara dış bildirim iletimi istenir.",
  "copy.efcb6e0b7db9": "Gerekli izinler",
  "copy.0aa77f135c5b": "Bu kuralın yukarıdaki işlemleri bu izinlerle arka planda yapmasına izin veriyorum.",
  "copy.ea56a32dc22e": "Kuralı duraklatmak yetkiyi geri alır. Tanımı değiştirirsen yeniden inceleyip izin vermen gerekir.",
  "copy.a2087f6f574b": "Etkinleştirme için güncel bir önizleme gerekir.",
  "copy.a94ad4193279": "{{value1}} · Çalışma geçmişi",
  "copy.7ab98b0a27d0": "Henüz çalışma yok.",
  "copy.f0873175a881": "Başarısız",
  "copy.cd660348fb64": "İşlem yapılmadı",
  "copy.84b523fa6286": "işlem makbuzu",
  "copy.1381d8087b77": "En son 30 çalışma. Ekran açıkken 15 saniyede bir yenilenir.",
  "copy.8161663dd432": "Yürütme izni iptal edildi. Kuralı yeniden inceleyip izin ver.",
  "copy.d304325b47a6": "Koşulda kullanılan kayıt veya gösterge artık kullanılamıyor.",
  "copy.bf38537161c3": "Koşuldaki gösterge, parametre veya birimleri kontrol et.",
  "copy.837a6342b6ed": "İşlem hedefini ve güncel alan tanımlarını kontrol et.",
  "copy.878a5cd5651e": "İşlem tamamlanamadı; hiçbir kısmi değişiklik kaydedilmedi.",
  "copy.f02667770bbd": "Kural değerlendirilemedi. Koşul ve izinlerini incele.",
  "copy.69b4a13f3c97": "Hedef kaynağı",
  "copy.858e6e74d13f": "Adlandırılmış parametre",
  "copy.f866486b9fc5": "Belirli yaşam kaydı",
  "copy.5d4e16126dfe": "Parametre",
  "copy.9b97e83c0c57": "birimsiz",
  "copy.32a3a3a8afc3": "Bağlı parametre ·",
  "copy.0f2dc78ad026": "Kaydın UUID’si",
  "copy.69437c7daba7": "Bu tablodaki belirli bir kaydın kalıcı kimliği.",
  "copy.84f304ae4c07": "Hedef değer alanı",
  "copy.77dd0edafbb7": "Göstergeyi düzenle",
  "copy.517fd966cd3d": "Göstergeyi kaydet",
  "copy.9e33b457f0b9": "Gösterge adı",
  "copy.b0bad6a5ddee": "Örneğin: Bu ayki toplam gider",
  "copy.e5711c7874c8": "Hesaplama",
  "copy.0c9788eb412a": "Değer alanı",
  "copy.ffedbbbf7a18": "Birim:",
  "copy.7251ac3be22a": "Birimsiz",
  "copy.3280406063df": ". Farklı birimler otomatik dönüştürülmez.",
  "copy.2d4d2412bc85": "Tüm zamanlar",
  "copy.6da72c631645": "Takvim günü",
  "copy.5c74c2b567c5": "Takvim haftası",
  "copy.e18c37057ae0": "Takvim ayı",
  "copy.339ebfc38349": "Kayan saat aralığı",
  "copy.6c14b2c85f0b": "Kaç saat",
  "copy.29fcb1a7c513": "Önceki aralık sayısı",
  "copy.41e21ccf8efa": "0 bu aralık, 1 önceki aralık.",
  "copy.abda4de2f16c": "Dönemlere ayır",
  "copy.219c8cd71833": "Tek değer",
  "copy.abc3e615d675": "Haftalık",
  "copy.e055e06d7581": "Aylık",
  "copy.c4d256aeb821": "Oranın paydası",
  "copy.7edb93959c4c": "Kayıt filtreleri",
  "copy.38c7ee983495": "Filtre {{value1}} alanı",
  "copy.2021b8cf444a": "Değer var",
  "copy.4cfa2b03d54b": "Değer",
  "copy.7f8cc282d6fa": "Filtre {{value1}} kaldır",
  "copy.7ed953e0d2cc": "Filtre ekle",
  "copy.4a3a2fbba2ac": "Hesaplamayı önizle",
  "copy.a6b34e5c8b31": "Kaydetmeden önce güncel sonucu önizleyin.",
  "copy.ecf9288e8869": "değer ·",
  "copy.017db41e7cab": "eksik ·",
  "copy.3d0d0d9d5db9": " · {{value1}} kayıt farklı birimle kaydedilmiş",
  "copy.2f043780332e": "Dönemlere göre gösterge. Kesin değerler aşağıdaki tabloda.",
  "copy.4b5eb7dd702a": "Kesin değerler · {{value1}} dönem{{value2}}",
  "copy.e3ac94324068": " · ilk 100 dönem",
  "copy.71ce76802c3f": "Göstergenin kesin dönem değerleri",
  "copy.97b04c9ea0bc": "Gösterge işlemleri",
  "copy.8e00a424a181": "· Canlı hesaplamalar",
  "copy.434b7895c486": "Göstergeler yüklenemedi",
  "copy.4df981e50c45": "Bu tablo için gösterge yok",
  "copy.1a3c24f23aaf": "Kendi kayıtlarından bir toplam, ortalama, fark veya oran tanımla. Kayıtların aynı yerde kalır.",
  "copy.100bbf4569d8": "İlk göstergeyi oluştur",
  "copy.8bea6c5a8b26": "Sonraki 10 gösterge",
  "copy.3f625500d504": "Kişisel gösterimler",
  "copy.9e0ea1a034a2": "Kaydettiğin sayı, grafik ve bütçe görünümleri.",
  "copy.c7ee250906e5": "Gösterim ekle",
  "copy.28de1833cf55": "Gösterimler yüklenemedi",
  "copy.4279d5e9593b": "Henüz kayıtlı gösterim yok.",
  "copy.493d6f1b003a": "{{value1}} görünümünü düzenle",
  "copy.5e7e7b0bddca": "{{value1}} görünümünü arşivle",
  "copy.851a5e85dfa7": "Daha fazla gösterim",
  "copy.445ba7390098": "Kişisel parametreler",
  "copy.77e80ba20a60": "Bütçe ve hedef gibi elle belirlediğin değerler. Boş değer, sıfırdan farklıdır.",
  "copy.fc96b4177021": "Parametreler yüklenemedi",
  "copy.fd6852601b2c": "{{value1}} parametresini düzenle",
  "copy.63bb756623a8": "{{value1}} parametresini arşivle",
  "copy.ae5c659e2bcb": "Henüz parametre eklenmemiş.",
  "copy.c7ea4006b6c0": "Sonuç hesaplanamadı",
  "copy.052fb79017ec": "Gösterim hesaplanamadı",
  "copy.8e793367275a": "Hedef:",
  "copy.54f52cea860b": "{{value1}} hedef oranı",
  "copy.5d370119c989": "Hedef oranı hesaplanamıyor.",
  "copy.3cbaf83e32b5": "Parametreyi düzenle",
  "copy.df7d69d55f54": "Parametre oluştur",
  "copy.dbf69d0e78ca": "Parametreyi kaydet",
  "copy.edbeaeec1c98": "Henüz belirlemediysen boş bırakabilirsin.",
  "copy.ef0128065b4d": "Birim",
  "copy.7fee1ba34326": "Örneğin: km",
  "copy.0e5fdb87c713": "Örneğin: TRY",
  "copy.7b0cb1b9bf1d": "Gösterimi düzenle",
  "copy.555145c29f85": "Gösterimi kaydet",
  "copy.5fe96d8de190": "Gösterge hesabı",
  "copy.c3a9ace8b58a": "Önceki bağlantı ·",
  "copy.a456e7e1d8ea": "Gösterim biçimi",
  "copy.b371799342cd": "Sayı",
  "copy.7875a41964bd": "Çizgi grafik",
  "copy.4b7c0c945fc4": "Sütun grafik",
  "copy.db1699cd5eae": "Bütçe / hedef",
  "copy.59412766be52": "Grafik için göstergeyi günlük, haftalık veya aylık dönemlere ayır.",
  "copy.20a487a93c7b": "Kayıt sayısı",
  "copy.47589f98e0c2": "En küçük",
  "copy.eba58f447104": "En büyük",
  "copy.da86d4567881": "Son değer",
  "copy.7cbb69c268be": "Son iki değer farkı",
  "copy.94ee9687ccdd": "Güncel",
  "copy.73a971055c89": "Henüz değer yok",
  "copy.01bb3fbfd910": "Birim veya para birimi değişmiş",
  "copy.414af0c2e405": "Payda sıfır",
  "copy.3f343590a0f8": "İlk sürüm",
  "copy.1060cd601e71": "Kayıt geçmişi",
  "copy.1ce69d3fa7bd": "Geçmişi kapat",
  "copy.2867f3bf2289": "Önceki sürümleri göster",
  "copy.baf843d557ef": "Önceki değerler; o sıradaki alan tanımları, birimleri ve zamanlarıyla korunur.",
  "copy.54f73814cd51": "Kayıt geçmişi yüklenemedi",
  "copy.5f54997110a2": "Kayıt sürümü",
  "copy.721f5ae1e295": "· Tablo v",
  "copy.a5fd3322a923": "Geri yüklemeyi incele",
  "copy.7aa5f8e5da31": "Bu sürümün değerleri ve kökeni",
  "copy.e3f04aa2f2ee": "Bu kayıt için önceki sürüm yok.",
  "copy.29781104c3ca": "Önceki 10 sürüm",
  "copy.16c790a6c5f3": "Önceki sürümü geri yükle",
  "copy.9dc488748585": "Kayıt sürümü {{value1}} → güncel tablo v{{value2}}",
  "copy.539a77efb00b": "İncelenen değerleri geri yükle",
  "copy.76d1e37c64f1": "Bu işlem yeni bir kayıt sürümü oluşturur. Aşağıdaki değerler güncel alan tanımlarıyla doğrulanır; geçmiş sürüm korunur.",
  "copy.63fc67871798": "alanlarının türü, birimi veya para birimi değişmiş. Eski sayılar taşınmadı; güncel anlamıyla değer gir veya boş bırakmayı bilinçli olarak seç.",
  "copy.e384fa7c7685": "Geri yüklenecek zamanlar",
  "copy.5f4b6a76f178": "YYYY-AA-GG",
  "copy.7f09eb76a7bd": "Değerleri ve zamanları güncel alan anlamlarıyla inceledim.",
  "copy.22345147d3aa": "Geri yükleme tamamlanamadı. Değerlerin korunuyor; yeniden deneyebilirsin.",
  "copy.beb634051c8c": "Çalışmaların, repertuvarın ve kendi belirlediğin hedefler.",
  "copy.63707abb877b": "Müzik bölümleri",
  "copy.dd20c603d44a": "Çalışmalar",
  "copy.3f91b8da2708": "Enstrümanlar",
  "copy.27434a3a59ca": "Enstrümanlar yüklenemedi.",
  "copy.8c0667f80052": "Daha Fazla Enstrüman",
  "copy.e60b18bba3fa": "Enstrüman",
  "copy.4ce77ca1e717": "Enstrüman seç",
  "copy.9b04278da509": "Çalışma Kaydet",
  "copy.ca305a452df4": "Çalışma süresi (dakika)",
  "copy.1a62f3a5ff78": "Değerlendirme",
  "copy.e0b2187c0b19": "İstersen neyin iyi gittiğini ve sonraki çalışmanı yaz.",
  "copy.2f4860940db1": "Çalışmayı Kaydet",
  "copy.6438f59868e2": "Çalışma Geçmişi",
  "copy.b6812043caaf": "Enstrüman çalışması",
  "copy.546781372686": "dk ·",
  "copy.e3e928cd8b91": "Henüz çalışma kaydı yok",
  "copy.50365c8b1c0f": "Daha Fazla Çalışma",
  "copy.c102ca35eb71": "Enstrümanların",
  "copy.1074b7d3aa15": "Enstrüman adı",
  "copy.e63281af03ef": "Türü / ailesi",
  "copy.4e216a6ccd18": "Enstrüman Ekle",
  "copy.eb05313bf373": " · Arşivli",
  "copy.64fd89d84c4c": "İlk enstrümanını ekle",
  "copy.2b7636165517": "Çalışmalar ve repertuvar bu enstrümana bağlanır.",
  "copy.03e58df3a6e7": "Planlandı",
  "copy.ba8b861a7e92": "Çalışılıyor",
  "copy.781abed95a2b": "Repertuvar",
  "copy.a43cae108a0a": "Eser",
  "copy.c4c3cefeabdf": "Besteci",
  "copy.7896c7265ffa": "Eser Ekle",
  "copy.e94bb018d8a0": "Daha Fazla Eser",
  "copy.c0fdc01c14d5": "Haftalık Hedefler",
  "copy.c805a1d6a98b": "Haftalık hedef (dakika)",
  "copy.b40e3e2e5d3c": "Ayrıca günlük 30 dakikalık çalışma rutini oluştur",
  "copy.b29371d18de9": "Daha Fazla Hedef",
  "copy.1dd6ed9afc67": "{{value1}} / {{value2}} dakika",
  "copy.f503634d3ef8": "Hedef {{value1}} dakika · Ölçüm şu anda kullanılamıyor",
  "copy.c90f6e1ceab2": "Çalışma Rutinleri",
  "copy.e2cd081b30a2": "Müzik Profili",
  "copy.d9a085bab7e5": "Profil adı",
  "copy.ddf7b36c1e27": "Yeni başlıyorum",
  "copy.bea8b751adee": "Virgülle ayırarak ekleyebilirsin.",
  "copy.7c3579be0c4d": "Bildirim kutusu",
  "copy.f64afd4e37dc": "Kurallarının ve kişisel işlemlerinin kalıcı bildirimleri.",
  "copy.2f0e888986dc": "Bildirim erişimi yok",
  "copy.44b49b676d25": "Bu oturumun bildirimleri okuma izni bulunmuyor.",
  "copy.927eaa66f42c": "Yalnızca okunmamış bildirimler",
  "copy.304124a5b190": "Bildirimler yüklenemedi",
  "copy.46eafa26b692": "Okunmamış bildirim yok",
  "copy.4a29ba463779": "Bildirim kutusu boş",
  "copy.78875f7bbc13": "Bir kural bildirim ürettiğinde burada görünür.",
  "copy.ca8965684f72": "Okundu olarak işaretle",
  "copy.c162125b89a8": "Okundu",
  "copy.54e696c573c2": "Bu görünümde en son 100 bildirim gösteriliyor.",
  "copy.029f2d8c3a68": "Bildirim güncellenemedi.",
  "copy.5cb4a7c44d22": "Arkadaş",
  "copy.65ebed86a586": "Arkadaş seç",
  "copy.2226db5278b0": "{{value1}} seç",
  "copy.329d4b483ecc": "Kayıt seç",
  "copy.01414d69e4db": "Başlıksız kayıt",
  "copy.810aa07099e6": "Seçilen kayıt",
  "copy.33243111d4e6": "Canlı Paylaşım Oluştur",
  "copy.8b4578a65b94": "Kaynağın sende kalır. Seçilen alanlar, erişim bitene kadar güncel haliyle paylaşılır.",
  "copy.34e4475ca31b": "Canlı paylaşım oluşturuldu.",
  "copy.e0ef8264cc9f": "Paylaşılacak tür",
  "copy.e14ef28e6b51": "Paylaşım kapsamı",
  "copy.d172963b8c03": "Tek kayıt",
  "copy.6e4749c7632c": "Seçilen kayıtlar",
  "copy.649dbcd38c47": "Bir tablo",
  "copy.6a634a619f03": "Bir yaşam alanı",
  "copy.5786dca239b5": "Görünür alanlar",
  "copy.cc64312788d5": "Seçilen alanların düzenlenmesine izin ver",
  "copy.d47fb074c3b5": "Kayıt tarih ve saatlerini de göster",
  "copy.9a2a6a1d5448": "Gelecekte oluşturulacak kayıtları da paylaş",
  "copy.05bc45cfb40e": "Özel verilerimden hesaplanan sonuçların bu paylaşıma yazılmasına ayrıca izin ver",
  "copy.53c00d95d282": "kaynak ·",
  "copy.a0aa70146433": "görünür alan ·",
  "copy.459743052b3f": "Görüntüleme ve düzenleme",
  "copy.06f510148a5a": "Yalnız görüntüleme",
  "copy.6fff1249112c": ". Erişimi dilediğinde iptal edebilirsin.",
  "copy.e901677380a2": "Seçilen Alanları Paylaş",
  "copy.e151b3eba900": "Tablo ve alanları",
  "copy.5c0cdd57ae69": "Yayımlanmış alanları seçmek için bir tablo seç.",
  "copy.a6bae99be6a1": "Kaynaklar yüklenemedi. Alan veya tabloyu yeniden seçebilirsin.",
  "copy.c64e213dadaf": "Paylaşımlar",
  "copy.2c6f2721b83b": "Benimle Paylaşılanlar",
  "copy.fbe321d799e3": "Paylaştıklarım",
  "copy.f82639d3e1ef": "Paylaşımlar yüklenemedi veya erişim değişti.",
  "copy.10e9dc59c4b1": "Bu listede paylaşım yok",
  "copy.2cd1c2657961": "Erişim iptal edildi",
  "copy.cad7966fb650": "{{value1}} görünür alan · {{value2}}",
  "copy.267bd110ff42": "Düzenlenebilir",
  "copy.ec6eb0960edf": "Görüntüleme",
  "copy.4b808287d627": "Erişimi İptal Et",
  "copy.21ae9a0a2082": "Bu paylaşımda",
  "copy.5b5d67171211": "alan seçildi. Alanlar:",
  "copy.e0acb4d14692": "Yeni kayıtlar dahil.",
  "copy.7328030d8a94": "Yeni kayıtlar otomatik eklenmez.",
  "copy.4460e10d21af": "Özel verilerden hesaplanan çıktılara ayrıca izin verdin.",
  "copy.d1addec0cc28": "Özel verilerden hesaplanan çıktılara izin verilmedi.",
  "copy.eb04e999aa74": "İncelemek için bir paylaşım seç.",
  "copy.79efbbcfbb65": "Daha Fazla Paylaşım",
  "copy.eec5f80ad665": "Paylaşım artık kullanılamıyor. Gizli alanlar gösterilmez.",
  "copy.7d560bdc3279": "Görünür kayıt yok",
  "copy.59d91b0a1e93": "Daha Fazla Paylaşılan Kayıt",
  "copy.69a6fed4edb2": "Güncel Kaydı Yükle",
  "copy.90970be0fae5": "Paylaşılan Yaşam Kaydı",
  "copy.aa20a4eac88d": "Değişikliğin kaydedildi · sürüm {{value1}}",
  "copy.ec4224650e2a": " ({{value1}})",
  "copy.8f331b53de89": " — {{value1}}",
  "copy.9a1b49340a04": "Görünür Alanları Düzenle",
  "copy.6f7d17742cbd": "Paylaşım erişimi sona erdi.",
  "copy.7074f1ed7f11": "Her seçeneği ayrı satıra yaz.",
  "copy.85ae77c7c7c7": "Yalnız kendi değişikliğinin kaydı döner. Kaynak sahibinin özel kuralları ve sonuçları paylaşılmaz.",
  "copy.50be7607bf65": "Kaynak veya paylaşım kullanılamıyor.",
  "copy.621156a998c9": "Paylaşılan",
  "copy.6640372dab0f": "Ortak Alan",
  "copy.051fdb634371": "Paylaşılan kayıtların yerleşimi. Kayıtların kendi proje ve bağlantıları korunur.",
  "copy.90adee1fa376": "Alana eklenecek paylaşım",
  "copy.69bbfa6b40da": "Paylaşım seç",
  "copy.39290b866133": "Paylaşılan kayıt",
  "copy.87dfc4e1c5b9": "Kayıt ·",
  "copy.366a747c901a": "Ortak Alana Ekle",
  "copy.d7ad06454fe3": "Alandan Çıkar",
  "copy.bb6b3fcc87f6": "Paylaşımlar bölümünden açabilirsin",
  "copy.451f149c1b5a": "Daha Fazla Yerleşim",
  "copy.de4bf796d637": "Daha Fazla Paylaşım Seçeneği",
  "copy.6f400a971e79": "Paylaşılan yaşam alanı",
  "copy.06c2353ad761": "Paylaşılan alandaki tablo",
  "copy.11b1cf1ddb67": "Paylaşılan tablo",
  "copy.010d33a7306a": "Paylaşılacak Yaşam kaydı",
  "copy.88f9e251a135": "Kayıtlar yüklenemedi.",
  "copy.08d693f840e3": "Arkadaşlıklarını, açıkça paylaştığın kayıtları ve müsaitliğini yönet.",
  "copy.1880195e390e": "Sosyal bölümleri",
  "copy.de675304418f": "Arkadaşlar",
  "copy.ff9817183890": "Not Kopyaları",
  "copy.34f2295bb9b6": "Müsaitlik",
  "copy.3f83fb55cde5": "Arkadaşlıkların yüklenemedi.",
  "copy.995b91a50ceb": "Paylaşım Formunu Kapat",
  "copy.0255d737df24": "Yeni Canlı Paylaşım",
  "copy.2db0c4bd1de1": "Ortak alan için bir arkadaş seç",
  "copy.7a6d41df984b": "Daha Fazla Arkadaşlık",
  "copy.12ed1ebecf00": "Özel Davet",
  "copy.3918b5e16cf9": "Hesap araması yoktur. Kodu yalnız bağlantı kurmak istediğin kişiyle paylaş.",
  "copy.08a06f684acf": "Davet Kodu Oluştur",
  "copy.8c8ee9e55708": "Davet kodun",
  "copy.35eb5cc99c9b": "Son kullanım:",
  "copy.20fcfdd75945": "Davet kodu kopyalandı.",
  "copy.ba07b97ecf0c": "Kodu seçerek kopyalayabilirsin.",
  "copy.c14e7316845a": "Kodu Kopyala",
  "copy.72ed0a55f01f": "Arkadaşlık isteği gönderildi.",
  "copy.1115c6e28f05": "Aldığın davet kodu",
  "copy.00090b4b0cbf": "Arkadaşlık İsteği Gönder",
  "copy.1046092e9e0f": "Arkadaşlıkların",
  "copy.c4b3563b59f7": "Arkadaşlık tek başına özel verilerini açmaz.",
  "copy.75a3ddfde60f": "Henüz arkadaşlık yok",
  "copy.67df3cc43e58": "Kabul Et",
  "copy.fd78c713b1a0": "Reddet",
  "copy.1ee9f680f738": "İsteği Geri Çek",
  "copy.cebeafe79e70": "Arkadaşlığı Bitir",
  "copy.42d863f01216": "Engelle",
  "copy.d219dde1fadf": "Bitirme veya engelleme, canlı paylaşımları ve müsaitlik erişimini kapatır. Kabul edilmiş not kopyaları alıcıda kalır.",
  "copy.52de0ec377af": "Bağımsız Not Kopyası Öner",
  "copy.1d7cfbda3d39": "Alıcı kabul ederse kendi notuna sahip olur. Sonraki değişiklikler eşitlenmez; kabul edilen kopyayı geri alamazsın.",
  "copy.f5cc7afb221f": "Not Kopyası Öner",
  "copy.ed0907f679e1": "Kopya Teklifleri",
  "copy.2737ad09599d": "Sana önerilen kopya",
  "copy.6db1b5040eaa": "Gönderdiğin kopya",
  "copy.1caa73c4aad6": "İçeriği İncele",
  "copy.8d6d07623105": "Teklifi İptal Et",
  "copy.a0e6440d040b": "Kendi Notunu Aç",
  "copy.95e5d7f36ba5": "Kopya teklifi yok",
  "copy.b8be4f967f78": "Daha Fazla Teklif",
  "copy.3ac8451d04a3": "Kopya teklifi artık kullanılamıyor.",
  "copy.3df93ebabe2a": "Not kopyası önizlemesi",
  "copy.ecaa5be87e41": "Kabul ettiğinde bu içeriğin bağımsız kopyası senin notlarına eklenir. Canlı paylaşım oluşturulmaz.",
  "copy.27c4009b94c4": "Kendi Notlarıma Kopyala",
  "copy.ba81b4ffe354": "Kopyayı Reddet",
  "copy.de5b45f3d079": "Önizlemeyi Kapat",
  "copy.e70bb6a2fb7b": "Müsait",
  "copy.c1846c73bd74": "Meşgul",
  "copy.41cdcbb9457d": "Uzakta",
  "copy.703df33c4c0c": "Kendi Müsaitliğin",
  "copy.678d2ecc733b": "Genel tercihin tüm kabul edilmiş arkadaşlıklarda kullanılır. Bir arkadaş için kaydetmek ona özel tercih oluşturur.",
  "copy.38faf42183e9": "Tercihin kapsamı",
  "copy.9e6888728499": "Tüm arkadaşlar için genel tercih",
  "copy.7ae5de664c2b": "Arkadaşının Müsaitliği",
  "copy.49451f45f178": "Yalnız arkadaşının açıkça bildirdiği durum ve izin verdiği zaman aralıkları görünür.",
  "copy.4ac8ab998cc8": "Başlangıç günü",
  "copy.c3c51b8639a8": "Bitiş günü",
  "copy.d925897cad40": "Müsaitliği Gör",
  "copy.be50271dfabf": "En fazla 31 gün. Takvimden yalnız serbest/meşgul zamanları gelir; başlıklar ve kayıt içerikleri görünmez.",
  "copy.7da744c981c8": "Müsaitlik paylaşılmıyor",
  "copy.7b6988b293b9": "Tüm aralıklar sığmadı. Daha kısa bir tarih aralığı seç.",
  "copy.a3e2bcca6678": "Müsaitlik tercihin kaydedildi.",
  "copy.b43347d5e002": "Müsaitliğimi paylaş",
  "copy.274b37543154": "Bildirdiğin durum",
  "copy.0925c172b610": "Takvimimdeki serbest/meşgul aralıklarını da paylaş",
  "copy.fb5b81150d56": "Takvim başlıkları paylaşılmaz. Takvime yerleştirilmemiş görevlerden meşgullük çıkarılmaz.",
  "copy.193e2a8dbc3e": "Bildirdiğin zaman aralıkları",
  "copy.bfbd5bfe3428": "Aralık başlangıcı",
  "copy.ea6902e15c44": "Aralık bitişi",
  "copy.ef48306b0c11": "Aralığı Kaldır",
  "copy.8a99fb2f0d81": "Zaman Aralığı Ekle",
  "copy.337b3d71f975": "Başlangıç ve bitişi sırayla seç; her aralık en fazla 31 gün olabilir.",
  "copy.2a4db7772763": "Müsaitliği Kaydet",
  "copy.404e9b3089ed": "Yanıt bekliyor",
  "copy.294b4baa9952": "Kabul edildi",
  "copy.c028f549f351": "Geri çekildi",
  "copy.b3629ca82080": "Kapandı",
  "copy.9042c04fab94": "Yaşam tablosu görünümü",
  "copy.1508ac959d13": "Göstergeler",
  "copy.9cc4262aecb2": "Kurallar",
  "copy.1d4b6cc8a1db": "Düzeni Önizle",
  "copy.3e4e27ae96d2": "Düzeni Kaydet",
  "copy.34fc129cb86d": "Konumlar henüz kaydedilmedi.",
  "copy.9d9beea930b8": "Bazı bağlantılar yüklenemedi.",
  "copy.e4eb74dc7900": "Bağlantı görünümü sınırlı. Seçili bilginin Bağlantılar panelinden ayrıntıları açabilirsin.",
  "copy.81655e4824dd": "Bu kayıt önceki bir tablo tanımıyla kaydedilmiş. Türü, birimi veya para birimi değişen alanların eski değerleri forma taşınmadı; güncel anlamıyla yeniden gir. Kaydedince önceki değerleri kayıt geçmişinde bulabilirsin.",
  "copy.7a1889e11ef6": "Kalıcı bildirim kutusunu aç",
  "extensions.workspace.description": "İlgi alanlarını tek çalışma alanında buluştur. Bir uygulama seç, Yaşam verilerini bağla ve kaldığın yerden devam et.",
  "extensions.hub.musicDescription": "Repertuvarını oluştur, pratiklerini kaydet ve enstrüman hedeflerini takip et.",
  "extensions.hub.lessonsDescription": "Derslerini, oturum notlarını, transkriptleri ve sonraki görevlerini bir arada tut.",
  "extensions.hub.cyclingDescription": "Sürüşlerini kaydet, mesafe ve süreyi incele, haftalık bisiklet hedefini belirle.",
  "extensions.hub.devicesDescription": "Cihazlarını bağla, veri izinlerini yönet ve kaydedilen özetleri incele.",
  "extensions.hub.socialDescription": "Davetler, ortak alanlar ve açıkça seçtiğin erişim izinleriyle bağlantıda kal.",
  "extensions.hub.preferencesDescription": "Uygulamalarının kullandığı Yaşam alanlarını, veri görünümlerini ve varsayılanları seç.",
  "extensions.hub.lifeData": "Yaşam verileri",
  "extensions.hub.catalogCount": "Kullanılabilir uygulama",
  "extensions.hub.active": "Etkin",
  "extensions.hub.paused": "Duraklatılmış",
  "extensions.hub.search": "Uygulama ara",
  "extensions.hub.filter": "Uygulamaları filtrele",
  "extensions.hub.all": "Tüm uygulamalar",
  "extensions.hub.available": "Keşfet",
  "extensions.hub.unavailable": "Kullanılamıyor",
  "extensions.hub.notInstalled": "Kurulu değil",
  "extensions.hub.empty": "Bu görünümde uygulama bulunamadı",
  "extensions.hub.emptyDescription": "Başka bir arama dene veya tüm uygulamaları göster.",
  "extensions.hub.reset": "Tüm uygulamaları göster",
  "extensions.hub.dataNote": "Kurulumdan önce her uygulamanın izinlerini sen seçersin. Uygulama kaldırıldığında Yaşam tabloların, kayıtların ve bağımsız notların sende kalır.",
  "apps.workspace.lede": "Yaşam kayıtlarını, kayıtlı görünümlerini ve grafiklerini kendi sayfalarında bir araya getir.",
  "apps.workspace.mode": "Uygulama görünümü",
  "apps.workspace.open": "Uygulamalarım",
  "apps.workspace.edit": "Düzeni düzenle",
  "apps.workspace.empty": "Hayatına göre şekillenen bir alan",
  "apps.workspace.emptyHint": "Bir uygulama oluştur, sayfa ekle ve mevcut Yaşam tablolarını, görünümlerini, grafiklerini veya kayıt formlarını bağla.",
  "apps.workspace.create": "Uygulama oluştur",
  "apps.workspace.applications": "Kayıtlı uygulamalar",
  "apps.workspace.pageCount": "Sayfa: {{count}}",
  "apps.workspace.configure": "Sayfaları düzenle",
  "apps.workspace.pages": "Uygulama sayfaları",
  "apps.workspace.noSections": "Bu sayfa ilk bölümü için hazır",
  "apps.workspace.noSectionsHint": "Yaşam içeriği eklemek için Sayfaları düzenle'yi kullan.",
  "apps.workspace.sourceUnavailable": "Bu veri kaynağı kullanılamıyor",
  "apps.workspace.sourceUnavailableHint": "Kaydettiğin düzen korunuyor. Düzeni düzenle bölümünden kullanılabilir bir kaynak seç.",
  "apps.workspace.noPages": "İlk sayfanı ekle",
  "apps.workspace.loadError": "Veri kaynağı yüklenemedi. Yeniden dene veya Düzeni düzenle bölümünden bağlantısını kontrol et.",
  "apps.workspace.formHint": "Güncel alanları ve doğrulama kurallarıyla {{title}} tablosuna kayıt ekle.",
  "apps.workspace.addRecord": "Kayıt ekle",
  "apps.workspace.recordSaved": "Kaydın Yaşam'a eklendi ve bağlı görünümlerde kullanılabilir.",
  "apps.workspace.recordCount": "Kayıt: {{count}}",
  "apps.workspace.noRecords": "Bu görünümde henüz kayıt yok",
  "apps.workspace.openRecord": "Kaydı aç",
  "apps.workspace.moreRecords": "Daha fazla kayıt yükle",
  "apps.music.goals": "Hedefler",
  "apps.music.profile": "Profil",
  "apps.social.rejected": "Reddedildi",
  "life.workspace.metrics": "Göstergeler",
  "life.workspace.rules": "Kurallar",
  "life.tools.metricsIntro": "Yaşam kayıtlarından göstergeler, grafikler ve bütçe görünümleri oluştur. Başlamak için bir kaynak seç.",
  "life.tools.rulesIntro": "Kayıtların ve hedeflerin için işlemler tanımla. Her kuralı önizle, izinlerini onayla ve çalışma geçmişini buradan izle.",
  "life.tools.manageAreas": "Yaşam alanları",
  "life.tools.areasError": "Yaşam alanları yüklenemedi",
  "life.tools.startTitle": "Bir yaşam alanıyla başla",
  "life.tools.startMetrics": "Bir alan ve kayıt tablosu oluştur; ardından kendi verilerinle göstergeler ve grafikler hazırla.",
  "life.tools.startRules": "Bir alan ve kayıt tablosu oluştur; ardından değişikliklerde, belirli aralıklarla veya elle çalışacak kurallar ekle.",
  "life.tools.createArea": "İlk alanını oluştur",
  "life.tools.source": "Kaynağını seç",
  "life.tools.area": "Yaşam alanı",
  "life.tools.schema": "Kayıt tablosu",
  "life.tools.chooseSchema": "Bir tablo seç",
  "life.tools.schemasError": "Kayıt tabloları yüklenemedi",
  "life.tools.noSchema": "Bu alanda henüz kayıt tablosu yok",
  "life.tools.noSchemaHint": "Takip etmek istediğin bilgiler için alanı açıp bir tablo oluştur.",
  "life.tools.openArea": "Alanı aç",
  "life.tools.metricContext": "Göstergeler ve görünümler bu tabloyu kullanır. Hedef değerlerini bir parametreden veya başka bir yaşam kaydından da alabilirsin.",
  "life.tools.ruleContext": "Yeni olay kuralları bu tabloyu kullanır. Zamanlanmış ve elle çalıştırılan kurallar da burada görünür.",
  "life.tools.openRecords": "Kayıtlar ve geçmiş",
  "life.recordPicker.search": "Kayıt bul",
  "life.recordPicker.searchHint": "Kayıt içeriğinde ara",
  "life.recordPicker.loading": "Kayıtlar yükleniyor…",
  "life.recordPicker.choose": "Bir kayıt seç",
  "life.recordPicker.saved": "Önceden seçilen kayıt",
  "life.recordPicker.untitled": "Başlıksız kayıt",
  "life.recordPicker.empty": "Seçilen tabloda bu aramaya uygun kayıt yok.",
  "life.recordPicker.error": "Kayıtlar yüklenemedi",
  "life.recordPicker.savedUnavailable": "Seçilen kayıt kullanılamıyor. Kaydetmeden önce başka bir kayıt seç.",
  "life.recordPicker.more": "Daha fazla kayıt yükle",
  "life.target.area": "Hedef alanı",
  "life.target.schema": "Hedef tablosu",
  "life.target.record": "Hedef kaydı",
  "life.target.chooseField": "Sayısal bir alan seç",
  "life.target.updateRecord": "Güncellenecek kayıt",
  "life.metrics.unavailableDisplays": "Etkin kaynağı bulunmayan görünümler",
  "life.metrics.unavailableHint": "Bu görünümlerin göstergeleri etkin kaynak listesinde bulunmuyor. Görünümleri buradan arşivleyebilirsin.",
  "life.metrics.unavailableError": "Diğer görünümlerin kaynakları kontrol edilemedi",
  "security.totp.scan_instruction": "Bu QR kodunu kimlik doğrulama uygulamanla tara, ardından uygulamanın gösterdiği altı haneli kodu gir.",
  "security.totp.manual_secret": "Tarayamıyor musun? Bu kurulum anahtarını elle gir",
  "security.totp.qr_alt": "Exognitos'u kimlik doğrulama uygulamasına eklemek için QR kodu",
  "security.totp.qr_failed": "QR kodu oluşturulamadı. Aşağıdaki kurulum anahtarını elle kullan.",
  "security.totp.login_hint": "Altı haneli kimlik doğrulama kodunu veya on karakterli kurtarma kodlarından birini gir. Bu giriş denemesi {{time}} tarihinde sona erer.",
  "security.totp.recovery_title": "Kurtarma kodlarını kaydet",
  "security.totp.recovery_description": "Kimlik doğrulama uygulamana erişemediğinde her kodla bir kez giriş yapabilirsin. Kodları özel ve bu cihazdan ayrı bir yerde sakla.",
  "security.totp.recovery_once": "Güvenliğin için bu paneli kapattıktan sonra Exognitos bu kodları yeniden gösteremez.",
  "security.totp.copy_recovery": "Tüm kodları kopyala",
  "security.totp.download_recovery": ".txt indir",
  "security.totp.recovery_copied": "Kurtarma kodları kopyalandı",
  "security.totp.recovery_saved_confirmation": "Bu kurtarma kodlarını güvenli bir yere kaydettim",
  "security.totp.recovery_done": "Kurulumu tamamla",
  "security.totp.recovery_count": "{{count}} kurtarma kodu kaldı",
  "security.totp.recovery_count_loading": "Kurtarma kodları kontrol ediliyor…",
  "security.totp.regenerate": "Kurtarma kodlarını değiştir",
  "security.totp.regenerate_title": "Tüm kurtarma kodları değiştirilsin mi?",
  "security.totp.regenerate_description": "Mevcut kurtarma kodlarının tamamı hemen geçersiz olur. Yeni kodlar yalnızca bir kez gösterilir.",
  "security.totp.regenerated": "Yeni kurtarma kodları oluşturuldu",
  "security.totp.regenerate_failed": "Kurtarma kodları değiştirilemedi",
  "security.totp.recovery_file_intro": "Exognitos iki adımlı doğrulama kurtarma kodları — her kod yalnızca bir kez kullanılabilir. Bu dosyayı gizli tut.",
  "shortcuts.title": "Klavye kısayolları",
  "shortcuts.description": "Bir iletişim kutusu veya panel açıkken genel kısayollar duraklatılır; böylece yazarken arkadaki bir işlem tetiklenmez.",
  "shortcuts.group.global": "Her yerde",
  "shortcuts.group.capture": "Hızlı Yakala",
  "shortcuts.group.review": "Yeniden keşfet incelemesi",
  "shortcuts.search": "Ara, komut çalıştır veya bir yere git",
  "shortcuts.capture": "Hızlı Yakala'yı aç",
  "shortcuts.capture_simple": "Yazmıyorken Hızlı Yakala'yı aç",
  "shortcuts.reference": "Bu kısayol rehberini aç",
  "shortcuts.close_layer": "Etkin iletişim kutusunu veya paneli kapat",
  "shortcuts.single_save": "Tek bir düşünceyi kaydet",
  "shortcuts.dump_save": "Çok satırlı zihin dökümünü kaydet",
  "shortcuts.review_previous": "Önceki inceleme kartı",
  "shortcuts.review_next": "Sonraki inceleme kartı",
  "connectivity.offline_title": "Bağlantı kesildi.",
  "connectivity.offline_description": "Canlı bilgiler yenilenemez. Gönderilmemiş değişiklikler ekranda kalır ancak kuyruğa alınmaz; bu sekmeyi kapatmadan önce yeniden bağlan.",
  "offline.enabled_description": "Canlı bilgiler yenilenemez. Hızlı Yakalamalar bu cihazda şifrelenir ve yeniden bağlandığında gönderilir.",
  "offline.capture_saved_title": "Yakalama bu cihaza kaydedildi",
  "offline.capture_saved_description": "Şifreli olarak saklanıyor; oturumun açık ve bağlantın hazır olduğunda gönderilecek.",
  "offline.capture_failed_title": "Bu yakalama çevrimdışı kaydedilemedi",
  "offline.capture_failed_description": "Pencereyi kapatmadan önce açık tut ve metni kopyala.",
  "offline.replaying_title": "Kaydedilmiş {{count}} yakalama gönderiliyor.",
  "offline.replaying_description": "Her yakalama özgün yeniden deneme kimliğini korur; yeniden bağlanmak kopya kayıt oluşturmaz.",
  "offline.review_title": "{{count}} çevrimdışı yakalamanın incelenmesi gerekiyor.",
  "offline.review_description": "Sunucu bu taslakları reddetti ya da şifreli verileri doğrulanamadı.",
  "offline.review_action": "Taslakları incele",
  "offline.review_dialog_title": "Çevrimdışı yakalamaları incele",
  "offline.review_dialog_description": "Metnin yalnızca bu hesaba bağlı incelemeyi açtığında çözülür. Her taslağı yeniden dene ya da açıkça sil.",
  "offline.review_empty": "İncelenecek çevrimdışı taslak yok.",
  "offline.corrupted_body": "Bu şifreli taslak hasarlı ve güvenli biçimde gösterilemiyor.",
  "offline.retry_action": "Yeniden dene",
  "offline.discard_title": "Bu çevrimdışı taslak silinsin mi?",
  "offline.discard_description": "Şifreli yerel kopya kalıcı olarak kaldırılır. Sunucudaki hiçbir kayıt silinmez.",
  "offline.discard_action": "Taslağı sil",
  "offline.state.pending": "bekliyor",
  "offline.state.conflict": "çakışma",
  "offline.state.rejected": "reddedildi",
  "offline.state.corrupted": "hasarlı",
  "offline.update_title": "Bir Exognitos güncellemesi hazır.",
  "offline.update_description": "Bu çalışma alanını yeniden yüklemek güvenli olduğunda yenile. Kaydedilmemiş form metni sen seçene kadar ekranda kalır.",
  "offline.update_later": "Daha sonra",
  "offline.update_now": "Şimdi yenile",
  "offline.last_known_inbox": "Son bilinen: {{count}} işlenmemiş yakalama; {{time}} tarihinde kaydedildi. Salt okunur ve güncelliğini yitirmiş olabilir.",
  "offline.clear_title": "Bu cihazdaki çevrimdışı veriler",
  "offline.clear_description": "Bu hesaba ait şifreli son bilinen görünümü ve {{count}} kayıtlı yakalamayı kaldır.",
  "offline.clear_confirm_title": "Çevrimdışı veriler bu cihazdan temizlensin mi?",
  "offline.clear_confirm_description": "Bu hesabın şifreli yerel görünümleri ve bekleyen yakalamaları kalıcı olarak kaldırılır. Sunucu kayıtları silinmez.",
  "offline.clear_action": "Çevrimdışı verileri temizle",
  "offline.clear_success": "Çevrimdışı veriler bu cihazdan temizlendi.",
  "activity.title": "Etkinlik ve Güvenlik",
  "activity.lede": "Hesabının, bağlı asistanların ve güvenlik kimlik bilgilerinin nasıl kullanıldığını gör.",
  "activity.export": "CSV dışa aktar",
  "activity.filters.title": "Filtreler",
  "activity.filters.description": "Kayıt içeriklerini veya sırları göstermeden hesap verebilirlik izini daralt.",
  "activity.filters.clear": "Filtreleri temizle",
  "activity.filters.family": "Etkinlik",
  "activity.filters.outcome": "Sonuç",
  "activity.filters.actor": "İşlemi yapan",
  "activity.filters.entity": "Kayıt türü",
  "activity.filters.entity_placeholder": "Örneğin task",
  "activity.filters.from": "Başlangıç",
  "activity.filters.to": "Bitiş dahil",
  "activity.filters.suspicious": "Yalnızca şüpheli",
  "activity.filters.suspicious_hint": "Hatalar, retler ve engellenen erişimler",
  "activity.filters.all": "Tümü",
  "activity.events.title": "Hesap etkinlikleri",
  "activity.events.description": "Son güvenlik ve yetkilendirilmiş erişim etkinlikleri.",
  "activity.retention": "Etkinlikler {{count}} gün saklanır. Dışa aktarımlar burada gösterilen güvenli alanlarla sınırlıdır.",
  "activity.native_notice": "Bu güvenlik günlüğü birinci taraf tarayıcı oturumunu gerektirir. Görmek veya dışa aktarmak için Exognitos'u tarayıcıda aç.",
  "activity.error": "Etkinlik günlüğü yüklenemedi.",
  "activity.empty.title": "Etkinlik kaydı yok",
  "activity.empty.description": "Güvenlikle ilgili hesap etkinlikleri burada görünür.",
  "activity.empty.filtered": "Bu filtrelerle eşleşen etkinlik yok. Görünümü genişletmek için bir veya daha fazla filtreyi temizle.",
  "activity.more": "Daha eski etkinlikleri yükle",
  "activity.suspicious": "Şüpheli",
  "activity.request": "İstek {{id}}",
  "activity.entity.open": "{{kind}} kaydını aç · {{id}}",
  "activity.family.account": "Hesap",
  "activity.family.assistant": "Asistan",
  "activity.family.auth": "Oturum ve güvenlik",
  "activity.family.backup": "Yedekleme",
  "activity.family.data": "Veri",
  "activity.family.import": "İçe aktarma",
  "activity.family.integration": "Entegrasyonlar",
  "activity.family.life": "Yaşam kayıtları",
  "activity.family.mcp": "MCP",
  "activity.family.notifications": "Bildirimler",
  "activity.family.oauth": "OAuth",
  "activity.family.relations": "İlişkiler",
  "activity.family.settings": "Ayarlar",
  "activity.family.token": "API anahtarları",
  "activity.outcome.success": "Başarılı",
  "activity.outcome.failure": "Başarısız",
  "activity.outcome.denied": "Reddedildi",
  "activity.actor.human_web": "Sen · web",
  "activity.actor.human_mobile": "Sen · mobil",
  "activity.actor.human_desktop": "Sen · masaüstü",
  "activity.actor.api_token": "Kişisel API anahtarı",
  "activity.actor.oauth_client": "Bağlı asistan",
  "activity.actor.mcp": "MCP istemcisi",
  "activity.actor.import": "İçe aktarma veya geri yükleme",
  "activity.actor.system": "Exognitos sistemi",
  "activity.actor.tool": "Araç · {{name}}",
  "activity.action.auth_login": "Oturum açıldı",
  "activity.action.auth_login_failed": "Oturum açma başarısız",
  "activity.action.auth_logout": "Oturum kapatıldı",
  "activity.action.auth_register": "Hesap oluşturuldu",
  "activity.action.password_changed": "Parola değiştirildi",
  "activity.action.password_reset_requested": "Parola sıfırlama istendi",
  "activity.action.password_reset_completed": "Parola sıfırlandı",
  "activity.action.session_revoked": "Oturum iptal edildi",
  "activity.action.mfa_enrolled": "İki adımlı doğrulama etkinleştirildi",
  "activity.action.mfa_challenge_issued": "İki adımlı doğrulama istendi",
  "activity.action.mfa_verified": "İki adımlı doğrulama tamamlandı",
  "activity.action.mfa_disabled": "İki adımlı doğrulama kapatıldı",
  "activity.action.mfa_failed": "İki adımlı doğrulama başarısız",
  "activity.action.token_create": "Kişisel API anahtarı oluşturuldu",
  "activity.action.token_revoke": "Kişisel API anahtarı iptal edildi",
  "activity.action.oauth_authorize": "Asistan erişimi onaylandı",
  "activity.action.oauth_revoke": "Asistan erişimi iptal edildi",
  "activity.action.oauth_token_issued": "Asistan kimlik bilgisi verildi",
  "activity.action.oauth_denied": "Asistan erişimi reddedildi",
  "activity.action.mcp_tool_call": "MCP aracı kullanıldı",
  "activity.action.mcp_denied": "MCP aracı engellendi",
  "activity.action.mcp_batch": "MCP toplu işlemi uygulandı",
  "activity.action.life_mutation": "Yaşam kaydı değiştirildi",
  "activity.action.relations_mutation": "İlişki değiştirildi",
  "activity.action.notifications_mutation": "Bildirim değiştirildi",
  "activity.action.assistant_mutation": "Asistan ayarı değiştirildi",
  "activity.action.account_delete": "Hesap silme istendi",
  "activity.action.data_purge": "Veri kalıcı olarak silindi",
  "activity.action.data_bulk_command": "Toplu değişiklik uygulandı",
  "activity.action.backup_export": "Yedek dışa aktarıldı",
  "activity.action.backup_restore": "Yedek geri yüklendi",
  "activity.action.backup_inspect": "Yedek incelendi",
  "activity.action.import_run": "İçe aktarma tamamlandı",
  "activity.action.integration_connect": "Entegrasyon bağlandı",
  "activity.action.integration_disconnect": "Entegrasyon bağlantısı kesildi",
  "activity.action.security_setting_changed": "Güvenlik ayarı değiştirildi",
  "activity.action.saved_view_mutation": "Kayıtlı görünüm değiştirildi",
  "savedViews.actions": "Kayıtlı görünüm işlemleri",
  "savedViews.archive": "Görünümü arşivle",
  "savedViews.archived": "Kayıtlı görünüm arşivlendi",
  "savedViews.cancel": "Vazgeç",
  "savedViews.confirm": "Kaydet",
  "savedViews.dialog.create": "Bu görünümü kaydet",
  "savedViews.dialog.duplicate": "Kayıtlı görünümü çoğalt",
  "savedViews.dialog.rename": "Kayıtlı görünümü yeniden adlandır",
  "savedViews.duplicate": "Çoğalt",
  "savedViews.error.generic": "Kayıtlı görünüm değiştirilemedi.",
  "savedViews.error.invalidImport": "Bu koleksiyon için geçerli bir kayıtlı görünüm dosyası değil.",
  "savedViews.error.load": "Kayıtlı görünümler kullanılamıyor",
  "savedViews.error.migrationRequired": "Bu kayıtlı görünüm açılmadan önce taşınmalı.",
  "savedViews.error.unsupportedOnSurface": "Bu kayıtlı görünüm, ekranın güvenle gösteremediği seçenekler içeriyor.",
  "savedViews.export": "Dışa aktar",
  "savedViews.import": "Kayıtlı görünüm içe aktar",
  "savedViews.makeDefault": "Varsayılan yap",
  "savedViews.makePrivate": "Özel yap",
  "savedViews.makeShareable": "Paylaşmaya aç",
  "savedViews.name": "Görünüm adı",
  "savedViews.pin": "Sabitle",
  "savedViews.removeDefault": "Varsayılanı kaldır",
  "savedViews.rename": "Yeniden adlandır",
  "savedViews.save": "Görünümü kaydet",
  "savedViews.select": "Kayıtlı görünümler",
  "savedViews.shared.choose": "Paylaşılabilir kayıtlı görünümler",
  "savedViews.shared.copyName": "Paylaşılan görünüm kopyası",
  "savedViews.shared.definition": "Görünüm tanımı",
  "savedViews.shared.entity": "Kayıtlı görünüm",
  "savedViews.shared.noneEligible": "Erişim vermeden önce koleksiyonunda bir kayıtlı görünümü paylaşmaya açın.",
  "savedViews.shared.saveCopy": "Özel bir kopya kaydet",
  "savedViews.shared.summary": "{{filters}} filtre · {{columns}} sütun",
  "savedViews.shared.unavailable": "Bu paylaşılan görünüm artık kullanılamıyor.",
  "savedViews.surfaces.projects": "Projeler",
  "savedViews.surfaces.tasks": "Görevler",
  "savedViews.undo": "Geri al",
  "savedViews.unpin": "Sabitlemeyi kaldır",
  "savedViews.update": "Geçerli filtrelerle güncelle",
  "entity.detail.breadcrumbs": "Ayrıntı yolu",
  "entity.detail.context": "Bağlam",
  "entity.detail.metadata": "Ayrıntı bağlamı",
  "entity.detail.provenance": "Köken",
  "entity.detail.source": "Kaynak",
  "entity.detail.status": "Durum",
  "entity.detail.type": "Tür",
  "entity.lifecycle.actions": "Kayıt işlemleri",
  "entity.lifecycle.archive": "Arşivle",
  "entity.lifecycle.archived": "Arşivlendi",
  "entity.lifecycle.complete": "Hedefi tamamla",
  "entity.lifecycle.completed": "Tamamlandı",
  "entity.lifecycle.decision.closed": "Kapalı",
  "entity.lifecycle.decision.considering": "Değerlendiriliyor",
  "entity.lifecycle.decision.decided": "Kararlaştırıldı",
  "entity.lifecycle.decision.revisiting": "Yeniden değerlendiriliyor",
  "entity.lifecycle.error": "Kayıt değiştirilemedi. Tekrar deneyin.",
  "entity.lifecycle.open": "Açık",
  "entity.lifecycle.reopen": "Hedefi yeniden aç",
  "entity.lifecycle.reopened": "Hedef yeniden açıldı",
  "entity.lifecycle.unarchive": "Geri yükle",
  "entity.lifecycle.unarchived": "Geri yüklendi",
  "search.archived": "Arşivlenmiş",
  "search.match.content": "İçerikte eşleşti",
  "search.match.exactTitle": "Başlıkla tam eşleşme",
  "search.match.lexical": "Arama terimleri eşleşti",
  "search.match.titlePrefix": "Başlık sorguyla başlıyor",
  "search.match.titleSimilarity": "Benzer başlık",
  "notifications.actions.label": "{{title}} için hatırlatıcı işlemleri",
  "notifications.actions.acknowledge": "Gördüm",
  "notifications.actions.snooze10": "10 dk",
  "notifications.actions.snooze60": "1 saat",
  "notifications.actions.cancel": "İptal et",
  "notifications.actions.pending": "Hatırlatıcı güncelleniyor…",
  "notifications.actions.error": "Hatırlatıcı güncellenemedi. Tekrar dene.",
  "notifications.actions.success.acknowledge": "{{title}} görüldü olarak işaretlendi.",
  "notifications.actions.success.snooze10": "{{title}} 10 dakika ertelendi.",
  "notifications.actions.success.snooze60": "{{title}} 1 saat ertelendi.",
  "notifications.actions.success.cancel": "{{title}} iptal edildi.",
  "collection.selectRecord": "{{title}} kaydını seç",
  "collection.archiveSelected": "Seçilenleri arşivle",
  "collection.completeSelected": "Seçilenleri tamamla",
  "collection.reopenSelected": "Seçilenleri yeniden aç",
  "collection.pauseSelected": "Seçilenleri duraklat",
  "collection.resumeSelected": "Seçilenleri sürdür",
  "collection.tasksArchived": "{{count}} görev arşivlendi",
  "collection.tasksCompleted": "{{count}} görev tamamlandı",
  "collection.tasksReopened": "{{count}} görev yeniden açıldı",
  "collection.routinesArchived": "{{count}} rutin arşivlendi",
  "collection.routinesPaused": "{{count}} rutin duraklatıldı",
  "collection.routinesResumed": "{{count}} rutin sürdürüldü",
  "collection.notesArchived": "{{count}} not arşivlendi",
  "collection.projectsArchived": "{{count}} proje arşivlendi",
  "review.reason.snoozed": "Ertelendi"
}
